/**
 * Vietnam Administrative Division Data (2-level system from July 1, 2025)
 * Auto-generated from CAS API: https://production.cas.so/address-kit/
 * Effective Date: 2025-07-01
 * Generated at: 2025-11-15T14:22:11.917Z
 *
 * Total provinces: 34
 * Total communes: 3321
 */


const vietnamAddressData = [
  {
    "code": "01",
    "name": "Thành phố Hà Nội",
    "englishName": "",
    "administrativeLevel": "Thành phố Trung ương",
    "communes": [
      {
        "code": "00004",
        "name": "Phường Ba Đình",
        "englishName": ""
      },
      {
        "code": "00008",
        "name": "Phường Ngọc Hà",
        "englishName": "Lieu Giai Commune"
      },
      {
        "code": "00025",
        "name": "Phường Giảng Võ",
        "englishName": ""
      },
      {
        "code": "00070",
        "name": "Phường \nHoàn Kiếm",
        "englishName": ""
      },
      {
        "code": "00082",
        "name": "Phường Cửa Nam",
        "englishName": ""
      },
      {
        "code": "00091",
        "name": "Phường Phú Thượng",
        "englishName": ""
      },
      {
        "code": "00097",
        "name": "Phường Hồng Hà",
        "englishName": ""
      },
      {
        "code": "00103",
        "name": "Phường Tây Hồ",
        "englishName": ""
      },
      {
        "code": "00118",
        "name": "Phường Bồ Đề",
        "englishName": ""
      },
      {
        "code": "00127",
        "name": "Phường Việt Hưng",
        "englishName": ""
      },
      {
        "code": "00136",
        "name": "Phường Phúc Lợi",
        "englishName": ""
      },
      {
        "code": "00145",
        "name": "Phường Long Biên",
        "englishName": ""
      },
      {
        "code": "00160",
        "name": "Phường Nghĩa Đô",
        "englishName": ""
      },
      {
        "code": "00166",
        "name": "Phường Cầu Giấy",
        "englishName": ""
      },
      {
        "code": "00175",
        "name": "Phường Yên Hòa",
        "englishName": ""
      },
      {
        "code": "00190",
        "name": "Phường Ô Chợ Dừa",
        "englishName": ""
      },
      {
        "code": "00199",
        "name": "Phường Láng",
        "englishName": ""
      },
      {
        "code": "00226",
        "name": "Phường Văn Miếu - Quốc Tử Giám",
        "englishName": ""
      },
      {
        "code": "00229",
        "name": "Phường Kim Liên",
        "englishName": ""
      },
      {
        "code": "00235",
        "name": "Phường Đống Đa",
        "englishName": ""
      },
      {
        "code": "00256",
        "name": "Phường Hai Bà Trưng",
        "englishName": ""
      },
      {
        "code": "00283",
        "name": "Phường Vĩnh Tuy",
        "englishName": ""
      },
      {
        "code": "00292",
        "name": "Phường Bạch Mai",
        "englishName": ""
      },
      {
        "code": "00301",
        "name": "Phường Vĩnh Hưng",
        "englishName": ""
      },
      {
        "code": "00316",
        "name": "Phường Định Công",
        "englishName": ""
      },
      {
        "code": "00322",
        "name": "Phường Tương Mai",
        "englishName": ""
      },
      {
        "code": "00328",
        "name": "Phường Lĩnh Nam",
        "englishName": ""
      },
      {
        "code": "00331",
        "name": "Phường Hoàng Mai",
        "englishName": ""
      },
      {
        "code": "00337",
        "name": "Phường Hoàng Liệt",
        "englishName": ""
      },
      {
        "code": "00340",
        "name": "Phường Yên Sở",
        "englishName": ""
      },
      {
        "code": "00352",
        "name": "Phường Phương Liệt",
        "englishName": ""
      },
      {
        "code": "00364",
        "name": "Phường Khương Đình",
        "englishName": ""
      },
      {
        "code": "00367",
        "name": "Phường Thanh Xuân",
        "englishName": ""
      },
      {
        "code": "00376",
        "name": "Xã Sóc Sơn",
        "englishName": ""
      },
      {
        "code": "00382",
        "name": "Xã Kim Anh",
        "englishName": ""
      },
      {
        "code": "00385",
        "name": "Xã Trung Giã",
        "englishName": ""
      },
      {
        "code": "00430",
        "name": "Xã Đa Phúc",
        "englishName": ""
      },
      {
        "code": "00433",
        "name": "Xã Nội Bài",
        "englishName": ""
      },
      {
        "code": "00454",
        "name": "Xã Đông Anh",
        "englishName": ""
      },
      {
        "code": "00466",
        "name": "Xã Phúc Thịnh",
        "englishName": ""
      },
      {
        "code": "00475",
        "name": "Xã Thư Lâm",
        "englishName": ""
      },
      {
        "code": "00493",
        "name": "Xã Thiên Lộc",
        "englishName": ""
      },
      {
        "code": "00508",
        "name": "Xã Vĩnh Thanh",
        "englishName": ""
      },
      {
        "code": "00541",
        "name": "Xã Phù Đổng",
        "englishName": ""
      },
      {
        "code": "00562",
        "name": "Xã Thuận An",
        "englishName": ""
      },
      {
        "code": "00565",
        "name": "Xã Gia Lâm",
        "englishName": "Trau Quy Commune"
      },
      {
        "code": "00577",
        "name": "Xã Bát Tràng",
        "englishName": ""
      },
      {
        "code": "00592",
        "name": "Phường Từ Liêm",
        "englishName": ""
      },
      {
        "code": "00598",
        "name": "Phường Thượng Cát",
        "englishName": ""
      },
      {
        "code": "00602",
        "name": "Phường Đông Ngạc",
        "englishName": ""
      },
      {
        "code": "00611",
        "name": "Phường Xuân Đỉnh",
        "englishName": ""
      },
      {
        "code": "00613",
        "name": "Phường Tây Tựu",
        "englishName": ""
      },
      {
        "code": "00619",
        "name": "Phường Phú Diễn",
        "englishName": ""
      },
      {
        "code": "00622",
        "name": "Phường Xuân Phương",
        "englishName": ""
      },
      {
        "code": "00634",
        "name": "Phường Tây Mỗ",
        "englishName": ""
      },
      {
        "code": "00637",
        "name": "Phường Đại Mỗ",
        "englishName": ""
      },
      {
        "code": "00640",
        "name": "Xã Thanh Trì",
        "englishName": ""
      },
      {
        "code": "00643",
        "name": "Phường Thanh Liệt",
        "englishName": ""
      },
      {
        "code": "00664",
        "name": "Xã Đại Thanh",
        "englishName": ""
      },
      {
        "code": "00679",
        "name": "Xã Ngọc Hồi",
        "englishName": ""
      },
      {
        "code": "00685",
        "name": "Xã Nam Phù",
        "englishName": ""
      },
      {
        "code": "04930",
        "name": "Xã Yên Xuân",
        "englishName": ""
      },
      {
        "code": "08974",
        "name": "Xã Quang Minh",
        "englishName": ""
      },
      {
        "code": "08980",
        "name": "Xã Yên Lãng",
        "englishName": ""
      },
      {
        "code": "08995",
        "name": "Xã Tiến Thắng",
        "englishName": ""
      },
      {
        "code": "09022",
        "name": "Xã Mê Linh",
        "englishName": ""
      },
      {
        "code": "09552",
        "name": "Phường Kiến Hưng",
        "englishName": ""
      },
      {
        "code": "09556",
        "name": "Phường Hà Đông",
        "englishName": ""
      },
      {
        "code": "09562",
        "name": "Phường Yên Nghĩa",
        "englishName": ""
      },
      {
        "code": "09568",
        "name": "Phường Phú Lương",
        "englishName": ""
      },
      {
        "code": "09574",
        "name": "Phường Sơn Tây",
        "englishName": ""
      },
      {
        "code": "09604",
        "name": "Phường Tùng Thiện",
        "englishName": ""
      },
      {
        "code": "09616",
        "name": "Xã Đoài Phương",
        "englishName": ""
      },
      {
        "code": "09619",
        "name": "Xã Quảng Oai",
        "englishName": ""
      },
      {
        "code": "09634",
        "name": "Xã Cổ Đô",
        "englishName": ""
      },
      {
        "code": "09661",
        "name": "Xã Minh Châu",
        "englishName": ""
      },
      {
        "code": "09664",
        "name": "Xã Vật Lại",
        "englishName": ""
      },
      {
        "code": "09676",
        "name": "Xã Bất Bạt",
        "englishName": ""
      },
      {
        "code": "09694",
        "name": "Xã Suối Hai",
        "englishName": ""
      },
      {
        "code": "09700",
        "name": "Xã Ba Vì",
        "englishName": ""
      },
      {
        "code": "09706",
        "name": "Xã Yên Bài",
        "englishName": ""
      },
      {
        "code": "09715",
        "name": "Xã Phúc Thọ",
        "englishName": ""
      },
      {
        "code": "09739",
        "name": "Xã Phúc Lộc",
        "englishName": ""
      },
      {
        "code": "09772",
        "name": "Xã Hát Môn",
        "englishName": ""
      },
      {
        "code": "09784",
        "name": "Xã Đan Phượng",
        "englishName": ""
      },
      {
        "code": "09787",
        "name": "Xã Liên Minh",
        "englishName": ""
      },
      {
        "code": "09817",
        "name": "Xã Ô Diên",
        "englishName": ""
      },
      {
        "code": "09832",
        "name": "Xã Hoài Đức",
        "englishName": ""
      },
      {
        "code": "09856",
        "name": "Xã Dương Hòa",
        "englishName": ""
      },
      {
        "code": "09871",
        "name": "Xã Sơn Đồng",
        "englishName": ""
      },
      {
        "code": "09877",
        "name": "Xã An Khánh",
        "englishName": ""
      },
      {
        "code": "09886",
        "name": "Phường Dương Nội",
        "englishName": ""
      },
      {
        "code": "09895",
        "name": "Xã Quốc Oai",
        "englishName": ""
      },
      {
        "code": "09910",
        "name": "Xã Kiều Phú",
        "englishName": ""
      },
      {
        "code": "09931",
        "name": "Xã Hưng Đạo",
        "englishName": ""
      },
      {
        "code": "09952",
        "name": "Xã Phú Cát",
        "englishName": ""
      },
      {
        "code": "09955",
        "name": "Xã Thạch Thất",
        "englishName": ""
      },
      {
        "code": "09982",
        "name": "Xã Hạ Bằng",
        "englishName": ""
      },
      {
        "code": "09988",
        "name": "Xã Hòa Lạc",
        "englishName": ""
      },
      {
        "code": "10003",
        "name": "Xã Tây Phương",
        "englishName": ""
      },
      {
        "code": "10015",
        "name": "Phường Chương Mỹ",
        "englishName": ""
      },
      {
        "code": "10030",
        "name": "Xã Phú Nghĩa",
        "englishName": ""
      },
      {
        "code": "10045",
        "name": "Xã Xuân Mai",
        "englishName": ""
      },
      {
        "code": "10072",
        "name": "Xã Quảng Bị",
        "englishName": ""
      },
      {
        "code": "10081",
        "name": "Xã Trần Phú",
        "englishName": ""
      },
      {
        "code": "10096",
        "name": "Xã Hòa Phú",
        "englishName": ""
      },
      {
        "code": "10114",
        "name": "Xã Thanh Oai",
        "englishName": ""
      },
      {
        "code": "10126",
        "name": "Xã Bình Minh",
        "englishName": ""
      },
      {
        "code": "10144",
        "name": "Xã Tam Hưng",
        "englishName": ""
      },
      {
        "code": "10180",
        "name": "Xã Dân Hòa",
        "englishName": ""
      },
      {
        "code": "10183",
        "name": "Xã Thường Tín",
        "englishName": ""
      },
      {
        "code": "10210",
        "name": "Xã Hồng Vân",
        "englishName": ""
      },
      {
        "code": "10231",
        "name": "Xã Thượng Phúc",
        "englishName": ""
      },
      {
        "code": "10237",
        "name": "Xã Chương Dương",
        "englishName": ""
      },
      {
        "code": "10273",
        "name": "Xã Phú Xuyên",
        "englishName": ""
      },
      {
        "code": "10279",
        "name": "Xã Phượng Dực",
        "englishName": ""
      },
      {
        "code": "10330",
        "name": "Xã Chuyên Mỹ",
        "englishName": ""
      },
      {
        "code": "10342",
        "name": "Xã Đại Xuyên",
        "englishName": ""
      },
      {
        "code": "10354",
        "name": "Xã Vân Đình",
        "englishName": ""
      },
      {
        "code": "10369",
        "name": "Xã Ứng Thiên",
        "englishName": ""
      },
      {
        "code": "10402",
        "name": "Xã Ứng Hòa",
        "englishName": ""
      },
      {
        "code": "10417",
        "name": "Xã Hòa Xá",
        "englishName": ""
      },
      {
        "code": "10441",
        "name": "Xã Mỹ Đức",
        "englishName": ""
      },
      {
        "code": "10459",
        "name": "Xã Phúc Sơn",
        "englishName": ""
      },
      {
        "code": "10465",
        "name": "Xã Hồng Sơn",
        "englishName": ""
      },
      {
        "code": "10489",
        "name": "Xã Hương Sơn",
        "englishName": ""
      }
    ]
  },
  {
    "code": "04",
    "name": "Tỉnh Cao Bằng",
    "englishName": "",
    "administrativeLevel": "Tỉnh",
    "communes": [
      {
        "code": "01273",
        "name": "Phường Thục Phán",
        "englishName": ""
      },
      {
        "code": "01279",
        "name": "Phường Nùng Trí Cao",
        "englishName": ""
      },
      {
        "code": "01288",
        "name": "Phường Tân Giang",
        "englishName": ""
      },
      {
        "code": "01290",
        "name": "Xã Bảo Lâm",
        "englishName": ""
      },
      {
        "code": "01294",
        "name": "Xã Lý Bôn",
        "englishName": ""
      },
      {
        "code": "01297",
        "name": "Xã Nam Quang",
        "englishName": ""
      },
      {
        "code": "01304",
        "name": "Xã Quảng Lâm",
        "englishName": "Thach Lam commune"
      },
      {
        "code": "01318",
        "name": "Xã Yên Thổ",
        "englishName": ""
      },
      {
        "code": "01321",
        "name": "Xã Bảo Lạc",
        "englishName": ""
      },
      {
        "code": "01324",
        "name": "Xã Cốc Pàng",
        "englishName": ""
      },
      {
        "code": "01327",
        "name": "Xã Cô Ba",
        "englishName": ""
      },
      {
        "code": "01336",
        "name": "Xã Khánh Xuân",
        "englishName": ""
      },
      {
        "code": "01339",
        "name": "Xã Xuân Trường",
        "englishName": ""
      },
      {
        "code": "01351",
        "name": "Xã Hưng Đạo",
        "englishName": ""
      },
      {
        "code": "01354",
        "name": "Xã Huy Giáp",
        "englishName": ""
      },
      {
        "code": "01360",
        "name": "Xã Sơn Lộ",
        "englishName": ""
      },
      {
        "code": "01363",
        "name": "Xã Thông Nông",
        "englishName": ""
      },
      {
        "code": "01366",
        "name": "Xã Cần Yên",
        "englishName": ""
      },
      {
        "code": "01387",
        "name": "Xã Thanh Long",
        "englishName": ""
      },
      {
        "code": "01392",
        "name": "Xã Trường Hà",
        "englishName": ""
      },
      {
        "code": "01393",
        "name": "Xã Lũng Nặm",
        "englishName": ""
      },
      {
        "code": "01414",
        "name": "Xã Tổng Cọt",
        "englishName": ""
      },
      {
        "code": "01438",
        "name": "Xã Hà Quảng",
        "englishName": ""
      },
      {
        "code": "01447",
        "name": "Xã Trà Lĩnh",
        "englishName": ""
      },
      {
        "code": "01456",
        "name": "Xã Quang Hán",
        "englishName": ""
      },
      {
        "code": "01465",
        "name": "Xã Quang Trung",
        "englishName": ""
      },
      {
        "code": "01477",
        "name": "Xã Trùng Khánh",
        "englishName": ""
      },
      {
        "code": "01489",
        "name": "Xã Đình Phong",
        "englishName": ""
      },
      {
        "code": "01501",
        "name": "Xã Đàm Thủy",
        "englishName": ""
      },
      {
        "code": "01525",
        "name": "Xã Đoài Dương",
        "englishName": ""
      },
      {
        "code": "01537",
        "name": "Xã Lý Quốc",
        "englishName": ""
      },
      {
        "code": "01552",
        "name": "Xã Quang Long",
        "englishName": ""
      },
      {
        "code": "01558",
        "name": "Xã Hạ Lang",
        "englishName": ""
      },
      {
        "code": "01561",
        "name": "Xã Vinh Quý",
        "englishName": ""
      },
      {
        "code": "01576",
        "name": "Xã Quảng Uyên",
        "englishName": ""
      },
      {
        "code": "01594",
        "name": "Xã Độc Lập",
        "englishName": ""
      },
      {
        "code": "01618",
        "name": "Xã Hạnh Phúc",
        "englishName": ""
      },
      {
        "code": "01636",
        "name": "Xã Bế Văn Đàn",
        "englishName": ""
      },
      {
        "code": "01648",
        "name": "Xã Phục Hòa",
        "englishName": ""
      },
      {
        "code": "01654",
        "name": "Xã Hòa An",
        "englishName": ""
      },
      {
        "code": "01660",
        "name": "Xã Nam Tuấn",
        "englishName": ""
      },
      {
        "code": "01699",
        "name": "Xã Nguyễn Huệ",
        "englishName": ""
      },
      {
        "code": "01708",
        "name": "Xã Bạch Đằng",
        "englishName": ""
      },
      {
        "code": "01726",
        "name": "Xã Nguyên Bình",
        "englishName": ""
      },
      {
        "code": "01729",
        "name": "Xã Tĩnh Túc",
        "englishName": ""
      },
      {
        "code": "01738",
        "name": "Xã Ca Thành",
        "englishName": ""
      },
      {
        "code": "01747",
        "name": "Xã Minh Tâm",
        "englishName": ""
      },
      {
        "code": "01768",
        "name": "Xã Phan Thanh",
        "englishName": ""
      },
      {
        "code": "01774",
        "name": "Xã Tam Kim",
        "englishName": ""
      },
      {
        "code": "01777",
        "name": "Xã Thành Công",
        "englishName": ""
      },
      {
        "code": "01786",
        "name": "Xã Đông Khê",
        "englishName": ""
      },
      {
        "code": "01789",
        "name": "Xã Canh Tân",
        "englishName": ""
      },
      {
        "code": "01792",
        "name": "Xã Kim Đồng",
        "englishName": ""
      },
      {
        "code": "01795",
        "name": "Xã Minh Khai",
        "englishName": ""
      },
      {
        "code": "01807",
        "name": "Xã Thạch An",
        "englishName": ""
      },
      {
        "code": "01822",
        "name": "Xã Đức Long",
        "englishName": ""
      }
    ]
  },
  {
    "code": "08",
    "name": "Tỉnh Tuyên Quang",
    "englishName": "",
    "administrativeLevel": "Tỉnh",
    "communes": [
      {
        "code": "00691",
        "name": "Phường Hà Giang 2",
        "englishName": ""
      },
      {
        "code": "00694",
        "name": "Phường Hà Giang 1",
        "englishName": ""
      },
      {
        "code": "00700",
        "name": "Xã Ngọc Đường",
        "englishName": ""
      },
      {
        "code": "00706",
        "name": "Xã Phú Linh",
        "englishName": ""
      },
      {
        "code": "00715",
        "name": "Xã Lũng Cú",
        "englishName": ""
      },
      {
        "code": "00721",
        "name": "Xã Đồng Văn",
        "englishName": ""
      },
      {
        "code": "00733",
        "name": "Xã Sà Phìn",
        "englishName": ""
      },
      {
        "code": "00745",
        "name": "Xã Phố Bảng",
        "englishName": ""
      },
      {
        "code": "00763",
        "name": "Xã Lũng Phìn",
        "englishName": ""
      },
      {
        "code": "00769",
        "name": "Xã Mèo Vạc",
        "englishName": ""
      },
      {
        "code": "00778",
        "name": "Xã Sơn Vĩ",
        "englishName": ""
      },
      {
        "code": "00787",
        "name": "Xã Sủng Máng",
        "englishName": ""
      },
      {
        "code": "00802",
        "name": "Xã Khâu Vai",
        "englishName": ""
      },
      {
        "code": "00808",
        "name": "Xã Tát Ngà",
        "englishName": ""
      },
      {
        "code": "00817",
        "name": "Xã Niêm Sơn",
        "englishName": ""
      },
      {
        "code": "00820",
        "name": "Xã Yên Minh",
        "englishName": ""
      },
      {
        "code": "00829",
        "name": "Xã Thắng Mố",
        "englishName": ""
      },
      {
        "code": "00832",
        "name": "Xã Bạch Đích",
        "englishName": ""
      },
      {
        "code": "00847",
        "name": "Xã Mậu Duệ",
        "englishName": ""
      },
      {
        "code": "00859",
        "name": "Xã Ngọc Long",
        "englishName": ""
      },
      {
        "code": "00865",
        "name": "Xã Đường Thượng",
        "englishName": ""
      },
      {
        "code": "00871",
        "name": "Xã Du Già",
        "englishName": ""
      },
      {
        "code": "00874",
        "name": "Xã Quản Bạ",
        "englishName": ""
      },
      {
        "code": "00883",
        "name": "Xã Cán Tỷ",
        "englishName": ""
      },
      {
        "code": "00889",
        "name": "Xã Nghĩa Thuận",
        "englishName": ""
      },
      {
        "code": "00892",
        "name": "Xã Tùng Vài",
        "englishName": ""
      },
      {
        "code": "00901",
        "name": "Xã Lùng Tám",
        "englishName": ""
      },
      {
        "code": "00913",
        "name": "Xã Vị Xuyên",
        "englishName": ""
      },
      {
        "code": "00919",
        "name": "Xã Minh Tân",
        "englishName": ""
      },
      {
        "code": "00922",
        "name": "Xã Thuận Hoà",
        "englishName": ""
      },
      {
        "code": "00925",
        "name": "Xã Tùng Bá",
        "englishName": ""
      },
      {
        "code": "00928",
        "name": "Xã Thanh Thủy",
        "englishName": ""
      },
      {
        "code": "00937",
        "name": "Xã Lao Chải",
        "englishName": ""
      },
      {
        "code": "00952",
        "name": "Xã Cao Bồ",
        "englishName": ""
      },
      {
        "code": "00958",
        "name": "Xã Thượng Sơn",
        "englishName": ""
      },
      {
        "code": "00967",
        "name": "Xã Việt Lâm",
        "englishName": ""
      },
      {
        "code": "00970",
        "name": "Xã Linh Hồ",
        "englishName": ""
      },
      {
        "code": "00976",
        "name": "Xã Bạch Ngọc",
        "englishName": ""
      },
      {
        "code": "00982",
        "name": "Xã Minh Sơn",
        "englishName": ""
      },
      {
        "code": "00985",
        "name": "Xã Giáp Trung",
        "englishName": ""
      },
      {
        "code": "00991",
        "name": "Xã Bắc Mê",
        "englishName": ""
      },
      {
        "code": "00994",
        "name": "Xã Minh Ngọc",
        "englishName": ""
      },
      {
        "code": "01006",
        "name": "Xã Yên Cường",
        "englishName": ""
      },
      {
        "code": "01012",
        "name": "Xã Đường Hồng",
        "englishName": ""
      },
      {
        "code": "01021",
        "name": "Xã Hoàng Su Phì",
        "englishName": ""
      },
      {
        "code": "01024",
        "name": "Xã Bản Máy",
        "englishName": ""
      },
      {
        "code": "01033",
        "name": "Xã Thàng Tín",
        "englishName": ""
      },
      {
        "code": "01051",
        "name": "Xã Tân Tiến",
        "englishName": ""
      },
      {
        "code": "01057",
        "name": "Xã Pờ Ly Ngài",
        "englishName": ""
      },
      {
        "code": "01075",
        "name": "Xã Nậm Dịch",
        "englishName": ""
      },
      {
        "code": "01084",
        "name": "Xã Hồ Thầu",
        "englishName": ""
      },
      {
        "code": "01090",
        "name": "Xã Thông Nguyên",
        "englishName": ""
      },
      {
        "code": "01096",
        "name": "Xã Pà Vầy Sủ",
        "englishName": ""
      },
      {
        "code": "01108",
        "name": "Xã Xín Mần",
        "englishName": ""
      },
      {
        "code": "01117",
        "name": "Xã Trung Thịnh",
        "englishName": ""
      },
      {
        "code": "01141",
        "name": "Xã Nấm Dẩn",
        "englishName": ""
      },
      {
        "code": "01144",
        "name": "Xã Quảng Nguyên",
        "englishName": ""
      },
      {
        "code": "01147",
        "name": "Xã Khuôn Lùng",
        "englishName": ""
      },
      {
        "code": "01153",
        "name": "Xã Bắc Quang",
        "englishName": ""
      },
      {
        "code": "01156",
        "name": "Xã Vĩnh Tuy",
        "englishName": ""
      },
      {
        "code": "01165",
        "name": "Xã Đồng Tâm",
        "englishName": ""
      },
      {
        "code": "01171",
        "name": "Xã Tân Quang",
        "englishName": ""
      },
      {
        "code": "01180",
        "name": "Xã Bằng Hành",
        "englishName": ""
      },
      {
        "code": "01192",
        "name": "Xã Liên Hiệp",
        "englishName": ""
      },
      {
        "code": "01201",
        "name": "Xã Hùng An",
        "englishName": ""
      },
      {
        "code": "01216",
        "name": "Xã Đồng Yên",
        "englishName": ""
      },
      {
        "code": "01225",
        "name": "Xã Tiên Nguyên",
        "englishName": ""
      },
      {
        "code": "01234",
        "name": "Xã Yên Thành",
        "englishName": ""
      },
      {
        "code": "01237",
        "name": "Xã Quang Bình",
        "englishName": ""
      },
      {
        "code": "01243",
        "name": "Xã Tân Trịnh",
        "englishName": ""
      },
      {
        "code": "01246",
        "name": "Xã Bằng Lang",
        "englishName": ""
      },
      {
        "code": "01255",
        "name": "Xã Xuân Giang",
        "englishName": ""
      },
      {
        "code": "01261",
        "name": "Xã Tiên Yên",
        "englishName": ""
      },
      {
        "code": "02212",
        "name": "Phường Nông Tiến",
        "englishName": ""
      },
      {
        "code": "02215",
        "name": "Phường Minh Xuân",
        "englishName": ""
      },
      {
        "code": "02221",
        "name": "Xã Nà Hang",
        "englishName": ""
      },
      {
        "code": "02239",
        "name": "Xã Thượng Nông",
        "englishName": ""
      },
      {
        "code": "02245",
        "name": "Xã Côn Lôn",
        "englishName": ""
      },
      {
        "code": "02248",
        "name": "Xã Yên Hoa",
        "englishName": ""
      },
      {
        "code": "02260",
        "name": "Xã Hồng Thái",
        "englishName": ""
      },
      {
        "code": "02266",
        "name": "Xã Lâm Bình",
        "englishName": ""
      },
      {
        "code": "02269",
        "name": "Xã Thượng Lâm",
        "englishName": ""
      },
      {
        "code": "02287",
        "name": "Xã Chiêm Hoá",
        "englishName": ""
      },
      {
        "code": "02296",
        "name": "Xã Bình An",
        "englishName": ""
      },
      {
        "code": "02302",
        "name": "Xã Minh Quang",
        "englishName": ""
      },
      {
        "code": "02305",
        "name": "Xã Trung Hà",
        "englishName": ""
      },
      {
        "code": "02308",
        "name": "Xã Tân Mỹ",
        "englishName": ""
      },
      {
        "code": "02317",
        "name": "Xã Yên Lập",
        "englishName": ""
      },
      {
        "code": "02320",
        "name": "Xã Tân An",
        "englishName": ""
      },
      {
        "code": "02332",
        "name": "Xã Kiên Đài",
        "englishName": ""
      },
      {
        "code": "02350",
        "name": "Xã Kim Bình",
        "englishName": ""
      },
      {
        "code": "02353",
        "name": "Xã Hoà An",
        "englishName": ""
      },
      {
        "code": "02359",
        "name": "Xã Tri Phú",
        "englishName": ""
      },
      {
        "code": "02365",
        "name": "Xã Yên Nguyên",
        "englishName": ""
      },
      {
        "code": "02374",
        "name": "Xã Hàm Yên",
        "englishName": ""
      },
      {
        "code": "02380",
        "name": "Xã Bạch Xa",
        "englishName": ""
      },
      {
        "code": "02392",
        "name": "Xã Phù Lưu",
        "englishName": ""
      },
      {
        "code": "02398",
        "name": "Xã Yên Phú",
        "englishName": ""
      },
      {
        "code": "02404",
        "name": "Xã Bình Xa",
        "englishName": ""
      },
      {
        "code": "02407",
        "name": "Xã Thái Sơn",
        "englishName": ""
      },
      {
        "code": "02419",
        "name": "Xã Thái Hoà",
        "englishName": ""
      },
      {
        "code": "02425",
        "name": "Xã Hùng Đức",
        "englishName": ""
      },
      {
        "code": "02434",
        "name": "Xã Lực Hành",
        "englishName": ""
      },
      {
        "code": "02437",
        "name": "Xã Kiến Thiết",
        "englishName": ""
      },
      {
        "code": "02449",
        "name": "Xã Xuân Vân",
        "englishName": ""
      },
      {
        "code": "02455",
        "name": "Xã Hùng Lợi",
        "englishName": ""
      },
      {
        "code": "02458",
        "name": "Xã Trung Sơn",
        "englishName": ""
      },
      {
        "code": "02470",
        "name": "Xã Tân Long",
        "englishName": ""
      },
      {
        "code": "02473",
        "name": "Xã Yên Sơn",
        "englishName": ""
      },
      {
        "code": "02494",
        "name": "Xã Thái Bình",
        "englishName": ""
      },
      {
        "code": "02509",
        "name": "Phường Mỹ Lâm",
        "englishName": ""
      },
      {
        "code": "02512",
        "name": "Phường An Tường",
        "englishName": ""
      },
      {
        "code": "02524",
        "name": "Phường Bình Thuận",
        "englishName": ""
      },
      {
        "code": "02530",
        "name": "Xã Nhữ Khê",
        "englishName": ""
      },
      {
        "code": "02536",
        "name": "Xã Sơn Dương",
        "englishName": ""
      },
      {
        "code": "02545",
        "name": "Xã Tân Trào",
        "englishName": ""
      },
      {
        "code": "02548",
        "name": "Xã Bình Ca",
        "englishName": ""
      },
      {
        "code": "02554",
        "name": "Xã Minh Thanh",
        "englishName": ""
      },
      {
        "code": "02572",
        "name": "Xã Đông Thọ",
        "englishName": ""
      },
      {
        "code": "02578",
        "name": "Xã Tân Thanh",
        "englishName": ""
      },
      {
        "code": "02608",
        "name": "Xã Hồng Sơn",
        "englishName": ""
      },
      {
        "code": "02611",
        "name": "Xã Phú Lương",
        "englishName": ""
      },
      {
        "code": "02620",
        "name": "Xã Sơn Thuỷ",
        "englishName": ""
      },
      {
        "code": "02623",
        "name": "Xã Trường Sinh",
        "englishName": ""
      }
    ]
  },
  {
    "code": "11",
    "name": "Tỉnh Điện Biên",
    "englishName": "",
    "administrativeLevel": "Tỉnh",
    "communes": [
      {
        "code": "03127",
        "name": "Phường Điện Biên Phủ",
        "englishName": ""
      },
      {
        "code": "03151",
        "name": "Phường Mường Lay",
        "englishName": ""
      },
      {
        "code": "03158",
        "name": "Xã Sín Thầu",
        "englishName": ""
      },
      {
        "code": "03160",
        "name": "Xã Mường Nhé",
        "englishName": ""
      },
      {
        "code": "03162",
        "name": "Xã Nậm Kè",
        "englishName": "Nam Ke commune"
      },
      {
        "code": "03163",
        "name": "Xã Mường Toong",
        "englishName": ""
      },
      {
        "code": "03164",
        "name": "Xã Quảng Lâm",
        "englishName": "Quang Lam Commune"
      },
      {
        "code": "03166",
        "name": "Xã Mường Chà",
        "englishName": ""
      },
      {
        "code": "03169",
        "name": "Xã Nà Hỳ",
        "englishName": ""
      },
      {
        "code": "03172",
        "name": "Xã Na Sang",
        "englishName": ""
      },
      {
        "code": "03175",
        "name": "Xã Chà Tở",
        "englishName": ""
      },
      {
        "code": "03176",
        "name": "Xã Nà Bủng",
        "englishName": ""
      },
      {
        "code": "03181",
        "name": "Xã Mường Tùng",
        "englishName": ""
      },
      {
        "code": "03193",
        "name": "Xã Pa Ham",
        "englishName": ""
      },
      {
        "code": "03194",
        "name": "Xã Nậm Nèn",
        "englishName": ""
      },
      {
        "code": "03199",
        "name": "Xã Si Pa Phìn",
        "englishName": ""
      },
      {
        "code": "03202",
        "name": "Xã Mường Pồn",
        "englishName": ""
      },
      {
        "code": "03203",
        "name": "Xã Na Son",
        "englishName": ""
      },
      {
        "code": "03208",
        "name": "Xã Xa Dung",
        "englishName": ""
      },
      {
        "code": "03214",
        "name": "Xã Mường Luân",
        "englishName": ""
      },
      {
        "code": "03217",
        "name": "Xã Tủa Chùa",
        "englishName": ""
      },
      {
        "code": "03220",
        "name": "Xã Tủa Thàng",
        "englishName": ""
      },
      {
        "code": "03226",
        "name": "Xã Sín Chải",
        "englishName": ""
      },
      {
        "code": "03241",
        "name": "Xã Sính Phình",
        "englishName": ""
      },
      {
        "code": "03244",
        "name": "Xã Sáng Nhè",
        "englishName": ""
      },
      {
        "code": "03253",
        "name": "Xã Tuần Giáo",
        "englishName": ""
      },
      {
        "code": "03256",
        "name": "Xã Mường Ảng",
        "englishName": ""
      },
      {
        "code": "03260",
        "name": "Xã Pú Nhung",
        "englishName": ""
      },
      {
        "code": "03268",
        "name": "Xã Mường Mùn",
        "englishName": ""
      },
      {
        "code": "03283",
        "name": "Xã Chiềng Sinh",
        "englishName": ""
      },
      {
        "code": "03295",
        "name": "Xã Quài Tở",
        "englishName": ""
      },
      {
        "code": "03301",
        "name": "Xã Búng Lao",
        "englishName": ""
      },
      {
        "code": "03313",
        "name": "Xã Mường Lạn",
        "englishName": ""
      },
      {
        "code": "03316",
        "name": "Xã Nà Tấu",
        "englishName": ""
      },
      {
        "code": "03325",
        "name": "Xã Mường Phăng",
        "englishName": ""
      },
      {
        "code": "03328",
        "name": "Xã Thanh Nưa",
        "englishName": ""
      },
      {
        "code": "03334",
        "name": "Phường Mường Thanh",
        "englishName": ""
      },
      {
        "code": "03349",
        "name": "Xã Thanh Yên",
        "englishName": ""
      },
      {
        "code": "03352",
        "name": "Xã Thanh An",
        "englishName": ""
      },
      {
        "code": "03356",
        "name": "Xã Sam Mứn",
        "englishName": ""
      },
      {
        "code": "03358",
        "name": "Xã Núa Ngam",
        "englishName": ""
      },
      {
        "code": "03368",
        "name": "Xã Mường Nhà",
        "englishName": ""
      },
      {
        "code": "03370",
        "name": "Xã Pu Nhi",
        "englishName": ""
      },
      {
        "code": "03382",
        "name": "Xã Phình Giàng",
        "englishName": ""
      },
      {
        "code": "03385",
        "name": "Xã Tìa Dình",
        "englishName": ""
      }
    ]
  },
  {
    "code": "12",
    "name": "Tỉnh Lai Châu",
    "englishName": "",
    "administrativeLevel": "Tỉnh",
    "communes": [
      {
        "code": "03388",
        "name": "Phường Đoàn Kết",
        "englishName": ""
      },
      {
        "code": "03390",
        "name": "Xã Bình Lư",
        "englishName": "Tam Đường town"
      },
      {
        "code": "03394",
        "name": "Xã Sin Suối Hồ",
        "englishName": ""
      },
      {
        "code": "03405",
        "name": "Xã Tả Lèng",
        "englishName": ""
      },
      {
        "code": "03408",
        "name": "Phường Tân Phong",
        "englishName": ""
      },
      {
        "code": "03424",
        "name": "Xã Bản Bo",
        "englishName": ""
      },
      {
        "code": "03430",
        "name": "Xã Khun Há",
        "englishName": ""
      },
      {
        "code": "03433",
        "name": "Xã Bum Tở",
        "englishName": ""
      },
      {
        "code": "03434",
        "name": "Xã Nậm Hàng",
        "englishName": ""
      },
      {
        "code": "03439",
        "name": "Xã Thu Lũm",
        "englishName": ""
      },
      {
        "code": "03442",
        "name": "Xã Pa Ủ",
        "englishName": ""
      },
      {
        "code": "03445",
        "name": "Xã Mường Tè",
        "englishName": ""
      },
      {
        "code": "03451",
        "name": "Xã Mù Cả",
        "englishName": ""
      },
      {
        "code": "03460",
        "name": "Xã Hua Bum",
        "englishName": ""
      },
      {
        "code": "03463",
        "name": "Xã Tà Tổng",
        "englishName": ""
      },
      {
        "code": "03466",
        "name": "Xã Bum Nưa",
        "englishName": ""
      },
      {
        "code": "03472",
        "name": "Xã Mường Mô",
        "englishName": ""
      },
      {
        "code": "03478",
        "name": "Xã Sìn Hồ",
        "englishName": ""
      },
      {
        "code": "03487",
        "name": "Xã Lê Lợi",
        "englishName": ""
      },
      {
        "code": "03503",
        "name": "Xã Pa Tần",
        "englishName": ""
      },
      {
        "code": "03508",
        "name": "Xã Hồng Thu",
        "englishName": ""
      },
      {
        "code": "03517",
        "name": "Xã Nậm Tăm",
        "englishName": ""
      },
      {
        "code": "03529",
        "name": "Xã Tủa Sín Chải",
        "englishName": ""
      },
      {
        "code": "03532",
        "name": "Xã Pu Sam Cáp",
        "englishName": ""
      },
      {
        "code": "03538",
        "name": "Xã Nậm Mạ",
        "englishName": ""
      },
      {
        "code": "03544",
        "name": "Xã Nậm Cuổi",
        "englishName": ""
      },
      {
        "code": "03549",
        "name": "Xã Phong Thổ",
        "englishName": "Phong Thổ town"
      },
      {
        "code": "03562",
        "name": "Xã Sì Lở Lầu",
        "englishName": ""
      },
      {
        "code": "03571",
        "name": "Xã Dào San",
        "englishName": ""
      },
      {
        "code": "03583",
        "name": "Xã Khổng Lào",
        "englishName": ""
      },
      {
        "code": "03595",
        "name": "Xã Than Uyên",
        "englishName": ""
      },
      {
        "code": "03598",
        "name": "Xã Tân Uyên",
        "englishName": ""
      },
      {
        "code": "03601",
        "name": "Xã Mường Khoa",
        "englishName": ""
      },
      {
        "code": "03613",
        "name": "Xã Nậm Sỏ",
        "englishName": ""
      },
      {
        "code": "03616",
        "name": "Xã Pắc Ta",
        "englishName": ""
      },
      {
        "code": "03618",
        "name": "Xã Mường Than",
        "englishName": ""
      },
      {
        "code": "03637",
        "name": "Xã Mường Kim",
        "englishName": ""
      },
      {
        "code": "03640",
        "name": "Xã Khoen On",
        "englishName": ""
      }
    ]
  },
  {
    "code": "14",
    "name": "Tỉnh Sơn La",
    "englishName": "",
    "administrativeLevel": "Tỉnh",
    "communes": [
      {
        "code": "03646",
        "name": "Phường Tô Hiệu",
        "englishName": ""
      },
      {
        "code": "03664",
        "name": "Phường Chiềng An",
        "englishName": ""
      },
      {
        "code": "03670",
        "name": "Phường Chiềng Cơi",
        "englishName": ""
      },
      {
        "code": "03679",
        "name": "Phường Chiềng Sinh",
        "englishName": ""
      },
      {
        "code": "03688",
        "name": "Xã Mường Chiên",
        "englishName": ""
      },
      {
        "code": "03694",
        "name": "Xã Mường Giôn",
        "englishName": ""
      },
      {
        "code": "03703",
        "name": "Xã Quỳnh Nhai",
        "englishName": ""
      },
      {
        "code": "03712",
        "name": "Xã Mường Sại",
        "englishName": ""
      },
      {
        "code": "03721",
        "name": "Xã Thuận Châu",
        "englishName": ""
      },
      {
        "code": "03724",
        "name": "Xã Bình Thuận",
        "englishName": ""
      },
      {
        "code": "03727",
        "name": "Xã Mường É",
        "englishName": ""
      },
      {
        "code": "03754",
        "name": "Xã Chiềng La",
        "englishName": ""
      },
      {
        "code": "03757",
        "name": "Xã Mường Khiêng",
        "englishName": ""
      },
      {
        "code": "03760",
        "name": "Xã Mường Bám",
        "englishName": ""
      },
      {
        "code": "03763",
        "name": "Xã Long Hẹ",
        "englishName": ""
      },
      {
        "code": "03781",
        "name": "Xã Co Mạ",
        "englishName": ""
      },
      {
        "code": "03784",
        "name": "Xã Nậm Lầu",
        "englishName": ""
      },
      {
        "code": "03799",
        "name": "Xã Muổi Nọi",
        "englishName": ""
      },
      {
        "code": "03808",
        "name": "Xã Mường La",
        "englishName": ""
      },
      {
        "code": "03814",
        "name": "Xã Chiềng Lao",
        "englishName": ""
      },
      {
        "code": "03820",
        "name": "Xã Ngọc Chiến",
        "englishName": ""
      },
      {
        "code": "03847",
        "name": "Xã Mường Bú",
        "englishName": ""
      },
      {
        "code": "03850",
        "name": "Xã Chiềng Hoa",
        "englishName": ""
      },
      {
        "code": "03856",
        "name": "Xã Bắc Yên",
        "englishName": ""
      },
      {
        "code": "03862",
        "name": "Xã Xím Vàng",
        "englishName": ""
      },
      {
        "code": "03868",
        "name": "Xã Tà Xùa",
        "englishName": ""
      },
      {
        "code": "03871",
        "name": "Xã Pắc Ngà",
        "englishName": ""
      },
      {
        "code": "03880",
        "name": "Xã Tạ Khoa",
        "englishName": ""
      },
      {
        "code": "03892",
        "name": "Xã Chiềng Sại",
        "englishName": ""
      },
      {
        "code": "03901",
        "name": "Xã Suối Tọ",
        "englishName": ""
      },
      {
        "code": "03907",
        "name": "Xã Mường Cơi",
        "englishName": ""
      },
      {
        "code": "03910",
        "name": "Xã Phù Yên",
        "englishName": ""
      },
      {
        "code": "03922",
        "name": "Xã Gia Phù",
        "englishName": ""
      },
      {
        "code": "03943",
        "name": "Xã Mường Bang",
        "englishName": ""
      },
      {
        "code": "03958",
        "name": "Xã Tường Hạ",
        "englishName": ""
      },
      {
        "code": "03961",
        "name": "Xã Kim Bon",
        "englishName": ""
      },
      {
        "code": "03970",
        "name": "Xã Tân Phong",
        "englishName": ""
      },
      {
        "code": "03979",
        "name": "Phường Mộc Sơn",
        "englishName": ""
      },
      {
        "code": "03980",
        "name": "Phường Mộc Châu",
        "englishName": ""
      },
      {
        "code": "03982",
        "name": "Phường Thảo Nguyên",
        "englishName": ""
      },
      {
        "code": "03985",
        "name": "Xã Chiềng Sơn",
        "englishName": ""
      },
      {
        "code": "03997",
        "name": "Xã Tân Yên",
        "englishName": ""
      },
      {
        "code": "04000",
        "name": "Xã Đoàn Kết",
        "englishName": ""
      },
      {
        "code": "04006",
        "name": "Xã Song Khủa",
        "englishName": ""
      },
      {
        "code": "04018",
        "name": "Xã Tô Múa",
        "englishName": ""
      },
      {
        "code": "04033",
        "name": "Phường Vân Sơn",
        "englishName": ""
      },
      {
        "code": "04045",
        "name": "Xã Lóng Sập",
        "englishName": ""
      },
      {
        "code": "04048",
        "name": "Xã Vân Hồ",
        "englishName": ""
      },
      {
        "code": "04057",
        "name": "Xã Xuân Nha",
        "englishName": ""
      },
      {
        "code": "04075",
        "name": "Xã Yên Châu",
        "englishName": ""
      },
      {
        "code": "04078",
        "name": "Xã Chiềng Hặc",
        "englishName": ""
      },
      {
        "code": "04087",
        "name": "Xã Yên Sơn",
        "englishName": ""
      },
      {
        "code": "04096",
        "name": "Xã Lóng Phiêng",
        "englishName": ""
      },
      {
        "code": "04099",
        "name": "Xã Phiêng Khoài",
        "englishName": ""
      },
      {
        "code": "04105",
        "name": "Xã Mai Sơn",
        "englishName": ""
      },
      {
        "code": "04108",
        "name": "Xã Chiềng Sung",
        "englishName": ""
      },
      {
        "code": "04117",
        "name": "Xã Mường Chanh",
        "englishName": ""
      },
      {
        "code": "04123",
        "name": "Xã Chiềng Mung",
        "englishName": ""
      },
      {
        "code": "04132",
        "name": "Xã Chiềng Mai",
        "englishName": ""
      },
      {
        "code": "04136",
        "name": "Xã Tà Hộc",
        "englishName": ""
      },
      {
        "code": "04144",
        "name": "Xã Phiêng Cằm",
        "englishName": ""
      },
      {
        "code": "04159",
        "name": "Xã Phiêng Pằn",
        "englishName": ""
      },
      {
        "code": "04168",
        "name": "Xã Sông Mã",
        "englishName": ""
      },
      {
        "code": "04171",
        "name": "Xã Bó Sinh",
        "englishName": ""
      },
      {
        "code": "04183",
        "name": "Xã Mường Lầm",
        "englishName": ""
      },
      {
        "code": "04186",
        "name": "Xã Nậm Ty",
        "englishName": ""
      },
      {
        "code": "04195",
        "name": "Xã Chiềng Sơ",
        "englishName": ""
      },
      {
        "code": "04204",
        "name": "Xã Chiềng Khoong",
        "englishName": ""
      },
      {
        "code": "04210",
        "name": "Xã Huổi Một",
        "englishName": ""
      },
      {
        "code": "04219",
        "name": "Xã Mường Hung",
        "englishName": ""
      },
      {
        "code": "04222",
        "name": "Xã Chiềng Khương",
        "englishName": ""
      },
      {
        "code": "04228",
        "name": "Xã Púng Bánh",
        "englishName": ""
      },
      {
        "code": "04231",
        "name": "Xã Sốp Cộp",
        "englishName": ""
      },
      {
        "code": "04240",
        "name": "Xã Mường Lèo",
        "englishName": ""
      },
      {
        "code": "04246",
        "name": "Xã Mường Lạn",
        "englishName": ""
      }
    ]
  },
  {
    "code": "15",
    "name": "Tỉnh Lào Cai",
    "englishName": "",
    "administrativeLevel": "Tỉnh",
    "communes": [
      {
        "code": "02647",
        "name": "Phường Lào Cai",
        "englishName": ""
      },
      {
        "code": "02671",
        "name": "Phường Cam Đường",
        "englishName": "Nam Cuong Commune"
      },
      {
        "code": "02680",
        "name": "Xã Hợp Thành",
        "englishName": ""
      },
      {
        "code": "02683",
        "name": "Xã Bát Xát",
        "englishName": ""
      },
      {
        "code": "02686",
        "name": "Xã A Mú Sung",
        "englishName": ""
      },
      {
        "code": "02695",
        "name": "Xã Trịnh Tường",
        "englishName": ""
      },
      {
        "code": "02701",
        "name": "Xã Y Tý",
        "englishName": ""
      },
      {
        "code": "02707",
        "name": "Xã Dền Sáng",
        "englishName": ""
      },
      {
        "code": "02725",
        "name": "Xã Bản Xèo",
        "englishName": ""
      },
      {
        "code": "02728",
        "name": "Xã Mường Hum",
        "englishName": ""
      },
      {
        "code": "02746",
        "name": "Xã Cốc San",
        "englishName": ""
      },
      {
        "code": "02752",
        "name": "Xã Pha Long",
        "englishName": ""
      },
      {
        "code": "02761",
        "name": "Xã Mường Khương",
        "englishName": ""
      },
      {
        "code": "02782",
        "name": "Xã Cao Sơn",
        "englishName": ""
      },
      {
        "code": "02788",
        "name": "Xã Bản Lầu",
        "englishName": ""
      },
      {
        "code": "02809",
        "name": "Xã Si Ma Cai",
        "englishName": ""
      },
      {
        "code": "02824",
        "name": "Xã Sín Chéng",
        "englishName": ""
      },
      {
        "code": "02839",
        "name": "Xã Bắc Hà",
        "englishName": ""
      },
      {
        "code": "02842",
        "name": "Xã Tả Củ Tỷ",
        "englishName": ""
      },
      {
        "code": "02848",
        "name": "Xã Lùng Phình",
        "englishName": ""
      },
      {
        "code": "02869",
        "name": "Xã Bản Liền",
        "englishName": ""
      },
      {
        "code": "02890",
        "name": "Xã Bảo Nhai",
        "englishName": ""
      },
      {
        "code": "02896",
        "name": "Xã Cốc Lầu",
        "englishName": ""
      },
      {
        "code": "02902",
        "name": "Xã Phong Hải",
        "englishName": ""
      },
      {
        "code": "02905",
        "name": "Xã Bảo Thắng",
        "englishName": ""
      },
      {
        "code": "02908",
        "name": "Xã Tằng Loỏng",
        "englishName": ""
      },
      {
        "code": "02923",
        "name": "Xã Gia Phú",
        "englishName": ""
      },
      {
        "code": "02926",
        "name": "Xã Xuân Quang",
        "englishName": ""
      },
      {
        "code": "02947",
        "name": "Xã Bảo Yên",
        "englishName": ""
      },
      {
        "code": "02953",
        "name": "Xã Nghĩa Đô",
        "englishName": ""
      },
      {
        "code": "02962",
        "name": "Xã Xuân Hòa",
        "englishName": ""
      },
      {
        "code": "02968",
        "name": "Xã Thượng Hà",
        "englishName": ""
      },
      {
        "code": "02989",
        "name": "Xã Bảo Hà",
        "englishName": ""
      },
      {
        "code": "02998",
        "name": "Xã Phúc Khánh",
        "englishName": ""
      },
      {
        "code": "03004",
        "name": "Xã Ngũ Chỉ Sơn",
        "englishName": ""
      },
      {
        "code": "03006",
        "name": "Phường Sa Pa",
        "englishName": ""
      },
      {
        "code": "03013",
        "name": "Xã Tả Phìn",
        "englishName": ""
      },
      {
        "code": "03037",
        "name": "Xã Tả Van",
        "englishName": ""
      },
      {
        "code": "03043",
        "name": "Xã Mường Bo",
        "englishName": ""
      },
      {
        "code": "03046",
        "name": "Xã Bản Hồ",
        "englishName": ""
      },
      {
        "code": "03061",
        "name": "Xã Võ Lao",
        "englishName": ""
      },
      {
        "code": "03076",
        "name": "Xã Nậm Chày",
        "englishName": ""
      },
      {
        "code": "03082",
        "name": "Xã Văn Bàn",
        "englishName": ""
      },
      {
        "code": "03085",
        "name": "Xã Nậm Xé",
        "englishName": ""
      },
      {
        "code": "03091",
        "name": "Xã Chiềng Ken",
        "englishName": ""
      },
      {
        "code": "03103",
        "name": "Xã Khánh Yên",
        "englishName": ""
      },
      {
        "code": "03106",
        "name": "Xã Dương Quỳ",
        "englishName": ""
      },
      {
        "code": "03121",
        "name": "Xã Minh Lương",
        "englishName": ""
      },
      {
        "code": "04252",
        "name": "Phường Yên Bái",
        "englishName": ""
      },
      {
        "code": "04273",
        "name": "Phường Nam Cường",
        "englishName": ""
      },
      {
        "code": "04279",
        "name": "Phường Văn Phú",
        "englishName": ""
      },
      {
        "code": "04288",
        "name": "Phường Nghĩa Lộ",
        "englishName": ""
      },
      {
        "code": "04303",
        "name": "Xã Lục Yên",
        "englishName": ""
      },
      {
        "code": "04309",
        "name": "Xã Lâm Thượng",
        "englishName": ""
      },
      {
        "code": "04336",
        "name": "Xã Tân Lĩnh",
        "englishName": ""
      },
      {
        "code": "04342",
        "name": "Xã Khánh Hòa",
        "englishName": ""
      },
      {
        "code": "04345",
        "name": "Xã Mường Lai",
        "englishName": ""
      },
      {
        "code": "04363",
        "name": "Xã Phúc Lợi",
        "englishName": ""
      },
      {
        "code": "04375",
        "name": "Xã Mậu A",
        "englishName": ""
      },
      {
        "code": "04381",
        "name": "Xã Lâm Giang",
        "englishName": ""
      },
      {
        "code": "04387",
        "name": "Xã Châu Quế",
        "englishName": ""
      },
      {
        "code": "04399",
        "name": "Xã Đông Cuông",
        "englishName": ""
      },
      {
        "code": "04402",
        "name": "Xã Phong Dụ Hạ",
        "englishName": ""
      },
      {
        "code": "04423",
        "name": "Xã Phong Dụ Thượng",
        "englishName": ""
      },
      {
        "code": "04429",
        "name": "Xã Tân Hợp",
        "englishName": ""
      },
      {
        "code": "04441",
        "name": "Xã Xuân Ái",
        "englishName": ""
      },
      {
        "code": "04450",
        "name": "Xã Mỏ Vàng",
        "englishName": ""
      },
      {
        "code": "04456",
        "name": "Xã Mù Cang Chải",
        "englishName": ""
      },
      {
        "code": "04462",
        "name": "Xã Nậm Có",
        "englishName": ""
      },
      {
        "code": "04465",
        "name": "Xã Khao Mang",
        "englishName": ""
      },
      {
        "code": "04474",
        "name": "Xã Lao Chải",
        "englishName": ""
      },
      {
        "code": "04489",
        "name": "Xã Chế Tạo",
        "englishName": ""
      },
      {
        "code": "04492",
        "name": "Xã Púng Luông",
        "englishName": ""
      },
      {
        "code": "04498",
        "name": "Xã Trấn Yên",
        "englishName": ""
      },
      {
        "code": "04531",
        "name": "Xã Quy Mông",
        "englishName": ""
      },
      {
        "code": "04537",
        "name": "Xã Lương Thịnh",
        "englishName": ""
      },
      {
        "code": "04543",
        "name": "Phường Âu Lâu",
        "englishName": ""
      },
      {
        "code": "04564",
        "name": "Xã Việt Hồng",
        "englishName": ""
      },
      {
        "code": "04576",
        "name": "Xã Hưng Khánh",
        "englishName": ""
      },
      {
        "code": "04585",
        "name": "Xã Hạnh Phúc",
        "englishName": ""
      },
      {
        "code": "04603",
        "name": "Xã Tà Xi Láng",
        "englishName": ""
      },
      {
        "code": "04606",
        "name": "Xã Trạm Tấu",
        "englishName": ""
      },
      {
        "code": "04609",
        "name": "Xã Phình Hồ",
        "englishName": ""
      },
      {
        "code": "04630",
        "name": "Xã Tú Lệ",
        "englishName": ""
      },
      {
        "code": "04636",
        "name": "Xã Gia Hội",
        "englishName": ""
      },
      {
        "code": "04651",
        "name": "Xã Sơn Lương",
        "englishName": ""
      },
      {
        "code": "04660",
        "name": "Xã Liên Sơn",
        "englishName": ""
      },
      {
        "code": "04663",
        "name": "Phường Trung Tâm",
        "englishName": ""
      },
      {
        "code": "04672",
        "name": "Xã Văn Chấn",
        "englishName": ""
      },
      {
        "code": "04681",
        "name": "Phường Cầu Thia",
        "englishName": ""
      },
      {
        "code": "04693",
        "name": "Xã Cát Thịnh",
        "englishName": ""
      },
      {
        "code": "04699",
        "name": "Xã Chấn Thịnh",
        "englishName": ""
      },
      {
        "code": "04705",
        "name": "Xã Thượng Bằng La",
        "englishName": ""
      },
      {
        "code": "04711",
        "name": "Xã Nghĩa Tâm",
        "englishName": ""
      },
      {
        "code": "04714",
        "name": "Xã Yên Bình",
        "englishName": ""
      },
      {
        "code": "04717",
        "name": "Xã Thác Bà",
        "englishName": ""
      },
      {
        "code": "04726",
        "name": "Xã Cảm Nhân",
        "englishName": ""
      },
      {
        "code": "04744",
        "name": "Xã Yên Thành",
        "englishName": ""
      },
      {
        "code": "04750",
        "name": "Xã Bảo Ái",
        "englishName": ""
      }
    ]
  },
  {
    "code": "19",
    "name": "Tỉnh Thái Nguyên",
    "englishName": "",
    "administrativeLevel": "Tỉnh",
    "communes": [
      {
        "code": "01840",
        "name": "Phường Đức Xuân",
        "englishName": ""
      },
      {
        "code": "01843",
        "name": "Phường Bắc Kạn",
        "englishName": ""
      },
      {
        "code": "01849",
        "name": "Xã Phong Quang",
        "englishName": ""
      },
      {
        "code": "01864",
        "name": "Xã Bằng Thành",
        "englishName": ""
      },
      {
        "code": "01879",
        "name": "Xã Cao Minh",
        "englishName": ""
      },
      {
        "code": "01882",
        "name": "Xã Nghiên Loan",
        "englishName": ""
      },
      {
        "code": "01894",
        "name": "Xã Phúc Lộc",
        "englishName": ""
      },
      {
        "code": "01906",
        "name": "Xã Ba Bể",
        "englishName": ""
      },
      {
        "code": "01912",
        "name": "Xã Chợ Rã",
        "englishName": ""
      },
      {
        "code": "01921",
        "name": "Xã Thượng Minh",
        "englishName": ""
      },
      {
        "code": "01933",
        "name": "Xã Đồng Phúc",
        "englishName": ""
      },
      {
        "code": "01936",
        "name": "Xã Nà Phặc",
        "englishName": ""
      },
      {
        "code": "01942",
        "name": "Xã Bằng Vân",
        "englishName": ""
      },
      {
        "code": "01954",
        "name": "Xã Ngân Sơn",
        "englishName": ""
      },
      {
        "code": "01957",
        "name": "Xã Thượng Quan",
        "englishName": ""
      },
      {
        "code": "01960",
        "name": "Xã Hiệp Lực",
        "englishName": ""
      },
      {
        "code": "01969",
        "name": "Xã Phủ Thông",
        "englishName": ""
      },
      {
        "code": "01981",
        "name": "Xã Vĩnh Thông",
        "englishName": ""
      },
      {
        "code": "02008",
        "name": "Xã Cẩm Giàng",
        "englishName": ""
      },
      {
        "code": "02014",
        "name": "Xã Bạch Thông",
        "englishName": ""
      },
      {
        "code": "02020",
        "name": "Xã Chợ Đồn",
        "englishName": ""
      },
      {
        "code": "02026",
        "name": "Xã Nam Cường",
        "englishName": ""
      },
      {
        "code": "02038",
        "name": "Xã Quảng Bạch",
        "englishName": ""
      },
      {
        "code": "02044",
        "name": "Xã Yên Thịnh",
        "englishName": ""
      },
      {
        "code": "02071",
        "name": "Xã Nghĩa Tá",
        "englishName": ""
      },
      {
        "code": "02083",
        "name": "Xã Yên Phong",
        "englishName": ""
      },
      {
        "code": "02086",
        "name": "Xã Chợ Mới",
        "englishName": ""
      },
      {
        "code": "02101",
        "name": "Xã Thanh Mai",
        "englishName": ""
      },
      {
        "code": "02104",
        "name": "Xã Tân Kỳ",
        "englishName": ""
      },
      {
        "code": "02107",
        "name": "Xã Thanh Thịnh",
        "englishName": ""
      },
      {
        "code": "02116",
        "name": "Xã Yên Bình",
        "englishName": ""
      },
      {
        "code": "02143",
        "name": "Xã Văn Lang",
        "englishName": ""
      },
      {
        "code": "02152",
        "name": "Xã Cường Lợi",
        "englishName": ""
      },
      {
        "code": "02155",
        "name": "Xã Na Rì",
        "englishName": ""
      },
      {
        "code": "02176",
        "name": "Xã Trần Phú",
        "englishName": ""
      },
      {
        "code": "02185",
        "name": "Xã Côn Minh",
        "englishName": ""
      },
      {
        "code": "02191",
        "name": "Xã Xuân Dương",
        "englishName": ""
      },
      {
        "code": "05443",
        "name": "Phường Phan Đình Phùng",
        "englishName": ""
      },
      {
        "code": "05455",
        "name": "Phường Quyết Thắng",
        "englishName": ""
      },
      {
        "code": "05467",
        "name": "Phường Gia Sàng",
        "englishName": ""
      },
      {
        "code": "05482",
        "name": "Phường Quan Triều",
        "englishName": ""
      },
      {
        "code": "05488",
        "name": "Xã Đại Phúc",
        "englishName": ""
      },
      {
        "code": "05500",
        "name": "Phường Tích Lương",
        "englishName": ""
      },
      {
        "code": "05503",
        "name": "Xã Tân Cương",
        "englishName": ""
      },
      {
        "code": "05518",
        "name": "Phường Sông Công",
        "englishName": ""
      },
      {
        "code": "05528",
        "name": "Phường Bách Quang",
        "englishName": ""
      },
      {
        "code": "05533",
        "name": "Phường Bá Xuyên",
        "englishName": ""
      },
      {
        "code": "05542",
        "name": "Xã Lam Vỹ",
        "englishName": ""
      },
      {
        "code": "05551",
        "name": "Xã Kim Phượng",
        "englishName": ""
      },
      {
        "code": "05563",
        "name": "Xã Phượng Tiến",
        "englishName": ""
      },
      {
        "code": "05569",
        "name": "Xã Định Hóa",
        "englishName": ""
      },
      {
        "code": "05581",
        "name": "Xã Trung Hội",
        "englishName": ""
      },
      {
        "code": "05587",
        "name": "Xã Bình Yên",
        "englishName": ""
      },
      {
        "code": "05602",
        "name": "Xã Phú Đình",
        "englishName": ""
      },
      {
        "code": "05605",
        "name": "Xã Bình Thành",
        "englishName": ""
      },
      {
        "code": "05611",
        "name": "Xã Phú Lương",
        "englishName": ""
      },
      {
        "code": "05620",
        "name": "Xã Yên Trạch",
        "englishName": ""
      },
      {
        "code": "05632",
        "name": "Xã Hợp Thành",
        "englishName": ""
      },
      {
        "code": "05641",
        "name": "Xã Vô Tranh",
        "englishName": ""
      },
      {
        "code": "05662",
        "name": "Xã Trại Cau",
        "englishName": ""
      },
      {
        "code": "05665",
        "name": "Xã Văn Lăng",
        "englishName": ""
      },
      {
        "code": "05674",
        "name": "Xã Quang Sơn",
        "englishName": ""
      },
      {
        "code": "05680",
        "name": "Xã Văn Hán",
        "englishName": ""
      },
      {
        "code": "05692",
        "name": "Xã Đồng Hỷ",
        "englishName": ""
      },
      {
        "code": "05707",
        "name": "Xã Nam Hòa",
        "englishName": ""
      },
      {
        "code": "05710",
        "name": "Phường Linh Sơn",
        "englishName": ""
      },
      {
        "code": "05716",
        "name": "Xã Võ Nhai",
        "englishName": ""
      },
      {
        "code": "05719",
        "name": "Xã Sảng Mộc",
        "englishName": ""
      },
      {
        "code": "05722",
        "name": "Xã Nghinh Tường",
        "englishName": ""
      },
      {
        "code": "05725",
        "name": "Xã Thần Sa",
        "englishName": ""
      },
      {
        "code": "05740",
        "name": "Xã La Hiên",
        "englishName": ""
      },
      {
        "code": "05746",
        "name": "Xã Tràng Xá",
        "englishName": ""
      },
      {
        "code": "05755",
        "name": "Xã Dân Tiến",
        "englishName": ""
      },
      {
        "code": "05773",
        "name": "Xã Phú Xuyên",
        "englishName": ""
      },
      {
        "code": "05776",
        "name": "Xã Đức Lương",
        "englishName": ""
      },
      {
        "code": "05788",
        "name": "Xã Phú Lạc",
        "englishName": ""
      },
      {
        "code": "05800",
        "name": "Xã Phú Thịnh",
        "englishName": ""
      },
      {
        "code": "05809",
        "name": "Xã An Khánh",
        "englishName": ""
      },
      {
        "code": "05818",
        "name": "Xã La Bằng",
        "englishName": ""
      },
      {
        "code": "05830",
        "name": "Xã Đại Từ",
        "englishName": ""
      },
      {
        "code": "05845",
        "name": "Xã Vạn Phú",
        "englishName": ""
      },
      {
        "code": "05851",
        "name": "Xã Quân Chu",
        "englishName": ""
      },
      {
        "code": "05857",
        "name": "Phường Phúc Thuận",
        "englishName": ""
      },
      {
        "code": "05860",
        "name": "Phường Phổ Yên",
        "englishName": ""
      },
      {
        "code": "05881",
        "name": "Xã Thành Công",
        "englishName": ""
      },
      {
        "code": "05890",
        "name": "Phường Vạn Xuân",
        "englishName": ""
      },
      {
        "code": "05899",
        "name": "Phường Trung Thành",
        "englishName": ""
      },
      {
        "code": "05908",
        "name": "Xã Phú Bình",
        "englishName": ""
      },
      {
        "code": "05917",
        "name": "Xã Tân Khánh",
        "englishName": ""
      },
      {
        "code": "05923",
        "name": "Xã Tân Thành",
        "englishName": ""
      },
      {
        "code": "05941",
        "name": "Xã Điềm Thụy",
        "englishName": ""
      },
      {
        "code": "05953",
        "name": "Xã Kha Sơn",
        "englishName": ""
      }
    ]
  },
  {
    "code": "20",
    "name": "Tỉnh Lạng Sơn",
    "englishName": "",
    "administrativeLevel": "Tỉnh",
    "communes": [
      {
        "code": "05977",
        "name": "Phường Đông Kinh",
        "englishName": ""
      },
      {
        "code": "05983",
        "name": "Phường Lương Văn Tri",
        "englishName": ""
      },
      {
        "code": "05986",
        "name": "Phường Tam Thanh",
        "englishName": ""
      },
      {
        "code": "06001",
        "name": "Xã Đoàn Kết",
        "englishName": ""
      },
      {
        "code": "06004",
        "name": "Xã Quốc Khánh",
        "englishName": ""
      },
      {
        "code": "06019",
        "name": "Xã Tân Tiến",
        "englishName": ""
      },
      {
        "code": "06037",
        "name": "Xã Kháng Chiến",
        "englishName": ""
      },
      {
        "code": "06040",
        "name": "Xã Thất Khê",
        "englishName": ""
      },
      {
        "code": "06046",
        "name": "Xã Tràng Định",
        "englishName": ""
      },
      {
        "code": "06058",
        "name": "Xã Quốc Việt",
        "englishName": ""
      },
      {
        "code": "06073",
        "name": "Xã Hoa Thám",
        "englishName": ""
      },
      {
        "code": "06076",
        "name": "Xã Quý Hòa",
        "englishName": ""
      },
      {
        "code": "06079",
        "name": "Xã Hồng Phong",
        "englishName": ""
      },
      {
        "code": "06085",
        "name": "Xã Thiện Hòa",
        "englishName": ""
      },
      {
        "code": "06091",
        "name": "Xã Thiện Thuật",
        "englishName": ""
      },
      {
        "code": "06103",
        "name": "Xã Thiện Long",
        "englishName": ""
      },
      {
        "code": "06112",
        "name": "Xã Bình Gia",
        "englishName": ""
      },
      {
        "code": "06115",
        "name": "Xã Tân Văn",
        "englishName": ""
      },
      {
        "code": "06124",
        "name": "Xã Na Sầm",
        "englishName": ""
      },
      {
        "code": "06148",
        "name": "Xã Thụy Hùng",
        "englishName": ""
      },
      {
        "code": "06151",
        "name": "Xã Hội Hoan",
        "englishName": ""
      },
      {
        "code": "06154",
        "name": "Xã Văn Lãng",
        "englishName": ""
      },
      {
        "code": "06172",
        "name": "Xã Hoàng Văn Thụ",
        "englishName": ""
      },
      {
        "code": "06184",
        "name": "Xã Đồng Đăng",
        "englishName": ""
      },
      {
        "code": "06187",
        "name": "Phường Kỳ Lừa",
        "englishName": ""
      },
      {
        "code": "06196",
        "name": "Xã Ba Sơn",
        "englishName": ""
      },
      {
        "code": "06211",
        "name": "Xã Cao Lộc",
        "englishName": ""
      },
      {
        "code": "06220",
        "name": "Xã Công Sơn",
        "englishName": ""
      },
      {
        "code": "06253",
        "name": "Xã Văn Quan",
        "englishName": ""
      },
      {
        "code": "06280",
        "name": "Xã Điềm He",
        "englishName": ""
      },
      {
        "code": "06286",
        "name": "Xã Khánh Khê",
        "englishName": ""
      },
      {
        "code": "06298",
        "name": "Xã Yên Phúc",
        "englishName": ""
      },
      {
        "code": "06313",
        "name": "Xã Tri Lễ",
        "englishName": ""
      },
      {
        "code": "06316",
        "name": "Xã Tân Đoàn",
        "englishName": ""
      },
      {
        "code": "06325",
        "name": "xã Bắc Sơn",
        "englishName": ""
      },
      {
        "code": "06337",
        "name": "Xã Tân Tri",
        "englishName": ""
      },
      {
        "code": "06349",
        "name": "Xã Hưng Vũ",
        "englishName": ""
      },
      {
        "code": "06364",
        "name": "Xã Vũ Lễ",
        "englishName": ""
      },
      {
        "code": "06367",
        "name": "Xã Vũ Lăng",
        "englishName": ""
      },
      {
        "code": "06376",
        "name": "Xã Nhất Hòa",
        "englishName": ""
      },
      {
        "code": "06385",
        "name": "Xã Hữu Lũng",
        "englishName": ""
      },
      {
        "code": "06391",
        "name": "Xã Yên Bình",
        "englishName": ""
      },
      {
        "code": "06400",
        "name": "Xã Hữu Liên",
        "englishName": ""
      },
      {
        "code": "06415",
        "name": "Xã Vân Nham",
        "englishName": ""
      },
      {
        "code": "06427",
        "name": "Xã Cai Kinh",
        "englishName": ""
      },
      {
        "code": "06436",
        "name": "Xã Thiện Tân",
        "englishName": ""
      },
      {
        "code": "06445",
        "name": "Xã Tân Thành",
        "englishName": ""
      },
      {
        "code": "06457",
        "name": "Xã Tuấn Sơn",
        "englishName": ""
      },
      {
        "code": "06463",
        "name": "Xã Chi Lăng",
        "englishName": ""
      },
      {
        "code": "06475",
        "name": "Xã Bằng Mạc",
        "englishName": ""
      },
      {
        "code": "06481",
        "name": "Xã Chiến Thắng",
        "englishName": ""
      },
      {
        "code": "06496",
        "name": "Xã Nhân Lý",
        "englishName": ""
      },
      {
        "code": "06505",
        "name": "Xã Vạn Linh",
        "englishName": ""
      },
      {
        "code": "06517",
        "name": "Xã Quan Sơn",
        "englishName": ""
      },
      {
        "code": "06526",
        "name": "Xã Na Dương",
        "englishName": ""
      },
      {
        "code": "06529",
        "name": "Xã Lộc Bình",
        "englishName": ""
      },
      {
        "code": "06541",
        "name": "Xã Mẫu Sơn",
        "englishName": ""
      },
      {
        "code": "06565",
        "name": "Xã Khuất Xá",
        "englishName": ""
      },
      {
        "code": "06577",
        "name": "Xã Thống Nhất",
        "englishName": ""
      },
      {
        "code": "06601",
        "name": "Xã Lợi Bác",
        "englishName": ""
      },
      {
        "code": "06607",
        "name": "Xã Xuân Dương",
        "englishName": ""
      },
      {
        "code": "06613",
        "name": "Xã Đình Lập",
        "englishName": ""
      },
      {
        "code": "06616",
        "name": "Xã Thái Bình",
        "englishName": ""
      },
      {
        "code": "06625",
        "name": "Xã Kiên Mộc",
        "englishName": ""
      },
      {
        "code": "06637",
        "name": "Xã Châu Sơn",
        "englishName": ""
      }
    ]
  },
  {
    "code": "22",
    "name": "Tỉnh Quảng Ninh",
    "englishName": "",
    "administrativeLevel": "Tỉnh",
    "communes": [
      {
        "code": "06652",
        "name": "Phường Hà Tu",
        "englishName": ""
      },
      {
        "code": "06658",
        "name": "Phường Cao Xanh",
        "englishName": ""
      },
      {
        "code": "06661",
        "name": "Phường Việt Hưng",
        "englishName": ""
      },
      {
        "code": "06673",
        "name": "Phường Bãi Cháy",
        "englishName": ""
      },
      {
        "code": "06676",
        "name": "Phường Hà Lầm",
        "englishName": ""
      },
      {
        "code": "06685",
        "name": "Phường Hồng Gai",
        "englishName": ""
      },
      {
        "code": "06688",
        "name": "Phường Hạ Long",
        "englishName": ""
      },
      {
        "code": "06706",
        "name": "Phường Tuần Châu",
        "englishName": ""
      },
      {
        "code": "06709",
        "name": "Phường Móng Cái 2",
        "englishName": ""
      },
      {
        "code": "06712",
        "name": "Phường Móng Cái 1",
        "englishName": ""
      },
      {
        "code": "06724",
        "name": "Xã Hải Sơn",
        "englishName": ""
      },
      {
        "code": "06733",
        "name": "Xã Hải Ninh",
        "englishName": ""
      },
      {
        "code": "06736",
        "name": "Phường Móng Cái 3",
        "englishName": ""
      },
      {
        "code": "06757",
        "name": "Xã Vĩnh Thực",
        "englishName": ""
      },
      {
        "code": "06760",
        "name": "Phường Mông Dương",
        "englishName": ""
      },
      {
        "code": "06778",
        "name": "Phường Quang Hanh",
        "englishName": ""
      },
      {
        "code": "06781",
        "name": "Phường Cửa Ông",
        "englishName": ""
      },
      {
        "code": "06793",
        "name": "Phường Cẩm Phả",
        "englishName": ""
      },
      {
        "code": "06799",
        "name": "Xã Hải Hòa",
        "englishName": ""
      },
      {
        "code": "06811",
        "name": "Phường Uông Bí",
        "englishName": ""
      },
      {
        "code": "06820",
        "name": "Phường Vàng Danh",
        "englishName": ""
      },
      {
        "code": "06832",
        "name": "Phường Yên Tử",
        "englishName": ""
      },
      {
        "code": "06838",
        "name": "Xã Bình Liêu",
        "englishName": ""
      },
      {
        "code": "06841",
        "name": "Xã Hoành Mô",
        "englishName": ""
      },
      {
        "code": "06856",
        "name": "Xã Lục Hồn",
        "englishName": ""
      },
      {
        "code": "06862",
        "name": "Xã Tiên Yên",
        "englishName": ""
      },
      {
        "code": "06874",
        "name": "Xã Điền Xá",
        "englishName": ""
      },
      {
        "code": "06877",
        "name": "Xã Đông Ngũ",
        "englishName": ""
      },
      {
        "code": "06886",
        "name": "Xã Hải Lạng",
        "englishName": ""
      },
      {
        "code": "06895",
        "name": "Xã Đầm Hà",
        "englishName": ""
      },
      {
        "code": "06913",
        "name": "Xã Quảng Tân",
        "englishName": ""
      },
      {
        "code": "06922",
        "name": "Xã Quảng Hà",
        "englishName": ""
      },
      {
        "code": "06931",
        "name": "Xã Quảng Đức",
        "englishName": ""
      },
      {
        "code": "06946",
        "name": "Xã Đường Hoa",
        "englishName": ""
      },
      {
        "code": "06967",
        "name": "Xã Cái Chiên",
        "englishName": ""
      },
      {
        "code": "06970",
        "name": "Xã Ba Chẽ",
        "englishName": ""
      },
      {
        "code": "06979",
        "name": "Xã Kỳ Thượng",
        "englishName": ""
      },
      {
        "code": "06985",
        "name": "Xã Lương Minh",
        "englishName": ""
      },
      {
        "code": "06994",
        "name": "Đặc khu Vân Đồn",
        "englishName": ""
      },
      {
        "code": "07030",
        "name": "Phường Hoành Bồ",
        "englishName": ""
      },
      {
        "code": "07054",
        "name": "Xã Quảng La",
        "englishName": ""
      },
      {
        "code": "07060",
        "name": "Xã Thống Nhất",
        "englishName": ""
      },
      {
        "code": "07069",
        "name": "Phường Mạo Khê",
        "englishName": ""
      },
      {
        "code": "07081",
        "name": "Phường Bình Khê",
        "englishName": ""
      },
      {
        "code": "07090",
        "name": "Phường An Sinh",
        "englishName": ""
      },
      {
        "code": "07093",
        "name": "Phường Đông Triều",
        "englishName": ""
      },
      {
        "code": "07114",
        "name": "Phường Hoàng Quế",
        "englishName": ""
      },
      {
        "code": "07132",
        "name": "Phường Quảng Yên",
        "englishName": ""
      },
      {
        "code": "07135",
        "name": "Phường Đông Mai",
        "englishName": ""
      },
      {
        "code": "07147",
        "name": "Phường Hiệp Hòa",
        "englishName": ""
      },
      {
        "code": "07168",
        "name": "Phường Hà An",
        "englishName": ""
      },
      {
        "code": "07180",
        "name": "Phường Liên Hòa",
        "englishName": ""
      },
      {
        "code": "07183",
        "name": "Phường Phong Cốc",
        "englishName": ""
      },
      {
        "code": "07192",
        "name": "Đặc khu Cô Tô",
        "englishName": ""
      }
    ]
  },
  {
    "code": "24",
    "name": "Tỉnh Bắc Ninh",
    "englishName": "",
    "administrativeLevel": "Tỉnh",
    "communes": [
      {
        "code": "07210",
        "name": "Phường Bắc Giang",
        "englishName": ""
      },
      {
        "code": "07228",
        "name": "Phường Đa Mai",
        "englishName": ""
      },
      {
        "code": "07246",
        "name": "Xã Xuân Lương",
        "englishName": ""
      },
      {
        "code": "07264",
        "name": "Xã Tam Tiến",
        "englishName": ""
      },
      {
        "code": "07282",
        "name": "Xã Đồng Kỳ",
        "englishName": ""
      },
      {
        "code": "07288",
        "name": "Xã Yên Thế",
        "englishName": ""
      },
      {
        "code": "07294",
        "name": "Xã Bố Hạ",
        "englishName": ""
      },
      {
        "code": "07306",
        "name": "Xã Nhã Nam",
        "englishName": ""
      },
      {
        "code": "07330",
        "name": "Xã Phúc Hòa",
        "englishName": ""
      },
      {
        "code": "07333",
        "name": "Xã Quang Trung",
        "englishName": ""
      },
      {
        "code": "07339",
        "name": "Xã Tân Yên",
        "englishName": ""
      },
      {
        "code": "07351",
        "name": "Xã Ngọc Thiện",
        "englishName": ""
      },
      {
        "code": "07375",
        "name": "Xã Lạng Giang",
        "englishName": ""
      },
      {
        "code": "07381",
        "name": "Xã Tiên Lục",
        "englishName": ""
      },
      {
        "code": "07399",
        "name": "Xã Kép",
        "englishName": ""
      },
      {
        "code": "07420",
        "name": "Xã Mỹ Thái",
        "englishName": ""
      },
      {
        "code": "07432",
        "name": "Xã Tân Dĩnh",
        "englishName": ""
      },
      {
        "code": "07444",
        "name": "Xã Lục Nam",
        "englishName": ""
      },
      {
        "code": "07450",
        "name": "Xã Đông Phú",
        "englishName": ""
      },
      {
        "code": "07462",
        "name": "Xã Bảo Đài",
        "englishName": ""
      },
      {
        "code": "07486",
        "name": "Xã Nghĩa Phương",
        "englishName": ""
      },
      {
        "code": "07489",
        "name": "Xã Trường Sơn",
        "englishName": ""
      },
      {
        "code": "07492",
        "name": "Xã Lục Sơn",
        "englishName": ""
      },
      {
        "code": "07498",
        "name": "Xã Bắc Lũng",
        "englishName": ""
      },
      {
        "code": "07519",
        "name": "Xã Cẩm Lý",
        "englishName": ""
      },
      {
        "code": "07525",
        "name": "Phường Chũ",
        "englishName": ""
      },
      {
        "code": "07531",
        "name": "Xã Tân Sơn",
        "englishName": ""
      },
      {
        "code": "07534",
        "name": "Xã Sa Lý",
        "englishName": ""
      },
      {
        "code": "07537",
        "name": "Xã Biên Sơn",
        "englishName": ""
      },
      {
        "code": "07543",
        "name": "Xã Sơn Hải",
        "englishName": ""
      },
      {
        "code": "07552",
        "name": "Xã Kiên Lao",
        "englishName": ""
      },
      {
        "code": "07573",
        "name": "Xã Biển Động",
        "englishName": ""
      },
      {
        "code": "07582",
        "name": "Xã Lục Ngạn",
        "englishName": ""
      },
      {
        "code": "07594",
        "name": "Xã Đèo Gia",
        "englishName": ""
      },
      {
        "code": "07603",
        "name": "Xã Nam Dương",
        "englishName": ""
      },
      {
        "code": "07612",
        "name": "Phường Phượng Sơn",
        "englishName": ""
      },
      {
        "code": "07615",
        "name": "Xã Sơn Động",
        "englishName": ""
      },
      {
        "code": "07616",
        "name": "Xã Tây Yên Tử",
        "englishName": ""
      },
      {
        "code": "07621",
        "name": "Xã Vân Sơn",
        "englishName": ""
      },
      {
        "code": "07627",
        "name": "Xã Đại Sơn",
        "englishName": ""
      },
      {
        "code": "07642",
        "name": "Xã Yên Định",
        "englishName": ""
      },
      {
        "code": "07654",
        "name": "Xã An Lạc",
        "englishName": ""
      },
      {
        "code": "07663",
        "name": "Xã Tuấn Đạo",
        "englishName": ""
      },
      {
        "code": "07672",
        "name": "Xã Dương Hưu",
        "englishName": ""
      },
      {
        "code": "07681",
        "name": "Phường Yên Dũng",
        "englishName": ""
      },
      {
        "code": "07682",
        "name": "Phường Tân An",
        "englishName": ""
      },
      {
        "code": "07696",
        "name": "Phường Tiền Phong",
        "englishName": ""
      },
      {
        "code": "07699",
        "name": "Phường Tân Tiến",
        "englishName": ""
      },
      {
        "code": "07735",
        "name": "Xã Đồng Việt",
        "englishName": ""
      },
      {
        "code": "07738",
        "name": "Phường Cảnh Thụy",
        "englishName": ""
      },
      {
        "code": "07774",
        "name": "Phường Tự Lạn",
        "englishName": ""
      },
      {
        "code": "07777",
        "name": "Phường Việt Yên",
        "englishName": ""
      },
      {
        "code": "07795",
        "name": "Phường Nếnh",
        "englishName": ""
      },
      {
        "code": "07798",
        "name": "Phường Vân Hà",
        "englishName": ""
      },
      {
        "code": "07822",
        "name": "Xã Hoàng Vân",
        "englishName": ""
      },
      {
        "code": "07840",
        "name": "Xã Hiệp Hoà",
        "englishName": ""
      },
      {
        "code": "07864",
        "name": "Xã Hợp Thịnh",
        "englishName": ""
      },
      {
        "code": "07870",
        "name": "Xã Xuân Cẩm",
        "englishName": ""
      },
      {
        "code": "09169",
        "name": "Phường Vũ Ninh",
        "englishName": ""
      },
      {
        "code": "09187",
        "name": "Phường Kinh Bắc",
        "englishName": ""
      },
      {
        "code": "09190",
        "name": "Phường Võ Cường",
        "englishName": ""
      },
      {
        "code": "09193",
        "name": "Xã Yên Phong",
        "englishName": ""
      },
      {
        "code": "09202",
        "name": "Xã Tam Giang",
        "englishName": ""
      },
      {
        "code": "09205",
        "name": "Xã Yên Trung",
        "englishName": ""
      },
      {
        "code": "09208",
        "name": "Xã Tam Đa",
        "englishName": ""
      },
      {
        "code": "09238",
        "name": "Xã Văn Môn",
        "englishName": ""
      },
      {
        "code": "09247",
        "name": "Phường Quế Võ",
        "englishName": ""
      },
      {
        "code": "09253",
        "name": "Phường Nhân Hòa",
        "englishName": ""
      },
      {
        "code": "09265",
        "name": "Phường Phương Liễu",
        "englishName": ""
      },
      {
        "code": "09286",
        "name": "Phường Nam Sơn",
        "englishName": ""
      },
      {
        "code": "09292",
        "name": "Xã Phù Lãng",
        "englishName": ""
      },
      {
        "code": "09295",
        "name": "Phường Bồng Lai",
        "englishName": ""
      },
      {
        "code": "09301",
        "name": "Phường Đào Viên",
        "englishName": ""
      },
      {
        "code": "09313",
        "name": "Xã Chi Lăng",
        "englishName": ""
      },
      {
        "code": "09319",
        "name": "Xã Tiên Du",
        "englishName": ""
      },
      {
        "code": "09325",
        "name": "Phường Hạp Lĩnh",
        "englishName": ""
      },
      {
        "code": "09334",
        "name": "Xã Liên Bão",
        "englishName": ""
      },
      {
        "code": "09340",
        "name": "Xã Đại Đồng",
        "englishName": ""
      },
      {
        "code": "09343",
        "name": "Xã Tân Chi",
        "englishName": ""
      },
      {
        "code": "09349",
        "name": "Xã Phật Tích",
        "englishName": ""
      },
      {
        "code": "09367",
        "name": "Phường Từ Sơn",
        "englishName": ""
      },
      {
        "code": "09370",
        "name": "Phường Tam Sơn",
        "englishName": ""
      },
      {
        "code": "09379",
        "name": "Phường Phù Khê",
        "englishName": ""
      },
      {
        "code": "09385",
        "name": "Phường Đồng Nguyên",
        "englishName": ""
      },
      {
        "code": "09400",
        "name": "Phường Thuận Thành",
        "englishName": ""
      },
      {
        "code": "09409",
        "name": "Phường Mão Điền",
        "englishName": ""
      },
      {
        "code": "09427",
        "name": "Phường Trí Quả",
        "englishName": ""
      },
      {
        "code": "09430",
        "name": "Phường Trạm Lộ",
        "englishName": ""
      },
      {
        "code": "09433",
        "name": "Phường Song Liễu",
        "englishName": ""
      },
      {
        "code": "09445",
        "name": "Phường Ninh Xá",
        "englishName": ""
      },
      {
        "code": "09454",
        "name": "Xã Gia Bình",
        "englishName": ""
      },
      {
        "code": "09466",
        "name": "Xã Cao Đức",
        "englishName": ""
      },
      {
        "code": "09469",
        "name": "Xã Đại Lai",
        "englishName": ""
      },
      {
        "code": "09475",
        "name": "Xã Nhân Thắng",
        "englishName": ""
      },
      {
        "code": "09487",
        "name": "Xã Đông Cứu",
        "englishName": ""
      },
      {
        "code": "09496",
        "name": "Xã Lương Tài",
        "englishName": ""
      },
      {
        "code": "09499",
        "name": "Xã Trung Kênh",
        "englishName": ""
      },
      {
        "code": "09523",
        "name": "Xã Trung Chính",
        "englishName": ""
      },
      {
        "code": "09529",
        "name": "Xã Lâm Thao",
        "englishName": ""
      }
    ]
  },
  {
    "code": "25",
    "name": "Tỉnh Phú Thọ",
    "englishName": "",
    "administrativeLevel": "Tỉnh",
    "communes": [
      {
        "code": "04792",
        "name": "Phường Tân Hòa",
        "englishName": ""
      },
      {
        "code": "04795",
        "name": "Phường Hòa Bình",
        "englishName": ""
      },
      {
        "code": "04828",
        "name": "Phường Thống Nhất",
        "englishName": ""
      },
      {
        "code": "04831",
        "name": "Xã Đà Bắc",
        "englishName": ""
      },
      {
        "code": "04846",
        "name": "Xã Đức Nhàn",
        "englishName": ""
      },
      {
        "code": "04849",
        "name": "Xã Tân Pheo",
        "englishName": ""
      },
      {
        "code": "04873",
        "name": "Xã Quy Đức",
        "englishName": ""
      },
      {
        "code": "04876",
        "name": "Xã Cao Sơn",
        "englishName": ""
      },
      {
        "code": "04891",
        "name": "Xã Tiền Phong",
        "englishName": ""
      },
      {
        "code": "04894",
        "name": "Phường Kỳ Sơn",
        "englishName": ""
      },
      {
        "code": "04897",
        "name": "Xã Thịnh Minh",
        "englishName": ""
      },
      {
        "code": "04924",
        "name": "Xã Lương Sơn",
        "englishName": ""
      },
      {
        "code": "04960",
        "name": "Xã Liên Sơn",
        "englishName": ""
      },
      {
        "code": "04978",
        "name": "Xã Kim Bôi",
        "englishName": ""
      },
      {
        "code": "04990",
        "name": "Xã Nật Sơn",
        "englishName": ""
      },
      {
        "code": "05014",
        "name": "Xã Mường Động",
        "englishName": ""
      },
      {
        "code": "05047",
        "name": "Xã Cao Dương",
        "englishName": ""
      },
      {
        "code": "05068",
        "name": "Xã Hợp Kim",
        "englishName": ""
      },
      {
        "code": "05086",
        "name": "Xã Dũng Tiến",
        "englishName": ""
      },
      {
        "code": "05089",
        "name": "Xã Cao Phong",
        "englishName": ""
      },
      {
        "code": "05092",
        "name": "Xã Thung Nai",
        "englishName": ""
      },
      {
        "code": "05116",
        "name": "Xã Mường Thàng",
        "englishName": ""
      },
      {
        "code": "05128",
        "name": "Xã Tân Lạc",
        "englishName": ""
      },
      {
        "code": "05134",
        "name": "Xã Mường Hoa",
        "englishName": ""
      },
      {
        "code": "05152",
        "name": "Xã Vân Sơn",
        "englishName": ""
      },
      {
        "code": "05158",
        "name": "Xã Mường Bi",
        "englishName": ""
      },
      {
        "code": "05191",
        "name": "Xã Toàn Thắng",
        "englishName": ""
      },
      {
        "code": "05200",
        "name": "Xã Mai Châu",
        "englishName": ""
      },
      {
        "code": "05206",
        "name": "Xã Tân Mai",
        "englishName": ""
      },
      {
        "code": "05212",
        "name": "Xã Pà Cò",
        "englishName": ""
      },
      {
        "code": "05245",
        "name": "Xã Bao La",
        "englishName": ""
      },
      {
        "code": "05251",
        "name": "Xã Mai Hạ",
        "englishName": ""
      },
      {
        "code": "05266",
        "name": "Xã Lạc Sơn",
        "englishName": ""
      },
      {
        "code": "05287",
        "name": "Xã Mường Vang",
        "englishName": ""
      },
      {
        "code": "05290",
        "name": "Xã Nhân Nghĩa",
        "englishName": ""
      },
      {
        "code": "05293",
        "name": "Xã Thượng Cốc",
        "englishName": ""
      },
      {
        "code": "05305",
        "name": "Xã Yên Phú",
        "englishName": ""
      },
      {
        "code": "05323",
        "name": "Xã Quyết Thắng",
        "englishName": ""
      },
      {
        "code": "05329",
        "name": "Xã Ngọc Sơn",
        "englishName": ""
      },
      {
        "code": "05347",
        "name": "Xã Đại Đồng",
        "englishName": ""
      },
      {
        "code": "05353",
        "name": "Xã Yên Thủy",
        "englishName": ""
      },
      {
        "code": "05362",
        "name": "Xã Lạc Lương",
        "englishName": ""
      },
      {
        "code": "05386",
        "name": "Xã Yên Trị",
        "englishName": ""
      },
      {
        "code": "05392",
        "name": "Xã Lạc Thủy",
        "englishName": ""
      },
      {
        "code": "05395",
        "name": "Xã An Nghĩa",
        "englishName": ""
      },
      {
        "code": "05425",
        "name": "Xã An Bình",
        "englishName": ""
      },
      {
        "code": "07894",
        "name": "Phường Nông Trang",
        "englishName": ""
      },
      {
        "code": "07900",
        "name": "Phường Việt Trì",
        "englishName": ""
      },
      {
        "code": "07909",
        "name": "Phường Thanh Miếu",
        "englishName": ""
      },
      {
        "code": "07918",
        "name": "Phường Vân Phú",
        "englishName": ""
      },
      {
        "code": "07942",
        "name": "Phường Phú Thọ",
        "englishName": ""
      },
      {
        "code": "07948",
        "name": "Phường Âu Cơ",
        "englishName": ""
      },
      {
        "code": "07954",
        "name": "Phường Phong Châu",
        "englishName": ""
      },
      {
        "code": "07969",
        "name": "Xã Đoan Hùng",
        "englishName": ""
      },
      {
        "code": "07996",
        "name": "Xã Bằng Luân",
        "englishName": ""
      },
      {
        "code": "07999",
        "name": "Xã Chí Đám",
        "englishName": ""
      },
      {
        "code": "08023",
        "name": "Xã Tây Cốc",
        "englishName": ""
      },
      {
        "code": "08038",
        "name": "Xã Chân Mộng",
        "englishName": ""
      },
      {
        "code": "08053",
        "name": "Xã Hạ Hòa",
        "englishName": ""
      },
      {
        "code": "08071",
        "name": "Xã Đan Thượng",
        "englishName": ""
      },
      {
        "code": "08110",
        "name": "Xã Hiền Lương",
        "englishName": ""
      },
      {
        "code": "08113",
        "name": "Xã Yên Kỳ",
        "englishName": ""
      },
      {
        "code": "08134",
        "name": "Xã Văn Lang",
        "englishName": ""
      },
      {
        "code": "08143",
        "name": "Xã Vĩnh Chân",
        "englishName": ""
      },
      {
        "code": "08152",
        "name": "Xã Thanh Ba",
        "englishName": ""
      },
      {
        "code": "08173",
        "name": "Xã Quảng Yên",
        "englishName": ""
      },
      {
        "code": "08203",
        "name": "Xã Hoàng Cương",
        "englishName": ""
      },
      {
        "code": "08209",
        "name": "Xã Đông Thành",
        "englishName": ""
      },
      {
        "code": "08218",
        "name": "Xã Chí Tiên",
        "englishName": ""
      },
      {
        "code": "08227",
        "name": "Xã Liên Minh",
        "englishName": ""
      },
      {
        "code": "08230",
        "name": "Xã Phù Ninh",
        "englishName": ""
      },
      {
        "code": "08236",
        "name": "Xã Phú Mỹ",
        "englishName": ""
      },
      {
        "code": "08245",
        "name": "Xã Trạm Thản",
        "englishName": ""
      },
      {
        "code": "08254",
        "name": "Xã Dân Chủ",
        "englishName": ""
      },
      {
        "code": "08275",
        "name": "Xã Bình Phú",
        "englishName": ""
      },
      {
        "code": "08290",
        "name": "Xã Yên Lập",
        "englishName": ""
      },
      {
        "code": "08296",
        "name": "Xã Sơn Lương",
        "englishName": ""
      },
      {
        "code": "08305",
        "name": "Xã Xuân Viên",
        "englishName": ""
      },
      {
        "code": "08311",
        "name": "Xã Trung Sơn",
        "englishName": ""
      },
      {
        "code": "08323",
        "name": "Xã Thượng Long",
        "englishName": ""
      },
      {
        "code": "08338",
        "name": "Xã Minh Hòa",
        "englishName": ""
      },
      {
        "code": "08341",
        "name": "Xã Cẩm Khê",
        "englishName": ""
      },
      {
        "code": "08344",
        "name": "Xã Tiên Lương",
        "englishName": ""
      },
      {
        "code": "08377",
        "name": "Xã Vân Bán",
        "englishName": ""
      },
      {
        "code": "08398",
        "name": "Xã Phú Khê",
        "englishName": ""
      },
      {
        "code": "08416",
        "name": "Xã Hùng Việt",
        "englishName": ""
      },
      {
        "code": "08431",
        "name": "Xã Đồng Lương",
        "englishName": ""
      },
      {
        "code": "08434",
        "name": "Xã Tam Nông",
        "englishName": ""
      },
      {
        "code": "08443",
        "name": "Xã Hiền Quan",
        "englishName": ""
      },
      {
        "code": "08467",
        "name": "Xã Vạn Xuân",
        "englishName": ""
      },
      {
        "code": "08479",
        "name": "Xã Thọ Văn",
        "englishName": ""
      },
      {
        "code": "08494",
        "name": "Xã Lâm Thao",
        "englishName": ""
      },
      {
        "code": "08500",
        "name": "Xã Xuân Lũng",
        "englishName": ""
      },
      {
        "code": "08515",
        "name": "Xã Hy Cương",
        "englishName": ""
      },
      {
        "code": "08521",
        "name": "Xã Phùng Nguyên",
        "englishName": ""
      },
      {
        "code": "08527",
        "name": "Xã Bản Nguyên",
        "englishName": ""
      },
      {
        "code": "08542",
        "name": "Xã Thanh Sơn",
        "englishName": ""
      },
      {
        "code": "08545",
        "name": "Xã Thu Cúc",
        "englishName": ""
      },
      {
        "code": "08560",
        "name": "Xã Lai Đồng",
        "englishName": ""
      },
      {
        "code": "08566",
        "name": "Xã Tân Sơn",
        "englishName": ""
      },
      {
        "code": "08584",
        "name": "Xã Võ Miếu",
        "englishName": ""
      },
      {
        "code": "08590",
        "name": "Xã Xuân Đài",
        "englishName": ""
      },
      {
        "code": "08593",
        "name": "Xã Minh Đài",
        "englishName": ""
      },
      {
        "code": "08611",
        "name": "Xã Văn Miếu",
        "englishName": ""
      },
      {
        "code": "08614",
        "name": "Xã Cự Đồng",
        "englishName": ""
      },
      {
        "code": "08620",
        "name": "Xã Long Cốc",
        "englishName": ""
      },
      {
        "code": "08632",
        "name": "Xã Hương Cần",
        "englishName": ""
      },
      {
        "code": "08635",
        "name": "Xã Khả Cửu",
        "englishName": ""
      },
      {
        "code": "08656",
        "name": "Xã Yên Sơn",
        "englishName": ""
      },
      {
        "code": "08662",
        "name": "Xã Đào Xá",
        "englishName": ""
      },
      {
        "code": "08674",
        "name": "Xã Thanh Thủy",
        "englishName": ""
      },
      {
        "code": "08686",
        "name": "Xã Tu Vũ",
        "englishName": ""
      },
      {
        "code": "08707",
        "name": "Phường Vĩnh Yên",
        "englishName": ""
      },
      {
        "code": "08716",
        "name": "Phường Vĩnh Phúc",
        "englishName": ""
      },
      {
        "code": "08740",
        "name": "Phường Phúc Yên",
        "englishName": ""
      },
      {
        "code": "08746",
        "name": "Phường Xuân Hòa",
        "englishName": ""
      },
      {
        "code": "08761",
        "name": "Xã Lập Thạch",
        "englishName": ""
      },
      {
        "code": "08770",
        "name": "Xã Hợp Lý",
        "englishName": ""
      },
      {
        "code": "08773",
        "name": "Xã Yên Lãng",
        "englishName": ""
      },
      {
        "code": "08782",
        "name": "Xã Hải Lựu",
        "englishName": ""
      },
      {
        "code": "08788",
        "name": "Xã Thái Hòa",
        "englishName": ""
      },
      {
        "code": "08812",
        "name": "Xã Liên Hòa",
        "englishName": ""
      },
      {
        "code": "08824",
        "name": "Xã Tam Sơn",
        "englishName": ""
      },
      {
        "code": "08842",
        "name": "Xã Tiên Lữ",
        "englishName": ""
      },
      {
        "code": "08848",
        "name": "Xã Sông Lô",
        "englishName": ""
      },
      {
        "code": "08866",
        "name": "Xã Sơn Đông",
        "englishName": ""
      },
      {
        "code": "08869",
        "name": "Xã Tam Dương",
        "englishName": ""
      },
      {
        "code": "08872",
        "name": "Xã Tam Dương Bắc",
        "englishName": ""
      },
      {
        "code": "08896",
        "name": "Xã Hoàng An",
        "englishName": ""
      },
      {
        "code": "08905",
        "name": "Xã Hội Thịnh",
        "englishName": ""
      },
      {
        "code": "08911",
        "name": "Xã Tam Đảo",
        "englishName": ""
      },
      {
        "code": "08914",
        "name": "Xã Đạo Trù",
        "englishName": ""
      },
      {
        "code": "08923",
        "name": "Xã Đại Đình",
        "englishName": ""
      },
      {
        "code": "08935",
        "name": "Xã Bình Nguyên",
        "englishName": ""
      },
      {
        "code": "08944",
        "name": "Xã Bình Tuyền",
        "englishName": ""
      },
      {
        "code": "08950",
        "name": "Xã Bình Xuyên",
        "englishName": ""
      },
      {
        "code": "08971",
        "name": "Xã Xuân Lãng",
        "englishName": ""
      },
      {
        "code": "09025",
        "name": "Xã Yên Lạc",
        "englishName": ""
      },
      {
        "code": "09040",
        "name": "Xã Tề Lỗ",
        "englishName": ""
      },
      {
        "code": "09043",
        "name": "Xã Tam Hồng",
        "englishName": ""
      },
      {
        "code": "09052",
        "name": "Xã Nguyệt Đức",
        "englishName": ""
      },
      {
        "code": "09064",
        "name": "Xã Liên Châu",
        "englishName": ""
      },
      {
        "code": "09076",
        "name": "Xã Vĩnh Tường",
        "englishName": ""
      },
      {
        "code": "09079",
        "name": "Xã Vĩnh An",
        "englishName": ""
      },
      {
        "code": "09100",
        "name": "Xã Vĩnh Hưng",
        "englishName": ""
      },
      {
        "code": "09106",
        "name": "Xã Vĩnh Thành",
        "englishName": ""
      },
      {
        "code": "09112",
        "name": "Xã Thổ Tang",
        "englishName": ""
      },
      {
        "code": "09154",
        "name": "Xã Vĩnh Phú",
        "englishName": ""
      }
    ]
  },
  {
    "code": "31",
    "name": "Thành phố Hải Phòng",
    "englishName": "",
    "administrativeLevel": "Thành phố Trung ương",
    "communes": [
      {
        "code": "10507",
        "name": "Phường Thành Đông",
        "englishName": ""
      },
      {
        "code": "10525",
        "name": "Phường Hải Dương",
        "englishName": ""
      },
      {
        "code": "10532",
        "name": "Phường Lê Thanh Nghị",
        "englishName": ""
      },
      {
        "code": "10537",
        "name": "Phường Tân Hưng",
        "englishName": ""
      },
      {
        "code": "10543",
        "name": "Phường Việt Hòa",
        "englishName": ""
      },
      {
        "code": "10546",
        "name": "Phường Chí Linh",
        "englishName": ""
      },
      {
        "code": "10549",
        "name": "Phường Chu Văn An",
        "englishName": ""
      },
      {
        "code": "10552",
        "name": "Phường Nguyễn Trãi",
        "englishName": ""
      },
      {
        "code": "10570",
        "name": "Phường Trần Hưng Đạo",
        "englishName": ""
      },
      {
        "code": "10573",
        "name": "Phường Trần Nhân Tông",
        "englishName": ""
      },
      {
        "code": "10603",
        "name": "Phường Lê Đại Hành",
        "englishName": ""
      },
      {
        "code": "10606",
        "name": "Xã Nam Sách",
        "englishName": ""
      },
      {
        "code": "10615",
        "name": "Xã Hợp Tiến",
        "englishName": ""
      },
      {
        "code": "10633",
        "name": "Xã Trần Phú",
        "englishName": ""
      },
      {
        "code": "10642",
        "name": "Xã Thái Tân",
        "englishName": ""
      },
      {
        "code": "10645",
        "name": "Xã An Phú",
        "englishName": ""
      },
      {
        "code": "10660",
        "name": "Phường Ái Quốc",
        "englishName": ""
      },
      {
        "code": "10675",
        "name": "Phường Kinh Môn",
        "englishName": ""
      },
      {
        "code": "10678",
        "name": "Phường Bắc An Phụ",
        "englishName": ""
      },
      {
        "code": "10705",
        "name": "Xã Nam An Phụ",
        "englishName": ""
      },
      {
        "code": "10714",
        "name": "Phường Nhị Chiểu",
        "englishName": ""
      },
      {
        "code": "10726",
        "name": "Phường Phạm Sư Mạnh",
        "englishName": ""
      },
      {
        "code": "10729",
        "name": "Phường Trần Liễu",
        "englishName": ""
      },
      {
        "code": "10744",
        "name": "Phường Nguyễn Đại Năng",
        "englishName": ""
      },
      {
        "code": "10750",
        "name": "Xã Phú Thái",
        "englishName": ""
      },
      {
        "code": "10756",
        "name": "Xã Lai Khê",
        "englishName": ""
      },
      {
        "code": "10792",
        "name": "Xã An Thành",
        "englishName": ""
      },
      {
        "code": "10804",
        "name": "Xã Kim Thành",
        "englishName": ""
      },
      {
        "code": "10813",
        "name": "Xã Thanh Hà",
        "englishName": ""
      },
      {
        "code": "10816",
        "name": "Xã Hà Bắc",
        "englishName": ""
      },
      {
        "code": "10837",
        "name": "Phường Nam Đồng",
        "englishName": ""
      },
      {
        "code": "10843",
        "name": "Xã Hà Nam",
        "englishName": ""
      },
      {
        "code": "10846",
        "name": "Xã Hà Tây",
        "englishName": ""
      },
      {
        "code": "10882",
        "name": "Xã Hà Đông",
        "englishName": ""
      },
      {
        "code": "10888",
        "name": "Xã Cẩm Giang",
        "englishName": ""
      },
      {
        "code": "10891",
        "name": "Phường Tứ Minh",
        "englishName": ""
      },
      {
        "code": "10903",
        "name": "Xã Cẩm Giàng",
        "englishName": ""
      },
      {
        "code": "10909",
        "name": "Xã Tuệ Tĩnh",
        "englishName": ""
      },
      {
        "code": "10930",
        "name": "Xã Mao Điền",
        "englishName": ""
      },
      {
        "code": "10945",
        "name": "Xã Kẻ Sặt",
        "englishName": ""
      },
      {
        "code": "10966",
        "name": "Xã Bình Giang",
        "englishName": ""
      },
      {
        "code": "10972",
        "name": "Xã Đường An",
        "englishName": ""
      },
      {
        "code": "10993",
        "name": "Xã Thượng Hồng",
        "englishName": ""
      },
      {
        "code": "10999",
        "name": "Xã Gia Lộc",
        "englishName": ""
      },
      {
        "code": "11002",
        "name": "Phường Thạch Khôi",
        "englishName": ""
      },
      {
        "code": "11020",
        "name": "Xã Yết Kiêu",
        "englishName": ""
      },
      {
        "code": "11050",
        "name": "Xã Gia Phúc",
        "englishName": ""
      },
      {
        "code": "11065",
        "name": "Xã Trường Tân",
        "englishName": ""
      },
      {
        "code": "11074",
        "name": "Xã Tứ Kỳ",
        "englishName": ""
      },
      {
        "code": "11086",
        "name": "Xã Đại Sơn",
        "englishName": ""
      },
      {
        "code": "11113",
        "name": "Xã Tân Kỳ",
        "englishName": ""
      },
      {
        "code": "11131",
        "name": "Xã Chí Minh",
        "englishName": ""
      },
      {
        "code": "11140",
        "name": "Xã Lạc Phượng",
        "englishName": ""
      },
      {
        "code": "11146",
        "name": "Xã Nguyên Giáp",
        "englishName": ""
      },
      {
        "code": "11164",
        "name": "Xã Vĩnh Lại",
        "englishName": ""
      },
      {
        "code": "11167",
        "name": "Xã Tân An",
        "englishName": ""
      },
      {
        "code": "11203",
        "name": "Xã Ninh Giang",
        "englishName": ""
      },
      {
        "code": "11218",
        "name": "Xã Hồng Châu",
        "englishName": ""
      },
      {
        "code": "11224",
        "name": "Xã Khúc Thừa Dụ",
        "englishName": ""
      },
      {
        "code": "11239",
        "name": "Xã Thanh Miện",
        "englishName": ""
      },
      {
        "code": "11242",
        "name": "Xã Nguyễn Lương Bằng",
        "englishName": ""
      },
      {
        "code": "11254",
        "name": "Xã Bắc Thanh Miện",
        "englishName": ""
      },
      {
        "code": "11257",
        "name": "Xã Hải Hưng",
        "englishName": ""
      },
      {
        "code": "11284",
        "name": "Xã Nam Thanh Miện",
        "englishName": ""
      },
      {
        "code": "11311",
        "name": "Phường Hồng Bàng",
        "englishName": ""
      },
      {
        "code": "11329",
        "name": "Phường Ngô Quyền",
        "englishName": ""
      },
      {
        "code": "11359",
        "name": "Phường Gia Viên",
        "englishName": ""
      },
      {
        "code": "11383",
        "name": "Phường Lê Chân",
        "englishName": ""
      },
      {
        "code": "11407",
        "name": "Phường An Biên",
        "englishName": ""
      },
      {
        "code": "11411",
        "name": "Phường Đông Hải",
        "englishName": ""
      },
      {
        "code": "11413",
        "name": "Phường Hải An",
        "englishName": ""
      },
      {
        "code": "11443",
        "name": "Phường Kiến An",
        "englishName": ""
      },
      {
        "code": "11446",
        "name": "Phường Phù Liễn",
        "englishName": ""
      },
      {
        "code": "11455",
        "name": "Phường Đồ Sơn",
        "englishName": ""
      },
      {
        "code": "11473",
        "name": "Phường Bạch Đằng",
        "englishName": ""
      },
      {
        "code": "11488",
        "name": "Phường Lưu Kiếm",
        "englishName": ""
      },
      {
        "code": "11503",
        "name": "Xã Việt Khê",
        "englishName": ""
      },
      {
        "code": "11506",
        "name": "Phường Lê Ích Mộc",
        "englishName": ""
      },
      {
        "code": "11533",
        "name": "Phường Hòa Bình",
        "englishName": ""
      },
      {
        "code": "11542",
        "name": "Phường Nam Triệu",
        "englishName": ""
      },
      {
        "code": "11557",
        "name": "Phường Thiên Hương",
        "englishName": ""
      },
      {
        "code": "11560",
        "name": "Phường Thủy Nguyên",
        "englishName": ""
      },
      {
        "code": "11581",
        "name": "Phường An Dương",
        "englishName": ""
      },
      {
        "code": "11593",
        "name": "Phường An Phong",
        "englishName": ""
      },
      {
        "code": "11602",
        "name": "Phường Hồng An",
        "englishName": ""
      },
      {
        "code": "11617",
        "name": "Phường An Hải",
        "englishName": ""
      },
      {
        "code": "11629",
        "name": "Xã An Lão",
        "englishName": ""
      },
      {
        "code": "11635",
        "name": "Xã An Trường",
        "englishName": ""
      },
      {
        "code": "11647",
        "name": "Xã An Quang",
        "englishName": ""
      },
      {
        "code": "11668",
        "name": "Xã An Khánh",
        "englishName": ""
      },
      {
        "code": "11674",
        "name": "Xã An Hưng",
        "englishName": ""
      },
      {
        "code": "11680",
        "name": "Xã Kiến Thụy",
        "englishName": ""
      },
      {
        "code": "11689",
        "name": "Phường Hưng Đạo",
        "englishName": ""
      },
      {
        "code": "11692",
        "name": "Phường Dương Kinh",
        "englishName": ""
      },
      {
        "code": "11713",
        "name": "Xã Nghi Dương",
        "englishName": ""
      },
      {
        "code": "11725",
        "name": "Xã Kiến Minh",
        "englishName": ""
      },
      {
        "code": "11728",
        "name": "Xã Kiến Hưng",
        "englishName": ""
      },
      {
        "code": "11737",
        "name": "Phường Nam Đồ Sơn",
        "englishName": ""
      },
      {
        "code": "11749",
        "name": "Xã Kiến Hải",
        "englishName": ""
      },
      {
        "code": "11755",
        "name": "Xã Tiên Lãng",
        "englishName": ""
      },
      {
        "code": "11761",
        "name": "Xã Quyết Thắng",
        "englishName": ""
      },
      {
        "code": "11779",
        "name": "Xã Tân Minh",
        "englishName": ""
      },
      {
        "code": "11791",
        "name": "Xã Tiên Minh",
        "englishName": ""
      },
      {
        "code": "11806",
        "name": "Xã Chấn Hưng",
        "englishName": ""
      },
      {
        "code": "11809",
        "name": "Xã Hùng Thắng",
        "englishName": ""
      },
      {
        "code": "11824",
        "name": "Xã Vĩnh Bảo",
        "englishName": ""
      },
      {
        "code": "11836",
        "name": "Xã Vĩnh Thịnh",
        "englishName": ""
      },
      {
        "code": "11842",
        "name": "Xã Vĩnh Thuận",
        "englishName": ""
      },
      {
        "code": "11848",
        "name": "Xã Vĩnh Hòa",
        "englishName": ""
      },
      {
        "code": "11875",
        "name": "Xã Vĩnh Hải",
        "englishName": ""
      },
      {
        "code": "11887",
        "name": "Xã Vĩnh Am",
        "englishName": ""
      },
      {
        "code": "11911",
        "name": "Xã Nguyễn Bỉnh Khiêm",
        "englishName": ""
      },
      {
        "code": "11914",
        "name": "Đặc khu Cát Hải",
        "englishName": ""
      },
      {
        "code": "11948",
        "name": "Đặc khu Bạch Long Vĩ",
        "englishName": ""
      }
    ]
  },
  {
    "code": "33",
    "name": "Tỉnh Hưng Yên",
    "englishName": "",
    "administrativeLevel": "Tỉnh",
    "communes": [
      {
        "code": "11953",
        "name": "Phường Phố Hiến",
        "englishName": ""
      },
      {
        "code": "11977",
        "name": "Xã Tân Hưng",
        "englishName": ""
      },
      {
        "code": "11980",
        "name": "Phường Hồng Châu",
        "englishName": ""
      },
      {
        "code": "11983",
        "name": "Phường Sơn Nam",
        "englishName": ""
      },
      {
        "code": "11992",
        "name": "Xã Lạc Đạo",
        "englishName": ""
      },
      {
        "code": "11995",
        "name": "Xã Đại Đồng",
        "englishName": ""
      },
      {
        "code": "12004",
        "name": "Xã Như Quỳnh",
        "englishName": ""
      },
      {
        "code": "12019",
        "name": "Xã Văn Giang",
        "englishName": ""
      },
      {
        "code": "12025",
        "name": "Xã Phụng Công",
        "englishName": ""
      },
      {
        "code": "12031",
        "name": "Xã Nghĩa Trụ",
        "englishName": ""
      },
      {
        "code": "12049",
        "name": "Xã Mễ Sở",
        "englishName": ""
      },
      {
        "code": "12064",
        "name": "Xã Nguyễn Văn Linh",
        "englishName": ""
      },
      {
        "code": "12070",
        "name": "Xã Hoàn Long",
        "englishName": ""
      },
      {
        "code": "12073",
        "name": "Xã Yên Mỹ",
        "englishName": ""
      },
      {
        "code": "12091",
        "name": "Xã Việt Yên",
        "englishName": ""
      },
      {
        "code": "12103",
        "name": "Phường Mỹ Hào",
        "englishName": ""
      },
      {
        "code": "12127",
        "name": "Phường Thượng Hồng",
        "englishName": ""
      },
      {
        "code": "12133",
        "name": "Phường Đường Hào",
        "englishName": ""
      },
      {
        "code": "12142",
        "name": "Xã Ân Thi",
        "englishName": ""
      },
      {
        "code": "12148",
        "name": "Xã Phạm Ngũ Lão",
        "englishName": ""
      },
      {
        "code": "12166",
        "name": "Xã Xuân Trúc",
        "englishName": ""
      },
      {
        "code": "12184",
        "name": "Xã Nguyễn Trãi",
        "englishName": ""
      },
      {
        "code": "12196",
        "name": "Xã Hồng Quang",
        "englishName": ""
      },
      {
        "code": "12205",
        "name": "Xã Khoái Châu",
        "englishName": ""
      },
      {
        "code": "12223",
        "name": "Xã Triệu Việt Vương",
        "englishName": ""
      },
      {
        "code": "12238",
        "name": "Xã Việt Tiến",
        "englishName": ""
      },
      {
        "code": "12247",
        "name": "Xã Châu Ninh",
        "englishName": ""
      },
      {
        "code": "12271",
        "name": "Xã Chí Minh",
        "englishName": ""
      },
      {
        "code": "12280",
        "name": "Xã Lương Bằng",
        "englishName": ""
      },
      {
        "code": "12286",
        "name": "Xã Nghĩa Dân",
        "englishName": ""
      },
      {
        "code": "12313",
        "name": "Xã Đức Hợp",
        "englishName": ""
      },
      {
        "code": "12322",
        "name": "Xã Hiệp Cường",
        "englishName": ""
      },
      {
        "code": "12337",
        "name": "Xã Hoàng Hoa Thám",
        "englishName": ""
      },
      {
        "code": "12361",
        "name": "Xã Tiên Hoa",
        "englishName": ""
      },
      {
        "code": "12364",
        "name": "Xã Tiên Lữ",
        "englishName": ""
      },
      {
        "code": "12391",
        "name": "Xã Quang Hưng",
        "englishName": ""
      },
      {
        "code": "12406",
        "name": "Xã Đoàn Đào",
        "englishName": ""
      },
      {
        "code": "12424",
        "name": "Xã Tiên Tiến",
        "englishName": ""
      },
      {
        "code": "12427",
        "name": "Xã Tống Trân",
        "englishName": ""
      },
      {
        "code": "12452",
        "name": "Phường Trần Hưng Đạo",
        "englishName": ""
      },
      {
        "code": "12454",
        "name": "Phường Trần Lãm",
        "englishName": ""
      },
      {
        "code": "12466",
        "name": "Phường Vũ Phúc",
        "englishName": ""
      },
      {
        "code": "12472",
        "name": "Xã Quỳnh Phụ",
        "englishName": ""
      },
      {
        "code": "12499",
        "name": "Xã A Sào",
        "englishName": ""
      },
      {
        "code": "12511",
        "name": "Xã Minh Thọ",
        "englishName": ""
      },
      {
        "code": "12517",
        "name": "Xã Ngọc Lâm",
        "englishName": ""
      },
      {
        "code": "12523",
        "name": "Xã Phụ Dực",
        "englishName": "An Bai town"
      },
      {
        "code": "12526",
        "name": "Xã Đồng Bằng",
        "englishName": ""
      },
      {
        "code": "12532",
        "name": "Xã Nguyễn Du",
        "englishName": ""
      },
      {
        "code": "12577",
        "name": "Xã Quỳnh An",
        "englishName": ""
      },
      {
        "code": "12583",
        "name": "Xã Tân Tiến",
        "englishName": ""
      },
      {
        "code": "12586",
        "name": "Xã Hưng Hà",
        "englishName": ""
      },
      {
        "code": "12595",
        "name": "Xã Ngự Thiên",
        "englishName": ""
      },
      {
        "code": "12613",
        "name": "Xã Long Hưng",
        "englishName": "Hung Nhan town"
      },
      {
        "code": "12619",
        "name": "Xã Diên Hà",
        "englishName": ""
      },
      {
        "code": "12631",
        "name": "Xã Thần Khê",
        "englishName": ""
      },
      {
        "code": "12634",
        "name": "Xã Tiên La",
        "englishName": ""
      },
      {
        "code": "12676",
        "name": "Xã Lê Quý Đôn",
        "englishName": ""
      },
      {
        "code": "12685",
        "name": "Xã Hồng Minh",
        "englishName": ""
      },
      {
        "code": "12688",
        "name": "Xã Đông Hưng",
        "englishName": ""
      },
      {
        "code": "12694",
        "name": "Xã Bắc Đông Hưng",
        "englishName": ""
      },
      {
        "code": "12700",
        "name": "Xã Bắc Tiên Hưng",
        "englishName": ""
      },
      {
        "code": "12736",
        "name": "Xã Đông Tiên Hưng",
        "englishName": ""
      },
      {
        "code": "12745",
        "name": "Xã Bắc Đông Quan",
        "englishName": ""
      },
      {
        "code": "12754",
        "name": "Xã Tiên Hưng",
        "englishName": ""
      },
      {
        "code": "12763",
        "name": "Xã Nam Tiên Hưng",
        "englishName": ""
      },
      {
        "code": "12775",
        "name": "Xã Nam Đông Hưng",
        "englishName": ""
      },
      {
        "code": "12793",
        "name": "Xã Đông Quan",
        "englishName": ""
      },
      {
        "code": "12817",
        "name": "Phường Trà Lý",
        "englishName": ""
      },
      {
        "code": "12826",
        "name": "Xã Thái Thụy",
        "englishName": ""
      },
      {
        "code": "12850",
        "name": "Xã Tây Thụy Anh",
        "englishName": ""
      },
      {
        "code": "12859",
        "name": "Xã Bắc Thụy Anh",
        "englishName": ""
      },
      {
        "code": "12862",
        "name": "Xã Đông Thụy Anh",
        "englishName": ""
      },
      {
        "code": "12865",
        "name": "Xã Thụy Anh",
        "englishName": ""
      },
      {
        "code": "12904",
        "name": "Xã Nam Thụy Anh",
        "englishName": ""
      },
      {
        "code": "12916",
        "name": "Xã Bắc Thái Ninh",
        "englishName": ""
      },
      {
        "code": "12919",
        "name": "Xã Tây Thái Ninh",
        "englishName": ""
      },
      {
        "code": "12922",
        "name": "Xã Thái Ninh",
        "englishName": ""
      },
      {
        "code": "12943",
        "name": "Xã Đông Thái Ninh",
        "englishName": ""
      },
      {
        "code": "12961",
        "name": "Xã Nam Thái Ninh",
        "englishName": ""
      },
      {
        "code": "12970",
        "name": "Xã Tiền Hải",
        "englishName": ""
      },
      {
        "code": "12988",
        "name": "Xã Đông Tiền Hải",
        "englishName": ""
      },
      {
        "code": "13003",
        "name": "Xã Đồng Châu",
        "englishName": ""
      },
      {
        "code": "13021",
        "name": "Xã Ái Quốc",
        "englishName": ""
      },
      {
        "code": "13039",
        "name": "Xã Tây Tiền Hải",
        "englishName": ""
      },
      {
        "code": "13057",
        "name": "Xã Nam Cường",
        "englishName": ""
      },
      {
        "code": "13063",
        "name": "Xã Nam Tiền Hải",
        "englishName": ""
      },
      {
        "code": "13066",
        "name": "Xã Hưng Phú",
        "englishName": ""
      },
      {
        "code": "13075",
        "name": "Xã Kiến Xương",
        "englishName": ""
      },
      {
        "code": "13093",
        "name": "Xã Trà Giang",
        "englishName": ""
      },
      {
        "code": "13096",
        "name": "Xã Bình Nguyên",
        "englishName": ""
      },
      {
        "code": "13120",
        "name": "Xã Lê Lợi",
        "englishName": ""
      },
      {
        "code": "13132",
        "name": "Xã Quang Lịch",
        "englishName": ""
      },
      {
        "code": "13141",
        "name": "Xã Vũ Quý",
        "englishName": ""
      },
      {
        "code": "13159",
        "name": "Xã Hồng Vũ",
        "englishName": ""
      },
      {
        "code": "13183",
        "name": "Xã Bình Thanh",
        "englishName": ""
      },
      {
        "code": "13186",
        "name": "Xã Bình Định",
        "englishName": ""
      },
      {
        "code": "13192",
        "name": "Xã Vũ Thư",
        "englishName": ""
      },
      {
        "code": "13219",
        "name": "Xã Vạn Xuân",
        "englishName": ""
      },
      {
        "code": "13222",
        "name": "Xã Thư Trì",
        "englishName": ""
      },
      {
        "code": "13225",
        "name": "Phường Thái Bình",
        "englishName": ""
      },
      {
        "code": "13246",
        "name": "Xã Tân Thuận",
        "englishName": ""
      },
      {
        "code": "13264",
        "name": "Xã Thư Vũ",
        "englishName": ""
      },
      {
        "code": "13279",
        "name": "Xã Vũ Tiên",
        "englishName": ""
      }
    ]
  },
  {
    "code": "37",
    "name": "Tỉnh Ninh Bình",
    "englishName": "",
    "administrativeLevel": "Tỉnh",
    "communes": [
      {
        "code": "13285",
        "name": "Phường Phủ Lý",
        "englishName": ""
      },
      {
        "code": "13291",
        "name": "Phường Phù Vân",
        "englishName": ""
      },
      {
        "code": "13318",
        "name": "Phường Châu Sơn",
        "englishName": ""
      },
      {
        "code": "13324",
        "name": "Phường Duy Tiên",
        "englishName": ""
      },
      {
        "code": "13330",
        "name": "Phường Duy Tân",
        "englishName": ""
      },
      {
        "code": "13336",
        "name": "Phường Duy Hà",
        "englishName": ""
      },
      {
        "code": "13348",
        "name": "Phường Đồng Văn",
        "englishName": ""
      },
      {
        "code": "13363",
        "name": "Phường Tiên Sơn",
        "englishName": ""
      },
      {
        "code": "13366",
        "name": "Phường Hà Nam",
        "englishName": ""
      },
      {
        "code": "13384",
        "name": "Phường Kim Bảng",
        "englishName": ""
      },
      {
        "code": "13393",
        "name": "Phường Lê Hồ",
        "englishName": ""
      },
      {
        "code": "13396",
        "name": "Phường Nguyễn Uý",
        "englishName": ""
      },
      {
        "code": "13402",
        "name": "Phường Kim Thanh",
        "englishName": ""
      },
      {
        "code": "13420",
        "name": "Phường Tam Chúc",
        "englishName": ""
      },
      {
        "code": "13435",
        "name": "Phường Lý Thường Kiệt",
        "englishName": ""
      },
      {
        "code": "13444",
        "name": "Phường Liêm Tuyền",
        "englishName": ""
      },
      {
        "code": "13456",
        "name": "Xã Liêm Hà",
        "englishName": ""
      },
      {
        "code": "13474",
        "name": "Xã Tân Thanh",
        "englishName": ""
      },
      {
        "code": "13483",
        "name": "Xã Thanh Bình",
        "englishName": ""
      },
      {
        "code": "13489",
        "name": "Xã Thanh Lâm",
        "englishName": ""
      },
      {
        "code": "13495",
        "name": "Xã Thanh Liêm",
        "englishName": ""
      },
      {
        "code": "13501",
        "name": "Xã Bình Mỹ",
        "englishName": ""
      },
      {
        "code": "13504",
        "name": "Xã Bình Lục",
        "englishName": ""
      },
      {
        "code": "13531",
        "name": "Xã Bình Giang",
        "englishName": ""
      },
      {
        "code": "13540",
        "name": "Xã Bình An",
        "englishName": ""
      },
      {
        "code": "13558",
        "name": "Xã Bình Sơn",
        "englishName": ""
      },
      {
        "code": "13573",
        "name": "Xã Lý Nhân",
        "englishName": ""
      },
      {
        "code": "13579",
        "name": "Xã Bắc Lý",
        "englishName": ""
      },
      {
        "code": "13591",
        "name": "Xã Nam Xang",
        "englishName": ""
      },
      {
        "code": "13594",
        "name": "Xã Trần Thương",
        "englishName": ""
      },
      {
        "code": "13597",
        "name": "Xã Vĩnh Trụ",
        "englishName": ""
      },
      {
        "code": "13609",
        "name": "Xã Nhân Hà",
        "englishName": ""
      },
      {
        "code": "13627",
        "name": "Xã Nam Lý",
        "englishName": ""
      },
      {
        "code": "13669",
        "name": "Phường Nam Định",
        "englishName": ""
      },
      {
        "code": "13684",
        "name": "Phường Thiên Trường",
        "englishName": ""
      },
      {
        "code": "13693",
        "name": "Phường Đông A",
        "englishName": ""
      },
      {
        "code": "13699",
        "name": "Phường Thành Nam",
        "englishName": ""
      },
      {
        "code": "13708",
        "name": "Phường Mỹ Lộc",
        "englishName": ""
      },
      {
        "code": "13741",
        "name": "Xã Vụ Bản",
        "englishName": ""
      },
      {
        "code": "13750",
        "name": "Xã Minh Tân",
        "englishName": ""
      },
      {
        "code": "13753",
        "name": "Xã Hiển Khánh",
        "englishName": ""
      },
      {
        "code": "13777",
        "name": "Phường Trường Thi",
        "englishName": ""
      },
      {
        "code": "13786",
        "name": "Xã Liên Minh",
        "englishName": ""
      },
      {
        "code": "13795",
        "name": "Xã Ý Yên",
        "englishName": ""
      },
      {
        "code": "13807",
        "name": "Xã Tân Minh",
        "englishName": ""
      },
      {
        "code": "13822",
        "name": "Xã Phong Doanh",
        "englishName": ""
      },
      {
        "code": "13834",
        "name": "Xã Vũ Dương",
        "englishName": ""
      },
      {
        "code": "13864",
        "name": "Xã Vạn Thắng",
        "englishName": ""
      },
      {
        "code": "13870",
        "name": "Xã Yên Cường",
        "englishName": ""
      },
      {
        "code": "13879",
        "name": "Xã Yên Đồng",
        "englishName": ""
      },
      {
        "code": "13891",
        "name": "Xã Nghĩa Hưng",
        "englishName": ""
      },
      {
        "code": "13894",
        "name": "Xã Rạng Đông",
        "englishName": ""
      },
      {
        "code": "13900",
        "name": "Xã Đồng Thịnh",
        "englishName": ""
      },
      {
        "code": "13918",
        "name": "Xã Nghĩa Sơn",
        "englishName": ""
      },
      {
        "code": "13927",
        "name": "Xã Hồng Phong",
        "englishName": ""
      },
      {
        "code": "13939",
        "name": "Xã Quỹ Nhất",
        "englishName": ""
      },
      {
        "code": "13957",
        "name": "Xã Nghĩa Lâm",
        "englishName": ""
      },
      {
        "code": "13966",
        "name": "Xã Nam Trực",
        "englishName": ""
      },
      {
        "code": "13972",
        "name": "Phường Vị Khê",
        "englishName": ""
      },
      {
        "code": "13984",
        "name": "Phường Hồng Quang",
        "englishName": ""
      },
      {
        "code": "13987",
        "name": "Xã Nam Hồng",
        "englishName": ""
      },
      {
        "code": "14005",
        "name": "Xã Nam Ninh",
        "englishName": ""
      },
      {
        "code": "14011",
        "name": "Xã Nam Minh",
        "englishName": ""
      },
      {
        "code": "14014",
        "name": "Xã Nam Đồng",
        "englishName": ""
      },
      {
        "code": "14026",
        "name": "Xã Cổ Lễ",
        "englishName": ""
      },
      {
        "code": "14038",
        "name": "Xã Ninh Giang",
        "englishName": ""
      },
      {
        "code": "14053",
        "name": "Xã Trực Ninh",
        "englishName": ""
      },
      {
        "code": "14056",
        "name": "Xã Cát Thành",
        "englishName": "Cat Thanh town"
      },
      {
        "code": "14062",
        "name": "Xã Quang Hưng",
        "englishName": ""
      },
      {
        "code": "14071",
        "name": "Xã Minh Thái",
        "englishName": ""
      },
      {
        "code": "14077",
        "name": "Xã Ninh Cường",
        "englishName": ""
      },
      {
        "code": "14089",
        "name": "Xã Xuân Trường",
        "englishName": ""
      },
      {
        "code": "14095",
        "name": "Xã Xuân Hồng",
        "englishName": ""
      },
      {
        "code": "14104",
        "name": "Xã Xuân Giang",
        "englishName": ""
      },
      {
        "code": "14122",
        "name": "Xã Xuân Hưng",
        "englishName": ""
      },
      {
        "code": "14161",
        "name": "Xã Giao Minh",
        "englishName": ""
      },
      {
        "code": "14167",
        "name": "Xã Giao Thuỷ",
        "englishName": ""
      },
      {
        "code": "14179",
        "name": "Xã Giao Hưng",
        "englishName": ""
      },
      {
        "code": "14182",
        "name": "Xã Giao Hoà",
        "englishName": ""
      },
      {
        "code": "14194",
        "name": "Xã Giao Bình",
        "englishName": ""
      },
      {
        "code": "14203",
        "name": "Xã Giao Phúc",
        "englishName": ""
      },
      {
        "code": "14212",
        "name": "Xã Giao Ninh",
        "englishName": ""
      },
      {
        "code": "14215",
        "name": "Xã Hải Hậu",
        "englishName": ""
      },
      {
        "code": "14218",
        "name": "Xã Hải Tiến",
        "englishName": ""
      },
      {
        "code": "14221",
        "name": "Xã Hải Thịnh",
        "englishName": ""
      },
      {
        "code": "14236",
        "name": "Xã Hải Anh",
        "englishName": ""
      },
      {
        "code": "14248",
        "name": "Xã Hải Hưng",
        "englishName": ""
      },
      {
        "code": "14281",
        "name": "Xã Hải An",
        "englishName": ""
      },
      {
        "code": "14287",
        "name": "Xã Hải Quang",
        "englishName": ""
      },
      {
        "code": "14308",
        "name": "Xã Hải Xuân",
        "englishName": ""
      },
      {
        "code": "14329",
        "name": "Phường Hoa Lư",
        "englishName": ""
      },
      {
        "code": "14359",
        "name": "Phường Nam Hoa Lư",
        "englishName": ""
      },
      {
        "code": "14362",
        "name": "Phường Tam Điệp",
        "englishName": ""
      },
      {
        "code": "14365",
        "name": "Phường Trung Sơn",
        "englishName": ""
      },
      {
        "code": "14371",
        "name": "Phường Yên Sơn",
        "englishName": ""
      },
      {
        "code": "14389",
        "name": "Xã Gia Lâm",
        "englishName": ""
      },
      {
        "code": "14401",
        "name": "Xã Gia Tường",
        "englishName": ""
      },
      {
        "code": "14404",
        "name": "Xã Cúc Phương",
        "englishName": ""
      },
      {
        "code": "14407",
        "name": "Xã Phú Sơn",
        "englishName": ""
      },
      {
        "code": "14428",
        "name": "Xã Nho Quan",
        "englishName": ""
      },
      {
        "code": "14434",
        "name": "Xã Thanh Sơn",
        "englishName": ""
      },
      {
        "code": "14452",
        "name": "Xã Quỳnh Lưu",
        "englishName": ""
      },
      {
        "code": "14458",
        "name": "Xã Phú Long",
        "englishName": ""
      },
      {
        "code": "14464",
        "name": "Xã Gia Viễn",
        "englishName": ""
      },
      {
        "code": "14482",
        "name": "Xã Gia Hưng",
        "englishName": ""
      },
      {
        "code": "14488",
        "name": "Xã Gia Vân",
        "englishName": ""
      },
      {
        "code": "14494",
        "name": "Xã Gia Trấn",
        "englishName": ""
      },
      {
        "code": "14500",
        "name": "Xã Đại Hoàng",
        "englishName": ""
      },
      {
        "code": "14524",
        "name": "Xã Gia Phong",
        "englishName": ""
      },
      {
        "code": "14533",
        "name": "Phường Tây Hoa Lư",
        "englishName": ""
      },
      {
        "code": "14560",
        "name": "Xã Yên Khánh",
        "englishName": ""
      },
      {
        "code": "14563",
        "name": "Xã Khánh Thiện",
        "englishName": ""
      },
      {
        "code": "14566",
        "name": "Phường Đông Hoa Lư",
        "englishName": ""
      },
      {
        "code": "14608",
        "name": "Xã Khánh Trung",
        "englishName": ""
      },
      {
        "code": "14611",
        "name": "Xã Khánh Nhạc",
        "englishName": ""
      },
      {
        "code": "14614",
        "name": "Xã Khánh Hội",
        "englishName": ""
      },
      {
        "code": "14620",
        "name": "Xã Phát Diệm",
        "englishName": ""
      },
      {
        "code": "14623",
        "name": "Xã Bình Minh",
        "englishName": ""
      },
      {
        "code": "14638",
        "name": "Xã Kim Sơn",
        "englishName": ""
      },
      {
        "code": "14647",
        "name": "Xã Quang Thiện",
        "englishName": ""
      },
      {
        "code": "14653",
        "name": "Xã Chất Bình",
        "englishName": ""
      },
      {
        "code": "14674",
        "name": "Xã Lai Thành",
        "englishName": ""
      },
      {
        "code": "14677",
        "name": "Xã Định Hóa",
        "englishName": ""
      },
      {
        "code": "14698",
        "name": "Xã Kim Đông",
        "englishName": ""
      },
      {
        "code": "14701",
        "name": "Xã Yên Mô",
        "englishName": ""
      },
      {
        "code": "14725",
        "name": "Phường Yên Thắng",
        "englishName": ""
      },
      {
        "code": "14728",
        "name": "Xã Yên Từ",
        "englishName": ""
      },
      {
        "code": "14743",
        "name": "Xã Yên Mạc",
        "englishName": ""
      },
      {
        "code": "14746",
        "name": "Xã Đồng Thái",
        "englishName": ""
      }
    ]
  },
  {
    "code": "38",
    "name": "Tỉnh Thanh Hóa",
    "englishName": "",
    "administrativeLevel": "Tỉnh",
    "communes": [
      {
        "code": "14758",
        "name": "Phường Hàm Rồng",
        "englishName": ""
      },
      {
        "code": "14797",
        "name": "Phường Hạc Thành",
        "englishName": ""
      },
      {
        "code": "14812",
        "name": "Phường Bỉm Sơn",
        "englishName": ""
      },
      {
        "code": "14818",
        "name": "Phường Quang Trung",
        "englishName": ""
      },
      {
        "code": "14845",
        "name": "Xã Mường Lát",
        "englishName": ""
      },
      {
        "code": "14848",
        "name": "Xã Tam Chung",
        "englishName": ""
      },
      {
        "code": "14854",
        "name": "Xã Mường Lý",
        "englishName": ""
      },
      {
        "code": "14857",
        "name": "Xã Trung Lý",
        "englishName": ""
      },
      {
        "code": "14860",
        "name": "Xã Quang Chiểu",
        "englishName": ""
      },
      {
        "code": "14863",
        "name": "Xã Pù Nhi",
        "englishName": ""
      },
      {
        "code": "14864",
        "name": "Xã Nhi Sơn",
        "englishName": ""
      },
      {
        "code": "14866",
        "name": "Xã Mường Chanh",
        "englishName": ""
      },
      {
        "code": "14869",
        "name": "Xã Hồi Xuân",
        "englishName": ""
      },
      {
        "code": "14872",
        "name": "Xã Trung Thành",
        "englishName": ""
      },
      {
        "code": "14875",
        "name": "Xã Trung Sơn",
        "englishName": ""
      },
      {
        "code": "14878",
        "name": "Xã Phú Lệ",
        "englishName": ""
      },
      {
        "code": "14890",
        "name": "Xã Phú Xuân",
        "englishName": ""
      },
      {
        "code": "14896",
        "name": "Xã Hiền Kiệt",
        "englishName": ""
      },
      {
        "code": "14902",
        "name": "Xã Nam Xuân",
        "englishName": ""
      },
      {
        "code": "14908",
        "name": "Xã Thiên Phủ",
        "englishName": ""
      },
      {
        "code": "14923",
        "name": "Xã Bá Thước",
        "englishName": ""
      },
      {
        "code": "14932",
        "name": "Xã Điền Quang",
        "englishName": ""
      },
      {
        "code": "14950",
        "name": "Xã Điền Lư",
        "englishName": ""
      },
      {
        "code": "14953",
        "name": "Xã Quý Lương",
        "englishName": ""
      },
      {
        "code": "14956",
        "name": "Xã Pù Luông",
        "englishName": ""
      },
      {
        "code": "14959",
        "name": "Xã Cổ Lũng",
        "englishName": ""
      },
      {
        "code": "14974",
        "name": "Xã Văn Nho",
        "englishName": ""
      },
      {
        "code": "14980",
        "name": "Xã Thiết Ống",
        "englishName": ""
      },
      {
        "code": "15001",
        "name": "Xã Trung Hạ",
        "englishName": ""
      },
      {
        "code": "15007",
        "name": "Xã Tam Thanh",
        "englishName": ""
      },
      {
        "code": "15010",
        "name": "Xã Sơn Thủy",
        "englishName": ""
      },
      {
        "code": "15013",
        "name": "Xã Na Mèo",
        "englishName": ""
      },
      {
        "code": "15016",
        "name": "Xã Quan Sơn",
        "englishName": ""
      },
      {
        "code": "15019",
        "name": "Xã Tam Lư",
        "englishName": ""
      },
      {
        "code": "15022",
        "name": "Xã Sơn Điện",
        "englishName": ""
      },
      {
        "code": "15025",
        "name": "Xã Mường Mìn",
        "englishName": ""
      },
      {
        "code": "15031",
        "name": "Xã Yên Khương",
        "englishName": ""
      },
      {
        "code": "15034",
        "name": "Xã Yên Thắng",
        "englishName": ""
      },
      {
        "code": "15043",
        "name": "Xã Giao An",
        "englishName": ""
      },
      {
        "code": "15049",
        "name": "Xã Văn Phú",
        "englishName": ""
      },
      {
        "code": "15055",
        "name": "Xã Linh Sơn",
        "englishName": ""
      },
      {
        "code": "15058",
        "name": "Xã Đồng Lương",
        "englishName": ""
      },
      {
        "code": "15061",
        "name": "Xã Ngọc Lặc",
        "englishName": ""
      },
      {
        "code": "15085",
        "name": "Xã Thạch Lập",
        "englishName": ""
      },
      {
        "code": "15091",
        "name": "Xã Ngọc Liên",
        "englishName": ""
      },
      {
        "code": "15106",
        "name": "Xã Nguyệt Ấn",
        "englishName": ""
      },
      {
        "code": "15112",
        "name": "Xã Kiên Thọ",
        "englishName": ""
      },
      {
        "code": "15124",
        "name": "Xã Minh Sơn",
        "englishName": ""
      },
      {
        "code": "15127",
        "name": "Xã Cẩm Thủy",
        "englishName": ""
      },
      {
        "code": "15142",
        "name": "Xã Cẩm Thạch",
        "englishName": ""
      },
      {
        "code": "15148",
        "name": "Xã Cẩm Tú",
        "englishName": ""
      },
      {
        "code": "15163",
        "name": "Xã Cẩm Vân",
        "englishName": ""
      },
      {
        "code": "15178",
        "name": "Xã Cẩm Tân",
        "englishName": ""
      },
      {
        "code": "15187",
        "name": "Xã Kim Tân",
        "englishName": ""
      },
      {
        "code": "15190",
        "name": "Xã Vân Du",
        "englishName": ""
      },
      {
        "code": "15199",
        "name": "Xã Thạch Quảng",
        "englishName": ""
      },
      {
        "code": "15211",
        "name": "Xã Thạch Bình",
        "englishName": ""
      },
      {
        "code": "15229",
        "name": "Xã Thành Vinh",
        "englishName": ""
      },
      {
        "code": "15250",
        "name": "Xã Ngọc Trạo",
        "englishName": ""
      },
      {
        "code": "15271",
        "name": "Xã Hà Trung",
        "englishName": ""
      },
      {
        "code": "15274",
        "name": "Xã Hà Long",
        "englishName": ""
      },
      {
        "code": "15286",
        "name": "Xã Hoạt Giang",
        "englishName": ""
      },
      {
        "code": "15298",
        "name": "Xã Lĩnh Toại",
        "englishName": ""
      },
      {
        "code": "15316",
        "name": "Xã Tống Sơn",
        "englishName": ""
      },
      {
        "code": "15349",
        "name": "Xã Vĩnh Lộc",
        "englishName": ""
      },
      {
        "code": "15361",
        "name": "Xã Tây Đô",
        "englishName": ""
      },
      {
        "code": "15382",
        "name": "Xã Biện Thượng",
        "englishName": ""
      },
      {
        "code": "15409",
        "name": "Xã Yên Phú",
        "englishName": ""
      },
      {
        "code": "15412",
        "name": "Xã Quý Lộc",
        "englishName": ""
      },
      {
        "code": "15421",
        "name": "Xã Yên Trường",
        "englishName": ""
      },
      {
        "code": "15442",
        "name": "Xã Yên Ninh",
        "englishName": ""
      },
      {
        "code": "15448",
        "name": "Xã Định Hòa",
        "englishName": ""
      },
      {
        "code": "15457",
        "name": "Xã Định Tân",
        "englishName": ""
      },
      {
        "code": "15469",
        "name": "Xã Yên Định",
        "englishName": ""
      },
      {
        "code": "15499",
        "name": "Xã Thọ Xuân",
        "englishName": ""
      },
      {
        "code": "15505",
        "name": "Xã Thọ Long",
        "englishName": ""
      },
      {
        "code": "15520",
        "name": "Xã Xuân Hòa",
        "englishName": ""
      },
      {
        "code": "15544",
        "name": "Xã Lam Sơn",
        "englishName": ""
      },
      {
        "code": "15553",
        "name": "Xã Sao Vàng",
        "englishName": ""
      },
      {
        "code": "15568",
        "name": "Xã Thọ Lập",
        "englishName": ""
      },
      {
        "code": "15574",
        "name": "Xã Xuân Tín",
        "englishName": ""
      },
      {
        "code": "15592",
        "name": "Xã Xuân Lập",
        "englishName": ""
      },
      {
        "code": "15607",
        "name": "Xã Bát Mọt",
        "englishName": ""
      },
      {
        "code": "15610",
        "name": "Xã Yên Nhân",
        "englishName": ""
      },
      {
        "code": "15622",
        "name": "Xã Vạn Xuân",
        "englishName": ""
      },
      {
        "code": "15628",
        "name": "Xã Lương Sơn",
        "englishName": ""
      },
      {
        "code": "15634",
        "name": "Xã Luận Thành",
        "englishName": ""
      },
      {
        "code": "15643",
        "name": "Xã Thắng Lộc",
        "englishName": ""
      },
      {
        "code": "15646",
        "name": "Xã Thường Xuân",
        "englishName": ""
      },
      {
        "code": "15658",
        "name": "Xã Xuân Chinh",
        "englishName": ""
      },
      {
        "code": "15661",
        "name": "Xã Tân Thành",
        "englishName": ""
      },
      {
        "code": "15664",
        "name": "Xã Triệu Sơn",
        "englishName": ""
      },
      {
        "code": "15667",
        "name": "Xã Thọ Bình",
        "englishName": ""
      },
      {
        "code": "15682",
        "name": "Xã Hợp Tiến",
        "englishName": ""
      },
      {
        "code": "15715",
        "name": "Xã Tân Ninh",
        "englishName": ""
      },
      {
        "code": "15724",
        "name": "Xã Đồng Tiến",
        "englishName": ""
      },
      {
        "code": "15754",
        "name": "Xã Thọ Ngọc",
        "englishName": ""
      },
      {
        "code": "15763",
        "name": "Xã Thọ Phú",
        "englishName": ""
      },
      {
        "code": "15766",
        "name": "Xã An Nông",
        "englishName": ""
      },
      {
        "code": "15772",
        "name": "Xã Thiệu Hóa",
        "englishName": ""
      },
      {
        "code": "15778",
        "name": "Xã Thiệu Tiến",
        "englishName": ""
      },
      {
        "code": "15796",
        "name": "Xã Thiệu Quang",
        "englishName": ""
      },
      {
        "code": "15820",
        "name": "Xã Thiệu Toán",
        "englishName": ""
      },
      {
        "code": "15835",
        "name": "Xã Thiệu Trung",
        "englishName": ""
      },
      {
        "code": "15853",
        "name": "Phường Đông Tiến",
        "englishName": ""
      },
      {
        "code": "15865",
        "name": "Xã Hoằng Hóa",
        "englishName": ""
      },
      {
        "code": "15880",
        "name": "Xã Hoằng Giang",
        "englishName": ""
      },
      {
        "code": "15889",
        "name": "Xã Hoằng Phú",
        "englishName": ""
      },
      {
        "code": "15910",
        "name": "Xã Hoằng Sơn",
        "englishName": ""
      },
      {
        "code": "15925",
        "name": "Phường Nguyệt Viên",
        "englishName": ""
      },
      {
        "code": "15961",
        "name": "Xã Hoằng Lộc",
        "englishName": ""
      },
      {
        "code": "15976",
        "name": "Xã Hoằng Châu",
        "englishName": ""
      },
      {
        "code": "15991",
        "name": "Xã Hoằng Tiến",
        "englishName": ""
      },
      {
        "code": "16000",
        "name": "Xã Hoằng Thanh",
        "englishName": ""
      },
      {
        "code": "16012",
        "name": "Xã Hậu Lộc",
        "englishName": ""
      },
      {
        "code": "16021",
        "name": "Xã Triệu Lộc",
        "englishName": ""
      },
      {
        "code": "16033",
        "name": "Xã Đông Thành",
        "englishName": ""
      },
      {
        "code": "16072",
        "name": "Xã Hoa Lộc",
        "englishName": ""
      },
      {
        "code": "16078",
        "name": "Xã Vạn Lộc",
        "englishName": ""
      },
      {
        "code": "16093",
        "name": "Xã Nga Sơn",
        "englishName": ""
      },
      {
        "code": "16108",
        "name": "Xã Tân Tiến",
        "englishName": ""
      },
      {
        "code": "16114",
        "name": "Xã Nga Thắng",
        "englishName": ""
      },
      {
        "code": "16138",
        "name": "Xã Hồ Vương",
        "englishName": ""
      },
      {
        "code": "16144",
        "name": "Xã Nga An",
        "englishName": ""
      },
      {
        "code": "16171",
        "name": "Xã Ba Đình",
        "englishName": ""
      },
      {
        "code": "16174",
        "name": "Xã Như Xuân",
        "englishName": ""
      },
      {
        "code": "16177",
        "name": "Xã Xuân Bình",
        "englishName": ""
      },
      {
        "code": "16186",
        "name": "Xã Hóa Quỳ",
        "englishName": ""
      },
      {
        "code": "16213",
        "name": "Xã Thanh Phong",
        "englishName": ""
      },
      {
        "code": "16222",
        "name": "Xã Thanh Quân",
        "englishName": ""
      },
      {
        "code": "16225",
        "name": "Xã Thượng Ninh",
        "englishName": ""
      },
      {
        "code": "16228",
        "name": "Xã Như Thanh",
        "englishName": ""
      },
      {
        "code": "16234",
        "name": "Xã Xuân Du",
        "englishName": ""
      },
      {
        "code": "16249",
        "name": "Xã Mậu Lâm",
        "englishName": ""
      },
      {
        "code": "16258",
        "name": "Xã Xuân Thái",
        "englishName": ""
      },
      {
        "code": "16264",
        "name": "Xã Yên Thọ",
        "englishName": ""
      },
      {
        "code": "16273",
        "name": "Xã Thanh Kỳ",
        "englishName": ""
      },
      {
        "code": "16279",
        "name": "Xã Nông Cống",
        "englishName": ""
      },
      {
        "code": "16297",
        "name": "Xã Trung Chính",
        "englishName": ""
      },
      {
        "code": "16309",
        "name": "Xã Thắng Lợi",
        "englishName": ""
      },
      {
        "code": "16342",
        "name": "Xã Thăng Bình",
        "englishName": ""
      },
      {
        "code": "16348",
        "name": "Xã Trường Văn",
        "englishName": ""
      },
      {
        "code": "16363",
        "name": "Xã Tượng Lĩnh",
        "englishName": ""
      },
      {
        "code": "16369",
        "name": "Xã Công Chính",
        "englishName": ""
      },
      {
        "code": "16378",
        "name": "Phường Đông Sơn",
        "englishName": ""
      },
      {
        "code": "16417",
        "name": "Phường Đông Quang",
        "englishName": ""
      },
      {
        "code": "16438",
        "name": "Xã Lưu Vệ",
        "englishName": ""
      },
      {
        "code": "16480",
        "name": "Xã Quảng Yên",
        "englishName": ""
      },
      {
        "code": "16489",
        "name": "Xã Quảng Chính",
        "englishName": ""
      },
      {
        "code": "16498",
        "name": "Xã Quảng Ngọc",
        "englishName": ""
      },
      {
        "code": "16516",
        "name": "Phường Nam Sầm Sơn",
        "englishName": ""
      },
      {
        "code": "16522",
        "name": "Phường Quảng Phú",
        "englishName": ""
      },
      {
        "code": "16531",
        "name": "Phường Sầm Sơn",
        "englishName": ""
      },
      {
        "code": "16540",
        "name": "Xã Quảng Ninh",
        "englishName": ""
      },
      {
        "code": "16543",
        "name": "Xã Quảng Bình",
        "englishName": ""
      },
      {
        "code": "16549",
        "name": "Xã Tiên Trang",
        "englishName": ""
      },
      {
        "code": "16561",
        "name": "Phường Tĩnh Gia",
        "englishName": ""
      },
      {
        "code": "16576",
        "name": "Phường Ngọc Sơn",
        "englishName": ""
      },
      {
        "code": "16591",
        "name": "Xã Các Sơn",
        "englishName": ""
      },
      {
        "code": "16594",
        "name": "Phường Tân Dân",
        "englishName": ""
      },
      {
        "code": "16597",
        "name": "Phường Hải Lĩnh",
        "englishName": ""
      },
      {
        "code": "16609",
        "name": "Phường Đào Duy Từ",
        "englishName": ""
      },
      {
        "code": "16624",
        "name": "Phường Trúc Lâm",
        "englishName": ""
      },
      {
        "code": "16636",
        "name": "Xã Trường Lâm",
        "englishName": ""
      },
      {
        "code": "16645",
        "name": "Phường Hải Bình",
        "englishName": ""
      },
      {
        "code": "16654",
        "name": "Phường Nghi Sơn",
        "englishName": ""
      }
    ]
  },
  {
    "code": "40",
    "name": "Tỉnh Nghệ An",
    "englishName": "",
    "administrativeLevel": "Tỉnh",
    "communes": [
      {
        "code": "16681",
        "name": "Phường Thành Vinh",
        "englishName": ""
      },
      {
        "code": "16690",
        "name": "Phường Trường Vinh",
        "englishName": ""
      },
      {
        "code": "16702",
        "name": "Phường Vinh Phú",
        "englishName": ""
      },
      {
        "code": "16708",
        "name": "Phường Vinh Lộc",
        "englishName": ""
      },
      {
        "code": "16732",
        "name": "Phường Cửa Lò",
        "englishName": ""
      },
      {
        "code": "16738",
        "name": "Xã Quế Phong",
        "englishName": ""
      },
      {
        "code": "16744",
        "name": "Xã Thông Thụ",
        "englishName": ""
      },
      {
        "code": "16750",
        "name": "Xã Tiền Phong",
        "englishName": ""
      },
      {
        "code": "16756",
        "name": "Xã Tri Lễ",
        "englishName": ""
      },
      {
        "code": "16774",
        "name": "Xã Mường Quàng",
        "englishName": ""
      },
      {
        "code": "16777",
        "name": "Xã Quỳ Châu",
        "englishName": ""
      },
      {
        "code": "16792",
        "name": "Xã Châu Tiến",
        "englishName": ""
      },
      {
        "code": "16801",
        "name": "Xã Hùng Chân",
        "englishName": ""
      },
      {
        "code": "16804",
        "name": "Xã Châu Bình",
        "englishName": ""
      },
      {
        "code": "16813",
        "name": "Xã Mường Xén",
        "englishName": ""
      },
      {
        "code": "16816",
        "name": "Xã Mỹ Lý",
        "englishName": ""
      },
      {
        "code": "16819",
        "name": "Xã Bắc Lý",
        "englishName": ""
      },
      {
        "code": "16822",
        "name": "Xã Keng Đu",
        "englishName": ""
      },
      {
        "code": "16828",
        "name": "Xã Huồi Tụ",
        "englishName": ""
      },
      {
        "code": "16831",
        "name": "Xã Mường Lống",
        "englishName": ""
      },
      {
        "code": "16834",
        "name": "Xã Na Loi",
        "englishName": ""
      },
      {
        "code": "16837",
        "name": "Xã Nậm Cắn",
        "englishName": ""
      },
      {
        "code": "16849",
        "name": "Xã Hữu Kiệm",
        "englishName": ""
      },
      {
        "code": "16855",
        "name": "Xã Chiêu Lưu",
        "englishName": ""
      },
      {
        "code": "16858",
        "name": "Xã Mường Típ",
        "englishName": ""
      },
      {
        "code": "16870",
        "name": "Xã Na Ngoi",
        "englishName": ""
      },
      {
        "code": "16876",
        "name": "Xã Tương Dương",
        "englishName": ""
      },
      {
        "code": "16882",
        "name": "Xã Nhôn Mai",
        "englishName": ""
      },
      {
        "code": "16885",
        "name": "Xã Hữu Khuông",
        "englishName": ""
      },
      {
        "code": "16903",
        "name": "Xã Nga My",
        "englishName": ""
      },
      {
        "code": "16906",
        "name": "Xã Lượng Minh",
        "englishName": ""
      },
      {
        "code": "16909",
        "name": "Xã Yên Hòa",
        "englishName": ""
      },
      {
        "code": "16912",
        "name": "Xã Yên Na",
        "englishName": ""
      },
      {
        "code": "16933",
        "name": "Xã Tam Quang",
        "englishName": ""
      },
      {
        "code": "16936",
        "name": "Xã Tam Thái",
        "englishName": ""
      },
      {
        "code": "16939",
        "name": "Phường Thái Hòa",
        "englishName": ""
      },
      {
        "code": "16941",
        "name": "Xã Nghĩa Đàn",
        "englishName": ""
      },
      {
        "code": "16951",
        "name": "Xã Nghĩa Lâm",
        "englishName": ""
      },
      {
        "code": "16969",
        "name": "Xã Nghĩa Thọ",
        "englishName": ""
      },
      {
        "code": "16972",
        "name": "Xã Nghĩa Hưng",
        "englishName": ""
      },
      {
        "code": "16975",
        "name": "Xã Nghĩa Mai",
        "englishName": ""
      },
      {
        "code": "17011",
        "name": "Phường Tây Hiếu",
        "englishName": ""
      },
      {
        "code": "17017",
        "name": "Xã Đông Hiếu",
        "englishName": ""
      },
      {
        "code": "17029",
        "name": "Xã Nghĩa Lộc",
        "englishName": ""
      },
      {
        "code": "17032",
        "name": "Xã Nghĩa Khánh",
        "englishName": ""
      },
      {
        "code": "17035",
        "name": "Xã Quỳ Hợp",
        "englishName": ""
      },
      {
        "code": "17044",
        "name": "Xã Châu Hồng",
        "englishName": ""
      },
      {
        "code": "17056",
        "name": "Xã Châu Lộc",
        "englishName": ""
      },
      {
        "code": "17059",
        "name": "Xã Tam Hợp",
        "englishName": ""
      },
      {
        "code": "17071",
        "name": "Xã Minh Hợp",
        "englishName": ""
      },
      {
        "code": "17077",
        "name": "Xã Mường Ham",
        "englishName": ""
      },
      {
        "code": "17089",
        "name": "Xã Mường Chọng",
        "englishName": ""
      },
      {
        "code": "17110",
        "name": "Phường Hoàng Mai",
        "englishName": "Hoang Mai town"
      },
      {
        "code": "17125",
        "name": "Phường Quỳnh Mai",
        "englishName": ""
      },
      {
        "code": "17128",
        "name": "Phường Tân Mai",
        "englishName": ""
      },
      {
        "code": "17143",
        "name": "Xã Quỳnh Văn",
        "englishName": ""
      },
      {
        "code": "17149",
        "name": "Xã Quỳnh Tam",
        "englishName": ""
      },
      {
        "code": "17170",
        "name": "Xã Quỳnh Sơn",
        "englishName": ""
      },
      {
        "code": "17176",
        "name": "Xã Quỳnh Anh",
        "englishName": ""
      },
      {
        "code": "17179",
        "name": "Xã Quỳnh Lưu",
        "englishName": ""
      },
      {
        "code": "17212",
        "name": "Xã Quỳnh Phú",
        "englishName": ""
      },
      {
        "code": "17224",
        "name": "Xã Quỳnh Thắng",
        "englishName": ""
      },
      {
        "code": "17230",
        "name": "Xã Bình Chuẩn",
        "englishName": ""
      },
      {
        "code": "17239",
        "name": "Xã Mậu Thạch",
        "englishName": ""
      },
      {
        "code": "17242",
        "name": "Xã Cam Phục",
        "englishName": ""
      },
      {
        "code": "17248",
        "name": "Xã Châu Khê",
        "englishName": ""
      },
      {
        "code": "17254",
        "name": "Xã Con Cuông",
        "englishName": ""
      },
      {
        "code": "17263",
        "name": "Xã Môn Sơn",
        "englishName": ""
      },
      {
        "code": "17266",
        "name": "Xã Tân Kỳ",
        "englishName": ""
      },
      {
        "code": "17272",
        "name": "Xã Tân Phú",
        "englishName": ""
      },
      {
        "code": "17278",
        "name": "Xã Giai Xuân",
        "englishName": ""
      },
      {
        "code": "17284",
        "name": "Xã Nghĩa Đồng",
        "englishName": ""
      },
      {
        "code": "17287",
        "name": "Xã Tiên Đồng",
        "englishName": ""
      },
      {
        "code": "17305",
        "name": "Xã Tân An",
        "englishName": ""
      },
      {
        "code": "17326",
        "name": "Xã Nghĩa Hành",
        "englishName": ""
      },
      {
        "code": "17329",
        "name": "Xã Anh Sơn",
        "englishName": ""
      },
      {
        "code": "17335",
        "name": "Xã Thành Bình Thọ",
        "englishName": ""
      },
      {
        "code": "17344",
        "name": "Xã Nhân Hòa",
        "englishName": ""
      },
      {
        "code": "17357",
        "name": "Xã Vĩnh Tường",
        "englishName": ""
      },
      {
        "code": "17365",
        "name": "Xã Anh Sơn Đông",
        "englishName": ""
      },
      {
        "code": "17380",
        "name": "Xã Yên Xuân",
        "englishName": ""
      },
      {
        "code": "17395",
        "name": "Xã Hùng Châu",
        "englishName": ""
      },
      {
        "code": "17416",
        "name": "Xã Đức Châu",
        "englishName": ""
      },
      {
        "code": "17419",
        "name": "Xã Hải Châu",
        "englishName": ""
      },
      {
        "code": "17443",
        "name": "Xã Quảng Châu",
        "englishName": ""
      },
      {
        "code": "17464",
        "name": "Xã Diễn Châu",
        "englishName": ""
      },
      {
        "code": "17476",
        "name": "Xã Minh Châu",
        "englishName": ""
      },
      {
        "code": "17479",
        "name": "Xã An Châu",
        "englishName": ""
      },
      {
        "code": "17488",
        "name": "Xã Tân Châu",
        "englishName": ""
      },
      {
        "code": "17506",
        "name": "Xã Yên Thành",
        "englishName": ""
      },
      {
        "code": "17515",
        "name": "Xã Bình Minh",
        "englishName": ""
      },
      {
        "code": "17521",
        "name": "Xã Quang Đồng",
        "englishName": ""
      },
      {
        "code": "17524",
        "name": "Xã Giai Lạc",
        "englishName": ""
      },
      {
        "code": "17530",
        "name": "Xã Đông Thành",
        "englishName": ""
      },
      {
        "code": "17560",
        "name": "Xã Vân Du",
        "englishName": ""
      },
      {
        "code": "17569",
        "name": "Xã Quan Thành",
        "englishName": ""
      },
      {
        "code": "17605",
        "name": "Xã Hợp Minh",
        "englishName": ""
      },
      {
        "code": "17611",
        "name": "Xã Vân Tụ",
        "englishName": ""
      },
      {
        "code": "17623",
        "name": "Xã Bạch Ngọc",
        "englishName": ""
      },
      {
        "code": "17641",
        "name": "Xã Lương Sơn",
        "englishName": ""
      },
      {
        "code": "17662",
        "name": "Xã Đô Lương",
        "englishName": ""
      },
      {
        "code": "17677",
        "name": "Xã Văn Hiến",
        "englishName": ""
      },
      {
        "code": "17689",
        "name": "Xã Thuần Trung",
        "englishName": ""
      },
      {
        "code": "17707",
        "name": "Xã Bạch Hà",
        "englishName": ""
      },
      {
        "code": "17713",
        "name": "Xã Đại Đồng",
        "englishName": ""
      },
      {
        "code": "17722",
        "name": "Xã Hạnh Lâm",
        "englishName": ""
      },
      {
        "code": "17728",
        "name": "Xã Cát Ngạn",
        "englishName": ""
      },
      {
        "code": "17743",
        "name": "Xã Tam Đồng",
        "englishName": ""
      },
      {
        "code": "17759",
        "name": "Xã Sơn Lâm",
        "englishName": ""
      },
      {
        "code": "17770",
        "name": "Xã Hoa Quân",
        "englishName": ""
      },
      {
        "code": "17779",
        "name": "Xã Xuân Lâm",
        "englishName": ""
      },
      {
        "code": "17791",
        "name": "Xã Kim Bảng",
        "englishName": ""
      },
      {
        "code": "17818",
        "name": "Xã Bích Hào",
        "englishName": ""
      },
      {
        "code": "17827",
        "name": "Xã Nghi Lộc",
        "englishName": ""
      },
      {
        "code": "17833",
        "name": "Xã Hải Lộc",
        "englishName": ""
      },
      {
        "code": "17842",
        "name": "Xã Thần Lĩnh",
        "englishName": ""
      },
      {
        "code": "17854",
        "name": "Xã Văn Kiều",
        "englishName": ""
      },
      {
        "code": "17857",
        "name": "Xã Phúc Lộc",
        "englishName": ""
      },
      {
        "code": "17866",
        "name": "Xã Trung Lộc",
        "englishName": ""
      },
      {
        "code": "17878",
        "name": "Xã Đông Lộc",
        "englishName": ""
      },
      {
        "code": "17920",
        "name": "Phường Vinh Hưng",
        "englishName": ""
      },
      {
        "code": "17935",
        "name": "Xã Nam Đàn",
        "englishName": ""
      },
      {
        "code": "17944",
        "name": "Xã Đại Huệ",
        "englishName": ""
      },
      {
        "code": "17950",
        "name": "Xã Vạn An",
        "englishName": ""
      },
      {
        "code": "17971",
        "name": "Xã Kim Liên",
        "englishName": ""
      },
      {
        "code": "17989",
        "name": "Xã Thiên Nhẫn",
        "englishName": ""
      },
      {
        "code": "18001",
        "name": "Xã Hưng Nguyên",
        "englishName": ""
      },
      {
        "code": "18007",
        "name": "Xã Yên Trung",
        "englishName": ""
      },
      {
        "code": "18028",
        "name": "Xã Hưng Nguyên Nam",
        "englishName": ""
      },
      {
        "code": "18040",
        "name": "Xã Lam Thành",
        "englishName": ""
      }
    ]
  },
  {
    "code": "42",
    "name": "Tỉnh Hà Tĩnh",
    "englishName": "",
    "administrativeLevel": "Tỉnh",
    "communes": [
      {
        "code": "18073",
        "name": "Phường Thành Sen",
        "englishName": ""
      },
      {
        "code": "18100",
        "name": "Phường Trần Phú",
        "englishName": ""
      },
      {
        "code": "18115",
        "name": "Phường Bắc Hồng Lĩnh",
        "englishName": ""
      },
      {
        "code": "18118",
        "name": "Phường Nam Hồng Lĩnh",
        "englishName": ""
      },
      {
        "code": "18133",
        "name": "Xã Hương Sơn",
        "englishName": ""
      },
      {
        "code": "18160",
        "name": "Xã Sơn Hồng",
        "englishName": ""
      },
      {
        "code": "18163",
        "name": "Xã Sơn Tiến",
        "englishName": ""
      },
      {
        "code": "18172",
        "name": "Xã Sơn Tây",
        "englishName": ""
      },
      {
        "code": "18184",
        "name": "Xã Sơn Giang",
        "englishName": ""
      },
      {
        "code": "18196",
        "name": "Xã Sơn Kim 1",
        "englishName": ""
      },
      {
        "code": "18199",
        "name": "Xã Sơn Kim 2",
        "englishName": ""
      },
      {
        "code": "18202",
        "name": "Xã Tứ Mỹ",
        "englishName": ""
      },
      {
        "code": "18223",
        "name": "Xã Kim Hoa",
        "englishName": ""
      },
      {
        "code": "18229",
        "name": "Xã Đức Thọ",
        "englishName": ""
      },
      {
        "code": "18244",
        "name": "Xã Đức Minh",
        "englishName": ""
      },
      {
        "code": "18262",
        "name": "Xã Đức Quang",
        "englishName": ""
      },
      {
        "code": "18277",
        "name": "Xã Đức Thịnh",
        "englishName": ""
      },
      {
        "code": "18304",
        "name": "Xã Đức Đồng",
        "englishName": ""
      },
      {
        "code": "18313",
        "name": "Xã Vũ Quang",
        "englishName": ""
      },
      {
        "code": "18322",
        "name": "Xã Mai Hoa",
        "englishName": ""
      },
      {
        "code": "18328",
        "name": "Xã Thượng Đức",
        "englishName": ""
      },
      {
        "code": "18352",
        "name": "Xã Nghi Xuân",
        "englishName": ""
      },
      {
        "code": "18364",
        "name": "Xã Đan Hải",
        "englishName": ""
      },
      {
        "code": "18373",
        "name": "Xã Tiên Điền",
        "englishName": ""
      },
      {
        "code": "18394",
        "name": "Xã Cổ Đạm",
        "englishName": ""
      },
      {
        "code": "18406",
        "name": "Xã Can Lộc",
        "englishName": ""
      },
      {
        "code": "18409",
        "name": "Xã Hồng Lộc",
        "englishName": ""
      },
      {
        "code": "18418",
        "name": "Xã Tùng Lộc",
        "englishName": ""
      },
      {
        "code": "18436",
        "name": "Xã Trường Lưu",
        "englishName": ""
      },
      {
        "code": "18466",
        "name": "Xã Gia Hanh",
        "englishName": ""
      },
      {
        "code": "18481",
        "name": "Xã Xuân Lộc",
        "englishName": ""
      },
      {
        "code": "18484",
        "name": "Xã Đồng Lộc",
        "englishName": ""
      },
      {
        "code": "18496",
        "name": "Xã Hương Khê",
        "englishName": ""
      },
      {
        "code": "18502",
        "name": "Xã Hà Linh",
        "englishName": ""
      },
      {
        "code": "18523",
        "name": "Xã Hương Bình",
        "englishName": ""
      },
      {
        "code": "18532",
        "name": "Xã Hương Phố",
        "englishName": ""
      },
      {
        "code": "18544",
        "name": "Xã Hương Xuân",
        "englishName": ""
      },
      {
        "code": "18547",
        "name": "Xã Phúc Trạch",
        "englishName": ""
      },
      {
        "code": "18550",
        "name": "Xã Hương Đô",
        "englishName": ""
      },
      {
        "code": "18562",
        "name": "Xã Thạch Hà",
        "englishName": ""
      },
      {
        "code": "18568",
        "name": "Xã Lộc Hà",
        "englishName": ""
      },
      {
        "code": "18583",
        "name": "Xã Mai Phụ",
        "englishName": ""
      },
      {
        "code": "18586",
        "name": "Xã Đông Kinh",
        "englishName": ""
      },
      {
        "code": "18601",
        "name": "Xã Việt Xuyên",
        "englishName": ""
      },
      {
        "code": "18604",
        "name": "Xã Thạch Khê",
        "englishName": ""
      },
      {
        "code": "18619",
        "name": "Xã Đồng Tiến",
        "englishName": ""
      },
      {
        "code": "18628",
        "name": "Xã Thạch Lạc",
        "englishName": ""
      },
      {
        "code": "18634",
        "name": "Xã Toàn Lưu",
        "englishName": ""
      },
      {
        "code": "18652",
        "name": "Phường Hà Huy Tập",
        "englishName": ""
      },
      {
        "code": "18667",
        "name": "Xã Thạch Xuân",
        "englishName": ""
      },
      {
        "code": "18673",
        "name": "Xã Cẩm Xuyên",
        "englishName": ""
      },
      {
        "code": "18676",
        "name": "Xã Thiên Cầm",
        "englishName": ""
      },
      {
        "code": "18682",
        "name": "Xã Yên Hòa",
        "englishName": ""
      },
      {
        "code": "18685",
        "name": "Xã Cẩm Bình",
        "englishName": ""
      },
      {
        "code": "18736",
        "name": "Xã Cẩm Hưng",
        "englishName": ""
      },
      {
        "code": "18739",
        "name": "Xã Cẩm Duệ",
        "englishName": ""
      },
      {
        "code": "18742",
        "name": "Xã Cẩm Trung",
        "englishName": ""
      },
      {
        "code": "18748",
        "name": "Xã Cẩm Lạc",
        "englishName": ""
      },
      {
        "code": "18754",
        "name": "Phường Sông Trí",
        "englishName": ""
      },
      {
        "code": "18766",
        "name": "Xã Kỳ Xuân",
        "englishName": ""
      },
      {
        "code": "18775",
        "name": "Xã Kỳ Anh",
        "englishName": ""
      },
      {
        "code": "18781",
        "name": "Phường Hải Ninh",
        "englishName": ""
      },
      {
        "code": "18787",
        "name": "Xã Kỳ Văn",
        "englishName": ""
      },
      {
        "code": "18790",
        "name": "Xã Kỳ Khang",
        "englishName": ""
      },
      {
        "code": "18814",
        "name": "Xã Kỳ Hoa",
        "englishName": ""
      },
      {
        "code": "18823",
        "name": "Phường Vũng Áng",
        "englishName": ""
      },
      {
        "code": "18832",
        "name": "Phường Hoành Sơn",
        "englishName": ""
      },
      {
        "code": "18838",
        "name": "Xã Kỳ Lạc",
        "englishName": ""
      },
      {
        "code": "18844",
        "name": "Xã Kỳ Thượng",
        "englishName": ""
      }
    ]
  },
  {
    "code": "44",
    "name": "Tỉnh Quảng Trị",
    "englishName": "",
    "administrativeLevel": "Tỉnh",
    "communes": [
      {
        "code": "18859",
        "name": "Phường Đồng Thuận",
        "englishName": ""
      },
      {
        "code": "18871",
        "name": "Phường Đồng Sơn",
        "englishName": ""
      },
      {
        "code": "18880",
        "name": "Phường Đồng Hới",
        "englishName": ""
      },
      {
        "code": "18901",
        "name": "Xã Minh Hóa",
        "englishName": ""
      },
      {
        "code": "18904",
        "name": "Xã Dân Hóa",
        "englishName": ""
      },
      {
        "code": "18919",
        "name": "Xã Tân Thành",
        "englishName": ""
      },
      {
        "code": "18922",
        "name": "Xã Kim Điền",
        "englishName": ""
      },
      {
        "code": "18943",
        "name": "Xã Kim Phú",
        "englishName": ""
      },
      {
        "code": "18949",
        "name": "Xã Đồng Lê",
        "englishName": ""
      },
      {
        "code": "18952",
        "name": "Xã Tuyên Sơn",
        "englishName": ""
      },
      {
        "code": "18958",
        "name": "Xã Tuyên Lâm",
        "englishName": ""
      },
      {
        "code": "18985",
        "name": "Xã Tuyên Phú",
        "englishName": ""
      },
      {
        "code": "18991",
        "name": "Xã Tuyên Bình",
        "englishName": ""
      },
      {
        "code": "18997",
        "name": "Xã Tuyên Hóa",
        "englishName": ""
      },
      {
        "code": "19009",
        "name": "Phường Ba Đồn",
        "englishName": ""
      },
      {
        "code": "19021",
        "name": "Xã Phú Trạch",
        "englishName": ""
      },
      {
        "code": "19030",
        "name": "Xã Trung Thuần",
        "englishName": ""
      },
      {
        "code": "19033",
        "name": "Xã Hòa Trạch",
        "englishName": ""
      },
      {
        "code": "19051",
        "name": "Xã Tân Gianh",
        "englishName": ""
      },
      {
        "code": "19057",
        "name": "Xã Quảng Trạch",
        "englishName": ""
      },
      {
        "code": "19066",
        "name": "Phường Bắc Gianh",
        "englishName": ""
      },
      {
        "code": "19075",
        "name": "Xã Nam Ba Đồn",
        "englishName": ""
      },
      {
        "code": "19093",
        "name": "Xã Nam Gianh",
        "englishName": ""
      },
      {
        "code": "19111",
        "name": "Xã Hoàn Lão",
        "englishName": ""
      },
      {
        "code": "19126",
        "name": "Xã Bắc Trạch",
        "englishName": ""
      },
      {
        "code": "19138",
        "name": "Xã Phong Nha",
        "englishName": ""
      },
      {
        "code": "19141",
        "name": "Xã Bố Trạch",
        "englishName": ""
      },
      {
        "code": "19147",
        "name": "Xã Thượng Trạch",
        "englishName": ""
      },
      {
        "code": "19159",
        "name": "Xã Đông Trạch",
        "englishName": ""
      },
      {
        "code": "19198",
        "name": "Xã Nam Trạch",
        "englishName": ""
      },
      {
        "code": "19204",
        "name": "Xã Trường Sơn",
        "englishName": ""
      },
      {
        "code": "19207",
        "name": "Xã Quảng Ninh",
        "englishName": ""
      },
      {
        "code": "19225",
        "name": "Xã Ninh Châu",
        "englishName": ""
      },
      {
        "code": "19237",
        "name": "Xã Trường Ninh",
        "englishName": ""
      },
      {
        "code": "19246",
        "name": "Xã Lệ Ninh",
        "englishName": ""
      },
      {
        "code": "19249",
        "name": "Xã Lệ Thủy",
        "englishName": ""
      },
      {
        "code": "19255",
        "name": "Xã Cam Hồng",
        "englishName": ""
      },
      {
        "code": "19288",
        "name": "Xã Sen Ngư",
        "englishName": ""
      },
      {
        "code": "19291",
        "name": "Xã Tân Mỹ",
        "englishName": ""
      },
      {
        "code": "19309",
        "name": "Xã Trường Phú",
        "englishName": ""
      },
      {
        "code": "19318",
        "name": "Xã Kim Ngân",
        "englishName": ""
      },
      {
        "code": "19333",
        "name": "Phường Đông Hà",
        "englishName": ""
      },
      {
        "code": "19351",
        "name": "Phường Nam Đông Hà",
        "englishName": ""
      },
      {
        "code": "19360",
        "name": "Phường Quảng Trị",
        "englishName": ""
      },
      {
        "code": "19363",
        "name": "Xã Vĩnh Linh",
        "englishName": ""
      },
      {
        "code": "19366",
        "name": "Xã Bến Quan",
        "englishName": ""
      },
      {
        "code": "19372",
        "name": "Xã Vĩnh Hoàng",
        "englishName": ""
      },
      {
        "code": "19405",
        "name": "Xã Vĩnh Thủy",
        "englishName": ""
      },
      {
        "code": "19414",
        "name": "Xã Cửa Tùng",
        "englishName": ""
      },
      {
        "code": "19429",
        "name": "Xã Khe Sanh",
        "englishName": ""
      },
      {
        "code": "19432",
        "name": "Xã Lao Bảo",
        "englishName": ""
      },
      {
        "code": "19435",
        "name": "Xã Hướng Lập",
        "englishName": ""
      },
      {
        "code": "19441",
        "name": "Xã Hướng Phùng",
        "englishName": ""
      },
      {
        "code": "19462",
        "name": "Xã Tân Lập",
        "englishName": ""
      },
      {
        "code": "19483",
        "name": "Xã A Dơi",
        "englishName": ""
      },
      {
        "code": "19489",
        "name": "Xã Lìa",
        "englishName": ""
      },
      {
        "code": "19495",
        "name": "Xã Gio Linh",
        "englishName": ""
      },
      {
        "code": "19496",
        "name": "Xã Cửa Việt",
        "englishName": "Cua Viet town"
      },
      {
        "code": "19501",
        "name": "Xã Bến Hải",
        "englishName": ""
      },
      {
        "code": "19537",
        "name": "Xã Cồn Tiên",
        "englishName": ""
      },
      {
        "code": "19555",
        "name": "Xã Hướng Hiệp",
        "englishName": ""
      },
      {
        "code": "19564",
        "name": "Xã Đakrông",
        "englishName": ""
      },
      {
        "code": "19567",
        "name": "Xã Ba Lòng",
        "englishName": ""
      },
      {
        "code": "19588",
        "name": "Xã Tà Rụt",
        "englishName": ""
      },
      {
        "code": "19594",
        "name": "Xã La Lay",
        "englishName": ""
      },
      {
        "code": "19597",
        "name": "Xã Cam Lộ",
        "englishName": ""
      },
      {
        "code": "19603",
        "name": "Xã Hiếu Giang",
        "englishName": ""
      },
      {
        "code": "19624",
        "name": "Xã Triệu Phong",
        "englishName": ""
      },
      {
        "code": "19639",
        "name": "Xã Nam Cửa Việt",
        "englishName": ""
      },
      {
        "code": "19645",
        "name": "Xã Triệu Bình",
        "englishName": ""
      },
      {
        "code": "19654",
        "name": "Xã Triệu Cơ",
        "englishName": ""
      },
      {
        "code": "19669",
        "name": "Xã Ái Tử",
        "englishName": ""
      },
      {
        "code": "19681",
        "name": "Xã Diên Sanh",
        "englishName": ""
      },
      {
        "code": "19699",
        "name": "Xã Vĩnh Định",
        "englishName": ""
      },
      {
        "code": "19702",
        "name": "Xã Hải Lăng",
        "englishName": ""
      },
      {
        "code": "19735",
        "name": "Xã Nam Hải Lăng",
        "englishName": ""
      },
      {
        "code": "19741",
        "name": "Xã Mỹ Thủy",
        "englishName": ""
      },
      {
        "code": "19742",
        "name": "Đặc khu Cồn Cỏ",
        "englishName": ""
      }
    ]
  },
  {
    "code": "46",
    "name": "Thành phố Huế",
    "englishName": "",
    "administrativeLevel": "Thành phố Trung ương",
    "communes": [
      {
        "code": "19753",
        "name": "Phường Phú Xuân",
        "englishName": ""
      },
      {
        "code": "19774",
        "name": "Phường Kim Long",
        "englishName": ""
      },
      {
        "code": "19777",
        "name": "Phường Vỹ Dạ",
        "englishName": ""
      },
      {
        "code": "19789",
        "name": "Phường Thuận Hóa",
        "englishName": ""
      },
      {
        "code": "19804",
        "name": "Phường Hương An",
        "englishName": ""
      },
      {
        "code": "19813",
        "name": "Phường Thủy Xuân",
        "englishName": ""
      },
      {
        "code": "19815",
        "name": "Phường An Cựu",
        "englishName": ""
      },
      {
        "code": "19819",
        "name": "Phường Phong Điền",
        "englishName": ""
      },
      {
        "code": "19828",
        "name": "Phường Phong Phú",
        "englishName": ""
      },
      {
        "code": "19831",
        "name": "Phường Phong Dinh",
        "englishName": ""
      },
      {
        "code": "19858",
        "name": "Phường Phong Thái",
        "englishName": ""
      },
      {
        "code": "19867",
        "name": "Xã Quảng Điền",
        "englishName": ""
      },
      {
        "code": "19873",
        "name": "Phường Phong Quảng",
        "englishName": ""
      },
      {
        "code": "19885",
        "name": "Xã Đan Điền",
        "englishName": ""
      },
      {
        "code": "19900",
        "name": "Phường Thuận An",
        "englishName": ""
      },
      {
        "code": "19909",
        "name": "Phường Dương Nỗ",
        "englishName": ""
      },
      {
        "code": "19918",
        "name": "Xã Phú Hồ",
        "englishName": ""
      },
      {
        "code": "19930",
        "name": "Phường Mỹ Thượng",
        "englishName": ""
      },
      {
        "code": "19942",
        "name": "Xã Phú Vang",
        "englishName": ""
      },
      {
        "code": "19945",
        "name": "Xã Phú Vinh",
        "englishName": ""
      },
      {
        "code": "19960",
        "name": "Phường Phú Bài",
        "englishName": ""
      },
      {
        "code": "19969",
        "name": "Phường Thanh Thủy",
        "englishName": ""
      },
      {
        "code": "19975",
        "name": "Phường Hương Thủy",
        "englishName": ""
      },
      {
        "code": "19996",
        "name": "Phường Hương Trà",
        "englishName": ""
      },
      {
        "code": "20014",
        "name": "Phường Hóa Châu",
        "englishName": ""
      },
      {
        "code": "20017",
        "name": "Phường Kim Trà",
        "englishName": ""
      },
      {
        "code": "20035",
        "name": "Xã Bình Điền",
        "englishName": ""
      },
      {
        "code": "20044",
        "name": "Xã A Lưới 2",
        "englishName": ""
      },
      {
        "code": "20050",
        "name": "Xã A Lưới 5",
        "englishName": ""
      },
      {
        "code": "20056",
        "name": "Xã A Lưới 1",
        "englishName": ""
      },
      {
        "code": "20071",
        "name": "Xã A Lưới 3",
        "englishName": ""
      },
      {
        "code": "20101",
        "name": "Xã A Lưới 4",
        "englishName": ""
      },
      {
        "code": "20107",
        "name": "Xã Phú Lộc",
        "englishName": ""
      },
      {
        "code": "20122",
        "name": "Xã Vinh Lộc",
        "englishName": ""
      },
      {
        "code": "20131",
        "name": "Xã Hưng Lộc",
        "englishName": ""
      },
      {
        "code": "20137",
        "name": "Xã Chân Mây - Lăng Cô",
        "englishName": ""
      },
      {
        "code": "20140",
        "name": "Xã Lộc An",
        "englishName": ""
      },
      {
        "code": "20161",
        "name": "Xã Khe Tre",
        "englishName": ""
      },
      {
        "code": "20179",
        "name": "Xã Nam Đông",
        "englishName": ""
      },
      {
        "code": "20182",
        "name": "Xã Long Quảng",
        "englishName": ""
      }
    ]
  },
  {
    "code": "48",
    "name": "Thành phố Đà Nẵng",
    "englishName": "",
    "administrativeLevel": "Thành phố Trung ương",
    "communes": [
      {
        "code": "20194",
        "name": "Phường Hải Vân",
        "englishName": "Hoa Hiep Bac Commune"
      },
      {
        "code": "20197",
        "name": "Phường Liên Chiểu",
        "englishName": "Hoa Khanh Bac Commune"
      },
      {
        "code": "20200",
        "name": "Phường Hòa Khánh",
        "englishName": ""
      },
      {
        "code": "20209",
        "name": "Phường Thanh Khê",
        "englishName": ""
      },
      {
        "code": "20242",
        "name": "Phường Hải Châu",
        "englishName": ""
      },
      {
        "code": "20257",
        "name": "Phường Hòa Cường",
        "englishName": "Hoa Cuong Bac Commune"
      },
      {
        "code": "20260",
        "name": "Phường Cẩm Lệ",
        "englishName": ""
      },
      {
        "code": "20263",
        "name": "Phường Sơn Trà",
        "englishName": ""
      },
      {
        "code": "20275",
        "name": "Phường An Hải",
        "englishName": ""
      },
      {
        "code": "20285",
        "name": "Phường Ngũ Hành Sơn",
        "englishName": "Khue My Commune"
      },
      {
        "code": "20305",
        "name": "Phường An Khê",
        "englishName": ""
      },
      {
        "code": "20308",
        "name": "Xã Bà Nà",
        "englishName": ""
      },
      {
        "code": "20314",
        "name": "Phường Hòa Xuân",
        "englishName": ""
      },
      {
        "code": "20320",
        "name": "Xã Hòa Vang",
        "englishName": ""
      },
      {
        "code": "20332",
        "name": "Xã Hòa Tiến",
        "englishName": ""
      },
      {
        "code": "20333",
        "name": "Đặc khu Hoàng Sa",
        "englishName": ""
      },
      {
        "code": "20335",
        "name": "Phường Bàn Thạch",
        "englishName": ""
      },
      {
        "code": "20341",
        "name": "Phường Tam Kỳ",
        "englishName": ""
      },
      {
        "code": "20350",
        "name": "Phường Hương Trà",
        "englishName": ""
      },
      {
        "code": "20356",
        "name": "Phường Quảng Phú",
        "englishName": ""
      },
      {
        "code": "20364",
        "name": "Xã Chiên Đàn",
        "englishName": ""
      },
      {
        "code": "20380",
        "name": "Xã Tây Hồ",
        "englishName": ""
      },
      {
        "code": "20392",
        "name": "Xã Phú Ninh",
        "englishName": ""
      },
      {
        "code": "20401",
        "name": "Phường Hội An Tây",
        "englishName": ""
      },
      {
        "code": "20410",
        "name": "Phường Hội An",
        "englishName": ""
      },
      {
        "code": "20413",
        "name": "Phường Hội An Đông",
        "englishName": ""
      },
      {
        "code": "20434",
        "name": "Xã Tân Hiệp",
        "englishName": ""
      },
      {
        "code": "20443",
        "name": "Xã Hùng Sơn",
        "englishName": ""
      },
      {
        "code": "20455",
        "name": "Xã Tây Giang",
        "englishName": ""
      },
      {
        "code": "20458",
        "name": "Xã Avương",
        "englishName": ""
      },
      {
        "code": "20467",
        "name": "Xã Đông Giang",
        "englishName": ""
      },
      {
        "code": "20476",
        "name": "Xã Sông Kôn",
        "englishName": ""
      },
      {
        "code": "20485",
        "name": "Xã Sông Vàng",
        "englishName": ""
      },
      {
        "code": "20494",
        "name": "Xã Bến Hiên",
        "englishName": ""
      },
      {
        "code": "20500",
        "name": "Xã Đại Lộc",
        "englishName": ""
      },
      {
        "code": "20506",
        "name": "Xã Thượng Đức",
        "englishName": ""
      },
      {
        "code": "20515",
        "name": "Xã Hà Nha",
        "englishName": ""
      },
      {
        "code": "20539",
        "name": "Xã Vu Gia",
        "englishName": ""
      },
      {
        "code": "20542",
        "name": "Xã Phú Thuận",
        "englishName": ""
      },
      {
        "code": "20551",
        "name": "Phường Điện Bàn",
        "englishName": ""
      },
      {
        "code": "20557",
        "name": "Phường Điện Bàn Bắc",
        "englishName": ""
      },
      {
        "code": "20569",
        "name": "Xã Điện Bàn Tây",
        "englishName": ""
      },
      {
        "code": "20575",
        "name": "Phường An Thắng",
        "englishName": ""
      },
      {
        "code": "20579",
        "name": "Phường Điện Bàn Đông",
        "englishName": "Dien Nam Trung commune"
      },
      {
        "code": "20587",
        "name": "Xã Gò Nổi",
        "englishName": ""
      },
      {
        "code": "20599",
        "name": "Xã Nam Phước",
        "englishName": ""
      },
      {
        "code": "20611",
        "name": "Xã Thu Bồn",
        "englishName": ""
      },
      {
        "code": "20623",
        "name": "Xã Duy Xuyên",
        "englishName": ""
      },
      {
        "code": "20635",
        "name": "Xã Duy Nghĩa",
        "englishName": ""
      },
      {
        "code": "20641",
        "name": "Xã Quế Sơn",
        "englishName": ""
      },
      {
        "code": "20650",
        "name": "Xã Xuân Phú",
        "englishName": ""
      },
      {
        "code": "20656",
        "name": "Xã Nông Sơn",
        "englishName": ""
      },
      {
        "code": "20662",
        "name": "Xã Quế Sơn Trung",
        "englishName": ""
      },
      {
        "code": "20669",
        "name": "Xã Quế Phước",
        "englishName": ""
      },
      {
        "code": "20695",
        "name": "Xã Thạnh Mỹ",
        "englishName": ""
      },
      {
        "code": "20698",
        "name": "Xã La Êê",
        "englishName": ""
      },
      {
        "code": "20704",
        "name": "Xã La Dêê",
        "englishName": ""
      },
      {
        "code": "20707",
        "name": "Xã Nam Giang",
        "englishName": ""
      },
      {
        "code": "20710",
        "name": "Xã Bến Giằng",
        "englishName": ""
      },
      {
        "code": "20716",
        "name": "Xã Đắc Pring",
        "englishName": ""
      },
      {
        "code": "20722",
        "name": "Xã Khâm Đức",
        "englishName": ""
      },
      {
        "code": "20728",
        "name": "Xã Phước Hiệp",
        "englishName": ""
      },
      {
        "code": "20734",
        "name": "Xã Phước Năng",
        "englishName": ""
      },
      {
        "code": "20740",
        "name": "Xã Phước Chánh",
        "englishName": ""
      },
      {
        "code": "20752",
        "name": "Xã Phước Thành",
        "englishName": ""
      },
      {
        "code": "20767",
        "name": "Xã Việt An",
        "englishName": ""
      },
      {
        "code": "20770",
        "name": "Xã Phước Trà",
        "englishName": ""
      },
      {
        "code": "20779",
        "name": "Xã Hiệp Đức",
        "englishName": ""
      },
      {
        "code": "20791",
        "name": "Xã Thăng Bình",
        "englishName": ""
      },
      {
        "code": "20794",
        "name": "Xã Thăng An",
        "englishName": ""
      },
      {
        "code": "20818",
        "name": "Xã Đồng Dương",
        "englishName": ""
      },
      {
        "code": "20827",
        "name": "Xã Thăng Phú",
        "englishName": ""
      },
      {
        "code": "20836",
        "name": "Xã Thăng Trường",
        "englishName": ""
      },
      {
        "code": "20848",
        "name": "Xã Thăng Điền",
        "englishName": ""
      },
      {
        "code": "20854",
        "name": "Xã Tiên Phước",
        "englishName": ""
      },
      {
        "code": "20857",
        "name": "Xã Sơn Cẩm Hà",
        "englishName": ""
      },
      {
        "code": "20875",
        "name": "Xã Lãnh Ngọc",
        "englishName": ""
      },
      {
        "code": "20878",
        "name": "Xã Thạnh Bình",
        "englishName": ""
      },
      {
        "code": "20900",
        "name": "Xã Trà My",
        "englishName": ""
      },
      {
        "code": "20908",
        "name": "Xã Trà Liên",
        "englishName": ""
      },
      {
        "code": "20920",
        "name": "Xã Trà Đốc",
        "englishName": ""
      },
      {
        "code": "20923",
        "name": "Xã Trà Tân",
        "englishName": ""
      },
      {
        "code": "20929",
        "name": "Xã Trà Giáp",
        "englishName": ""
      },
      {
        "code": "20938",
        "name": "Xã Trà Leng",
        "englishName": ""
      },
      {
        "code": "20941",
        "name": "Xã Trà Tập",
        "englishName": ""
      },
      {
        "code": "20944",
        "name": "Xã Nam Trà My",
        "englishName": ""
      },
      {
        "code": "20950",
        "name": "Xã Trà Linh",
        "englishName": ""
      },
      {
        "code": "20959",
        "name": "Xã Trà Vân",
        "englishName": ""
      },
      {
        "code": "20965",
        "name": "Xã Núi Thành",
        "englishName": ""
      },
      {
        "code": "20971",
        "name": "Xã Tam Xuân",
        "englishName": ""
      },
      {
        "code": "20977",
        "name": "Xã Đức Phú",
        "englishName": ""
      },
      {
        "code": "20984",
        "name": "Xã Tam Anh",
        "englishName": "Tam Anh Nam commune"
      },
      {
        "code": "20992",
        "name": "Xã Tam Hải",
        "englishName": ""
      },
      {
        "code": "21004",
        "name": "Xã Tam Mỹ",
        "englishName": "Tam My Tay commune"
      }
    ]
  },
  {
    "code": "51",
    "name": "Tỉnh Quảng Ngãi",
    "englishName": "",
    "administrativeLevel": "Tỉnh",
    "communes": [
      {
        "code": "21025",
        "name": "Phường Cẩm Thành",
        "englishName": ""
      },
      {
        "code": "21028",
        "name": "Phường Nghĩa Lộ",
        "englishName": ""
      },
      {
        "code": "21034",
        "name": "Xã An Phú",
        "englishName": ""
      },
      {
        "code": "21040",
        "name": "Xã Bình Sơn",
        "englishName": ""
      },
      {
        "code": "21061",
        "name": "Xã Vạn Tường",
        "englishName": ""
      },
      {
        "code": "21085",
        "name": "Xã Bình Minh",
        "englishName": ""
      },
      {
        "code": "21100",
        "name": "Xã Bình Chương",
        "englishName": ""
      },
      {
        "code": "21109",
        "name": "Xã Đông Sơn",
        "englishName": ""
      },
      {
        "code": "21115",
        "name": "Xã Trà Bồng",
        "englishName": ""
      },
      {
        "code": "21124",
        "name": "Xã Thanh Bồng",
        "englishName": ""
      },
      {
        "code": "21127",
        "name": "Xã Đông Trà Bồng",
        "englishName": ""
      },
      {
        "code": "21136",
        "name": "Xã Cà Đam",
        "englishName": ""
      },
      {
        "code": "21154",
        "name": "Xã Tây Trà",
        "englishName": ""
      },
      {
        "code": "21157",
        "name": "Xã Tây Trà Bồng",
        "englishName": ""
      },
      {
        "code": "21172",
        "name": "Phường Trương Quang Trọng",
        "englishName": ""
      },
      {
        "code": "21181",
        "name": "Xã Thọ Phong",
        "englishName": ""
      },
      {
        "code": "21196",
        "name": "Xã Trường Giang",
        "englishName": ""
      },
      {
        "code": "21205",
        "name": "Xã Ba Gia",
        "englishName": ""
      },
      {
        "code": "21211",
        "name": "Xã Tịnh Khê",
        "englishName": ""
      },
      {
        "code": "21220",
        "name": "Xã Sơn Tịnh",
        "englishName": ""
      },
      {
        "code": "21235",
        "name": "Xã Tư Nghĩa",
        "englishName": ""
      },
      {
        "code": "21238",
        "name": "Xã Vệ Giang",
        "englishName": ""
      },
      {
        "code": "21244",
        "name": "Xã Trà Giang",
        "englishName": ""
      },
      {
        "code": "21250",
        "name": "Xã Nghĩa Giang",
        "englishName": ""
      },
      {
        "code": "21289",
        "name": "Xã Sơn Hà",
        "englishName": ""
      },
      {
        "code": "21292",
        "name": "Xã Sơn Hạ",
        "englishName": ""
      },
      {
        "code": "21307",
        "name": "Xã Sơn Linh",
        "englishName": ""
      },
      {
        "code": "21319",
        "name": "Xã Sơn Thủy",
        "englishName": ""
      },
      {
        "code": "21325",
        "name": "Xã Sơn Kỳ",
        "englishName": ""
      },
      {
        "code": "21334",
        "name": "Xã Sơn Tây Thượng",
        "englishName": ""
      },
      {
        "code": "21340",
        "name": "Xã Sơn Tây",
        "englishName": ""
      },
      {
        "code": "21343",
        "name": "Xã Sơn Tây Hạ",
        "englishName": ""
      },
      {
        "code": "21349",
        "name": "Xã Sơn Mai",
        "englishName": ""
      },
      {
        "code": "21361",
        "name": "Xã Minh Long",
        "englishName": ""
      },
      {
        "code": "21364",
        "name": "Xã Nghĩa Hành",
        "englishName": ""
      },
      {
        "code": "21370",
        "name": "Xã Phước Giang",
        "englishName": ""
      },
      {
        "code": "21385",
        "name": "Xã Đình Cương",
        "englishName": ""
      },
      {
        "code": "21388",
        "name": "Xã Thiện Tín",
        "englishName": ""
      },
      {
        "code": "21400",
        "name": "Xã Mộ Đức",
        "englishName": ""
      },
      {
        "code": "21409",
        "name": "Xã Long Phụng",
        "englishName": ""
      },
      {
        "code": "21421",
        "name": "Xã Mỏ Cày",
        "englishName": ""
      },
      {
        "code": "21433",
        "name": "Xã Lân Phong",
        "englishName": ""
      },
      {
        "code": "21439",
        "name": "Phường Đức Phổ",
        "englishName": ""
      },
      {
        "code": "21451",
        "name": "Phường Trà Câu",
        "englishName": ""
      },
      {
        "code": "21457",
        "name": "Xã Nguyễn Nghiêm",
        "englishName": ""
      },
      {
        "code": "21472",
        "name": "Xã Khánh Cường",
        "englishName": ""
      },
      {
        "code": "21478",
        "name": "Phường Sa Huỳnh",
        "englishName": ""
      },
      {
        "code": "21484",
        "name": "Xã Ba Tơ",
        "englishName": ""
      },
      {
        "code": "21490",
        "name": "Xã Ba Vinh",
        "englishName": ""
      },
      {
        "code": "21496",
        "name": "Xã Ba Động",
        "englishName": ""
      },
      {
        "code": "21499",
        "name": "Xã Ba Dinh",
        "englishName": ""
      },
      {
        "code": "21520",
        "name": "Xã Đặng Thùy Trâm",
        "englishName": ""
      },
      {
        "code": "21523",
        "name": "Xã Ba Tô",
        "englishName": ""
      },
      {
        "code": "21529",
        "name": "Xã Ba Vì",
        "englishName": ""
      },
      {
        "code": "21538",
        "name": "Xã Ba Xa",
        "englishName": ""
      },
      {
        "code": "21548",
        "name": "Đặc khu Lý Sơn",
        "englishName": ""
      },
      {
        "code": "23284",
        "name": "Phường Đăk Cấm",
        "englishName": ""
      },
      {
        "code": "23293",
        "name": "Phường Kon Tum",
        "englishName": ""
      },
      {
        "code": "23302",
        "name": "Phường Đăk Bla",
        "englishName": ""
      },
      {
        "code": "23317",
        "name": "Xã Ngọk Bay",
        "englishName": ""
      },
      {
        "code": "23326",
        "name": "Xã Ia Chim",
        "englishName": ""
      },
      {
        "code": "23332",
        "name": "Xã Đăk Rơ Wa",
        "englishName": ""
      },
      {
        "code": "23341",
        "name": "Xã Đăk Pék",
        "englishName": ""
      },
      {
        "code": "23344",
        "name": "Xã Đăk Plô",
        "englishName": ""
      },
      {
        "code": "23356",
        "name": "Xã Xốp",
        "englishName": ""
      },
      {
        "code": "23365",
        "name": "Xã Ngọc Linh",
        "englishName": ""
      },
      {
        "code": "23368",
        "name": "Xã Đăk Long",
        "englishName": ""
      },
      {
        "code": "23374",
        "name": "Xã Đăk Môn",
        "englishName": ""
      },
      {
        "code": "23377",
        "name": "Xã Bờ Y",
        "englishName": ""
      },
      {
        "code": "23383",
        "name": "Xã Dục Nông",
        "englishName": ""
      },
      {
        "code": "23392",
        "name": "Xã Sa Loong",
        "englishName": ""
      },
      {
        "code": "23401",
        "name": "Xã Đăk Tô",
        "englishName": ""
      },
      {
        "code": "23416",
        "name": "Xã Đăk Sao",
        "englishName": ""
      },
      {
        "code": "23419",
        "name": "Xã Đăk Tờ Kan",
        "englishName": ""
      },
      {
        "code": "23425",
        "name": "Xã Tu Mơ Rông",
        "englishName": ""
      },
      {
        "code": "23428",
        "name": "Xã Ngọk Tụ",
        "englishName": ""
      },
      {
        "code": "23430",
        "name": "Xã Kon Đào",
        "englishName": "Dak Tram commune"
      },
      {
        "code": "23446",
        "name": "Xã Măng Ri",
        "englishName": ""
      },
      {
        "code": "23455",
        "name": "Xã Măng Bút",
        "englishName": ""
      },
      {
        "code": "23473",
        "name": "Xã Măng Đen",
        "englishName": ""
      },
      {
        "code": "23476",
        "name": "Xã Kon Plông",
        "englishName": ""
      },
      {
        "code": "23479",
        "name": "Xã Đăk Rve",
        "englishName": ""
      },
      {
        "code": "23485",
        "name": "Xã Đăk Kôi",
        "englishName": ""
      },
      {
        "code": "23497",
        "name": "Xã Kon Braih",
        "englishName": ""
      },
      {
        "code": "23500",
        "name": "Xã Đăk Hà",
        "englishName": ""
      },
      {
        "code": "23504",
        "name": "Xã Đăk Pxi",
        "englishName": ""
      },
      {
        "code": "23510",
        "name": "Xã Đăk Ui",
        "englishName": ""
      },
      {
        "code": "23512",
        "name": "Xã Đăk Mar",
        "englishName": ""
      },
      {
        "code": "23515",
        "name": "Xã Ngọk Réo",
        "englishName": ""
      },
      {
        "code": "23527",
        "name": "Xã Sa Thầy",
        "englishName": ""
      },
      {
        "code": "23530",
        "name": "Xã Rờ Kơi",
        "englishName": ""
      },
      {
        "code": "23534",
        "name": "Xã Sa Bình",
        "englishName": "Ho Moong commune"
      },
      {
        "code": "23535",
        "name": "Xã Ia Đal",
        "englishName": ""
      },
      {
        "code": "23536",
        "name": "Xã Mô Rai",
        "englishName": ""
      },
      {
        "code": "23538",
        "name": "Xã Ia Tơi",
        "englishName": ""
      },
      {
        "code": "23548",
        "name": "Xã Ya Ly",
        "englishName": ""
      }
    ]
  },
  {
    "code": "52",
    "name": "Tỉnh Gia Lai",
    "englishName": "",
    "administrativeLevel": "Tỉnh",
    "communes": [
      {
        "code": "21553",
        "name": "Phường Quy Nhơn Bắc",
        "englishName": ""
      },
      {
        "code": "21583",
        "name": "Phường Quy Nhơn",
        "englishName": ""
      },
      {
        "code": "21589",
        "name": "Phường Quy Nhơn Tây",
        "englishName": ""
      },
      {
        "code": "21592",
        "name": "Phường Quy Nhơn Nam",
        "englishName": ""
      },
      {
        "code": "21601",
        "name": "Phường Quy Nhơn Đông",
        "englishName": ""
      },
      {
        "code": "21607",
        "name": "Xã Nhơn Châu",
        "englishName": ""
      },
      {
        "code": "21609",
        "name": "Xã An Lão",
        "englishName": ""
      },
      {
        "code": "21616",
        "name": "Xã An Vinh",
        "englishName": ""
      },
      {
        "code": "21622",
        "name": "Xã An Toàn",
        "englishName": ""
      },
      {
        "code": "21628",
        "name": "Xã An Hòa",
        "englishName": ""
      },
      {
        "code": "21637",
        "name": "Phường Tam Quan",
        "englishName": ""
      },
      {
        "code": "21640",
        "name": "Phường Bồng Sơn",
        "englishName": ""
      },
      {
        "code": "21655",
        "name": "Phường Hoài Nhơn Bắc",
        "englishName": ""
      },
      {
        "code": "21661",
        "name": "Phường Hoài Nhơn Tây",
        "englishName": ""
      },
      {
        "code": "21664",
        "name": "Phường Hoài Nhơn",
        "englishName": ""
      },
      {
        "code": "21670",
        "name": "Phường Hoài Nhơn Đông",
        "englishName": ""
      },
      {
        "code": "21673",
        "name": "Phường Hoài Nhơn Nam",
        "englishName": ""
      },
      {
        "code": "21688",
        "name": "Xã Hoài Ân",
        "englishName": ""
      },
      {
        "code": "21697",
        "name": "Xã Ân Hảo",
        "englishName": ""
      },
      {
        "code": "21703",
        "name": "Xã Vạn Đức",
        "englishName": ""
      },
      {
        "code": "21715",
        "name": "Xã Ân Tường",
        "englishName": ""
      },
      {
        "code": "21727",
        "name": "Xã Kim Sơn",
        "englishName": ""
      },
      {
        "code": "21730",
        "name": "Xã Phù Mỹ",
        "englishName": ""
      },
      {
        "code": "21733",
        "name": "Xã Bình Dương",
        "englishName": ""
      },
      {
        "code": "21739",
        "name": "Xã Phù Mỹ Bắc",
        "englishName": ""
      },
      {
        "code": "21751",
        "name": "Xã Phù Mỹ Đông",
        "englishName": ""
      },
      {
        "code": "21757",
        "name": "Xã Phù Mỹ Tây",
        "englishName": ""
      },
      {
        "code": "21769",
        "name": "Xã An Lương",
        "englishName": ""
      },
      {
        "code": "21775",
        "name": "Xã Phù Mỹ Nam",
        "englishName": ""
      },
      {
        "code": "21786",
        "name": "Xã Vĩnh Thạnh",
        "englishName": "Vinh Thanh commune"
      },
      {
        "code": "21787",
        "name": "Xã Vĩnh Sơn",
        "englishName": ""
      },
      {
        "code": "21796",
        "name": "Xã Vĩnh Thịnh",
        "englishName": ""
      },
      {
        "code": "21805",
        "name": "Xã Vĩnh Quang",
        "englishName": ""
      },
      {
        "code": "21808",
        "name": "Xã Tây Sơn",
        "englishName": ""
      },
      {
        "code": "21817",
        "name": "Xã Bình Hiệp",
        "englishName": ""
      },
      {
        "code": "21820",
        "name": "Xã Bình Khê",
        "englishName": ""
      },
      {
        "code": "21829",
        "name": "Xã Bình An",
        "englishName": ""
      },
      {
        "code": "21835",
        "name": "Xã Bình Phú",
        "englishName": ""
      },
      {
        "code": "21853",
        "name": "Xã Phù Cát",
        "englishName": ""
      },
      {
        "code": "21859",
        "name": "Xã Đề Gi",
        "englishName": ""
      },
      {
        "code": "21868",
        "name": "Xã Hội Sơn",
        "englishName": ""
      },
      {
        "code": "21871",
        "name": "Xã Hòa Hội",
        "englishName": ""
      },
      {
        "code": "21880",
        "name": "Xã Cát Tiến",
        "englishName": ""
      },
      {
        "code": "21892",
        "name": "Xã Xuân An",
        "englishName": ""
      },
      {
        "code": "21901",
        "name": "Xã Ngô Mây",
        "englishName": ""
      },
      {
        "code": "21907",
        "name": "Phường Bình Định",
        "englishName": ""
      },
      {
        "code": "21910",
        "name": "Phường An Nhơn",
        "englishName": ""
      },
      {
        "code": "21925",
        "name": "Phường An Nhơn Bắc",
        "englishName": ""
      },
      {
        "code": "21934",
        "name": "Phường An Nhơn Đông",
        "englishName": ""
      },
      {
        "code": "21940",
        "name": "Xã An Nhơn Tây",
        "englishName": ""
      },
      {
        "code": "21943",
        "name": "Phường An Nhơn Nam",
        "englishName": ""
      },
      {
        "code": "21952",
        "name": "Xã Tuy Phước",
        "englishName": ""
      },
      {
        "code": "21964",
        "name": "Xã Tuy Phước Bắc",
        "englishName": ""
      },
      {
        "code": "21970",
        "name": "Xã Tuy Phước Đông",
        "englishName": ""
      },
      {
        "code": "21985",
        "name": "Xã Tuy Phước Tây",
        "englishName": ""
      },
      {
        "code": "21994",
        "name": "Xã Vân Canh",
        "englishName": ""
      },
      {
        "code": "21997",
        "name": "Xã Canh Liên",
        "englishName": ""
      },
      {
        "code": "22006",
        "name": "Xã Canh Vinh",
        "englishName": ""
      },
      {
        "code": "23563",
        "name": "Phường Diên Hồng",
        "englishName": ""
      },
      {
        "code": "23575",
        "name": "Phường Pleiku",
        "englishName": ""
      },
      {
        "code": "23584",
        "name": "Phường Thống Nhất",
        "englishName": ""
      },
      {
        "code": "23586",
        "name": "Phường Hội Phú",
        "englishName": ""
      },
      {
        "code": "23590",
        "name": "Xã Biển Hồ",
        "englishName": ""
      },
      {
        "code": "23602",
        "name": "Phường An Phú",
        "englishName": ""
      },
      {
        "code": "23611",
        "name": "Xã Gào",
        "englishName": ""
      },
      {
        "code": "23614",
        "name": "Phường An Bình",
        "englishName": ""
      },
      {
        "code": "23617",
        "name": "Phường An Khê",
        "englishName": ""
      },
      {
        "code": "23629",
        "name": "Xã Cửu An",
        "englishName": ""
      },
      {
        "code": "23638",
        "name": "Xã Kbang",
        "englishName": ""
      },
      {
        "code": "23644",
        "name": "Xã Đak Rong",
        "englishName": ""
      },
      {
        "code": "23647",
        "name": "Xã Sơn Lang",
        "englishName": ""
      },
      {
        "code": "23650",
        "name": "Xã Krong",
        "englishName": ""
      },
      {
        "code": "23668",
        "name": "Xã Tơ Tung",
        "englishName": ""
      },
      {
        "code": "23674",
        "name": "Xã Kông Bơ La",
        "englishName": ""
      },
      {
        "code": "23677",
        "name": "Xã Đak Đoa",
        "englishName": ""
      },
      {
        "code": "23683",
        "name": "Xã Đak Sơmei",
        "englishName": ""
      },
      {
        "code": "23701",
        "name": "Xã Kon Gang",
        "englishName": ""
      },
      {
        "code": "23710",
        "name": "Xã Ia Băng",
        "englishName": ""
      },
      {
        "code": "23714",
        "name": "Xã KDang",
        "englishName": "Hnol commune"
      },
      {
        "code": "23722",
        "name": "Xã Chư Păh",
        "englishName": ""
      },
      {
        "code": "23728",
        "name": "Xã Ia Khươl",
        "englishName": ""
      },
      {
        "code": "23734",
        "name": "Xã Ia Ly",
        "englishName": ""
      },
      {
        "code": "23749",
        "name": "Xã Ia Phí",
        "englishName": ""
      },
      {
        "code": "23764",
        "name": "Xã Ia Grai",
        "englishName": ""
      },
      {
        "code": "23767",
        "name": "Xã Ia Hrung",
        "englishName": ""
      },
      {
        "code": "23776",
        "name": "Xã Ia Krái",
        "englishName": ""
      },
      {
        "code": "23782",
        "name": "Xã Ia O",
        "englishName": ""
      },
      {
        "code": "23788",
        "name": "Xã Ia Chia",
        "englishName": ""
      },
      {
        "code": "23794",
        "name": "Xã Mang Yang",
        "englishName": ""
      },
      {
        "code": "23798",
        "name": "Xã Ayun",
        "englishName": ""
      },
      {
        "code": "23799",
        "name": "Xã Hra",
        "englishName": ""
      },
      {
        "code": "23812",
        "name": "Xã Lơ Pang",
        "englishName": ""
      },
      {
        "code": "23818",
        "name": "Xã Kon Chiêng",
        "englishName": ""
      },
      {
        "code": "23824",
        "name": "Xã Kông Chro",
        "englishName": ""
      },
      {
        "code": "23830",
        "name": "Xã Chư Krey",
        "englishName": ""
      },
      {
        "code": "23833",
        "name": "Xã Ya Ma",
        "englishName": ""
      },
      {
        "code": "23839",
        "name": "Xã SRó",
        "englishName": ""
      },
      {
        "code": "23842",
        "name": "Xã Đăk Song",
        "englishName": ""
      },
      {
        "code": "23851",
        "name": "Xã Chơ Long",
        "englishName": ""
      },
      {
        "code": "23857",
        "name": "Xã Đức Cơ",
        "englishName": ""
      },
      {
        "code": "23866",
        "name": "Xã Ia Krêl",
        "englishName": ""
      },
      {
        "code": "23869",
        "name": "Xã Ia Dơk",
        "englishName": ""
      },
      {
        "code": "23872",
        "name": "Xã Ia Dom",
        "englishName": ""
      },
      {
        "code": "23881",
        "name": "Xã Ia Pnôn",
        "englishName": ""
      },
      {
        "code": "23884",
        "name": "Xã Ia Nan",
        "englishName": ""
      },
      {
        "code": "23887",
        "name": "Xã Chư Prông",
        "englishName": ""
      },
      {
        "code": "23896",
        "name": "Xã Bàu Cạn",
        "englishName": ""
      },
      {
        "code": "23908",
        "name": "Xã Ia Tôr",
        "englishName": ""
      },
      {
        "code": "23911",
        "name": "Xã Ia Boòng",
        "englishName": ""
      },
      {
        "code": "23917",
        "name": "Xã Ia Púch",
        "englishName": ""
      },
      {
        "code": "23926",
        "name": "Xã Ia Pia",
        "englishName": ""
      },
      {
        "code": "23935",
        "name": "Xã Ia Lâu",
        "englishName": ""
      },
      {
        "code": "23938",
        "name": "Xã Ia Mơ",
        "englishName": ""
      },
      {
        "code": "23941",
        "name": "Xã Chư Sê",
        "englishName": ""
      },
      {
        "code": "23942",
        "name": "Xã Chư Pưh",
        "englishName": ""
      },
      {
        "code": "23947",
        "name": "Xã Bờ Ngoong",
        "englishName": ""
      },
      {
        "code": "23954",
        "name": "Xã Al Bá",
        "englishName": ""
      },
      {
        "code": "23971",
        "name": "Xã Ia Hrú",
        "englishName": ""
      },
      {
        "code": "23977",
        "name": "Xã Ia Ko",
        "englishName": ""
      },
      {
        "code": "23986",
        "name": "Xã Ia Le",
        "englishName": ""
      },
      {
        "code": "23995",
        "name": "Xã Đak Pơ",
        "englishName": ""
      },
      {
        "code": "24007",
        "name": "Xã Ya Hội",
        "englishName": ""
      },
      {
        "code": "24013",
        "name": "Xã Pờ Tó",
        "englishName": ""
      },
      {
        "code": "24022",
        "name": "Xã Ia Pa",
        "englishName": ""
      },
      {
        "code": "24028",
        "name": "Xã Ia Tul",
        "englishName": ""
      },
      {
        "code": "24043",
        "name": "Xã Phú Thiện",
        "englishName": ""
      },
      {
        "code": "24044",
        "name": "Phường Ayun Pa",
        "englishName": ""
      },
      {
        "code": "24049",
        "name": "Xã Chư A Thai",
        "englishName": "Ia Ake Commune"
      },
      {
        "code": "24061",
        "name": "Xã Ia Hiao",
        "englishName": ""
      },
      {
        "code": "24065",
        "name": "Xã Ia Rbol",
        "englishName": ""
      },
      {
        "code": "24073",
        "name": "Xã Ia Sao",
        "englishName": ""
      },
      {
        "code": "24076",
        "name": "Xã Phú Túc",
        "englishName": ""
      },
      {
        "code": "24100",
        "name": "Xã Ia Dreh",
        "englishName": ""
      },
      {
        "code": "24109",
        "name": "Xã Uar",
        "englishName": ""
      },
      {
        "code": "24112",
        "name": "Xã Ia Rsai",
        "englishName": ""
      }
    ]
  },
  {
    "code": "56",
    "name": "Tỉnh Khánh Hòa",
    "englishName": "",
    "administrativeLevel": "Tỉnh",
    "communes": [
      {
        "code": "22333",
        "name": "Phường Bắc Nha Trang",
        "englishName": ""
      },
      {
        "code": "22366",
        "name": "Phường Nha Trang",
        "englishName": ""
      },
      {
        "code": "22390",
        "name": "Phường Tây Nha Trang",
        "englishName": ""
      },
      {
        "code": "22402",
        "name": "Phường Nam Nha Trang",
        "englishName": ""
      },
      {
        "code": "22411",
        "name": "Phường Bắc Cam Ranh",
        "englishName": ""
      },
      {
        "code": "22420",
        "name": "Phường Cam Ranh",
        "englishName": ""
      },
      {
        "code": "22423",
        "name": "Phường Ba Ngòi",
        "englishName": ""
      },
      {
        "code": "22432",
        "name": "Phường Cam Linh",
        "englishName": ""
      },
      {
        "code": "22435",
        "name": "Xã Cam Hiệp",
        "englishName": ""
      },
      {
        "code": "22453",
        "name": "Xã Cam Lâm",
        "englishName": ""
      },
      {
        "code": "22465",
        "name": "Xã Cam An",
        "englishName": ""
      },
      {
        "code": "22480",
        "name": "Xã Nam Cam Ranh",
        "englishName": ""
      },
      {
        "code": "22489",
        "name": "Xã Vạn Ninh",
        "englishName": ""
      },
      {
        "code": "22498",
        "name": "Xã Tu Bông",
        "englishName": ""
      },
      {
        "code": "22504",
        "name": "Xã Đại Lãnh",
        "englishName": ""
      },
      {
        "code": "22516",
        "name": "Xã Vạn Thắng",
        "englishName": ""
      },
      {
        "code": "22525",
        "name": "Xã Vạn Hưng",
        "englishName": ""
      },
      {
        "code": "22528",
        "name": "Phường Ninh Hòa",
        "englishName": ""
      },
      {
        "code": "22546",
        "name": "Xã Bắc Ninh Hòa",
        "englishName": ""
      },
      {
        "code": "22552",
        "name": "Xã Tây Ninh Hòa",
        "englishName": ""
      },
      {
        "code": "22558",
        "name": "Xã Hòa Trí",
        "englishName": ""
      },
      {
        "code": "22561",
        "name": "Phường Đông Ninh Hòa",
        "englishName": ""
      },
      {
        "code": "22576",
        "name": "Xã Tân Định",
        "englishName": ""
      },
      {
        "code": "22591",
        "name": "Phường Hòa Thắng",
        "englishName": ""
      },
      {
        "code": "22597",
        "name": "Xã Nam Ninh Hòa",
        "englishName": ""
      },
      {
        "code": "22609",
        "name": "Xã Khánh Vĩnh",
        "englishName": ""
      },
      {
        "code": "22612",
        "name": "Xã Trung Khánh Vĩnh",
        "englishName": ""
      },
      {
        "code": "22615",
        "name": "Xã Bắc Khánh Vĩnh",
        "englishName": ""
      },
      {
        "code": "22624",
        "name": "Xã Tây Khánh Vĩnh",
        "englishName": ""
      },
      {
        "code": "22648",
        "name": "Xã Nam Khánh Vĩnh",
        "englishName": ""
      },
      {
        "code": "22651",
        "name": "Xã Diên Khánh",
        "englishName": ""
      },
      {
        "code": "22657",
        "name": "Xã Diên Điền",
        "englishName": ""
      },
      {
        "code": "22660",
        "name": "Xã Diên Lâm",
        "englishName": ""
      },
      {
        "code": "22672",
        "name": "Xã Diên Thọ",
        "englishName": ""
      },
      {
        "code": "22678",
        "name": "Xã Diên Lạc",
        "englishName": ""
      },
      {
        "code": "22702",
        "name": "Xã Suối Hiệp",
        "englishName": ""
      },
      {
        "code": "22708",
        "name": "Xã Suối Dầu",
        "englishName": ""
      },
      {
        "code": "22714",
        "name": "Xã Khánh Sơn",
        "englishName": ""
      },
      {
        "code": "22720",
        "name": "Xã Tây Khánh Sơn",
        "englishName": ""
      },
      {
        "code": "22732",
        "name": "Xã Đông Khánh Sơn",
        "englishName": ""
      },
      {
        "code": "22736",
        "name": "Đặc khu Trường Sa",
        "englishName": ""
      },
      {
        "code": "22738",
        "name": "Phường Đô Vinh",
        "englishName": ""
      },
      {
        "code": "22741",
        "name": "Phường Bảo An",
        "englishName": ""
      },
      {
        "code": "22759",
        "name": "Phường Phan Rang",
        "englishName": ""
      },
      {
        "code": "22780",
        "name": "Phường Đông Hải",
        "englishName": ""
      },
      {
        "code": "22786",
        "name": "Xã Bác Ái Tây",
        "englishName": ""
      },
      {
        "code": "22795",
        "name": "Xã Bác Ái",
        "englishName": ""
      },
      {
        "code": "22801",
        "name": "Xã Bác Ái Đông",
        "englishName": ""
      },
      {
        "code": "22810",
        "name": "Xã Ninh Sơn",
        "englishName": ""
      },
      {
        "code": "22813",
        "name": "Xã Lâm Sơn",
        "englishName": ""
      },
      {
        "code": "22822",
        "name": "Xã Mỹ Sơn",
        "englishName": ""
      },
      {
        "code": "22828",
        "name": "Xã Anh Dũng",
        "englishName": ""
      },
      {
        "code": "22834",
        "name": "Phường Ninh Chử",
        "englishName": ""
      },
      {
        "code": "22840",
        "name": "Xã Công Hải",
        "englishName": ""
      },
      {
        "code": "22846",
        "name": "Xã Vĩnh Hải",
        "englishName": ""
      },
      {
        "code": "22849",
        "name": "Xã Thuận Bắc",
        "englishName": ""
      },
      {
        "code": "22852",
        "name": "Xã Ninh Hải",
        "englishName": ""
      },
      {
        "code": "22861",
        "name": "Xã Xuân Hải",
        "englishName": ""
      },
      {
        "code": "22870",
        "name": "Xã Ninh Phước",
        "englishName": ""
      },
      {
        "code": "22873",
        "name": "Xã Phước Hậu",
        "englishName": ""
      },
      {
        "code": "22888",
        "name": "Xã Phước Dinh",
        "englishName": ""
      },
      {
        "code": "22891",
        "name": "Xã Phước Hữu",
        "englishName": ""
      },
      {
        "code": "22897",
        "name": "Xã Thuận Nam",
        "englishName": ""
      },
      {
        "code": "22900",
        "name": "Xã Phước Hà",
        "englishName": ""
      },
      {
        "code": "22909",
        "name": "Xã Cà Ná",
        "englishName": ""
      }
    ]
  },
  {
    "code": "66",
    "name": "Tỉnh Đắk Lắk",
    "englishName": "",
    "administrativeLevel": "Tỉnh",
    "communes": [
      {
        "code": "22015",
        "name": "Phường Tuy Hòa",
        "englishName": ""
      },
      {
        "code": "22045",
        "name": "Phường Bình Kiến",
        "englishName": ""
      },
      {
        "code": "22051",
        "name": "Phường Sông Cầu",
        "englishName": ""
      },
      {
        "code": "22057",
        "name": "Xã Xuân Lộc",
        "englishName": ""
      },
      {
        "code": "22060",
        "name": "Xã Xuân Cảnh",
        "englishName": ""
      },
      {
        "code": "22075",
        "name": "Xã Xuân Thọ",
        "englishName": ""
      },
      {
        "code": "22076",
        "name": "Phường Xuân Đài",
        "englishName": ""
      },
      {
        "code": "22081",
        "name": "Xã Đồng Xuân",
        "englishName": ""
      },
      {
        "code": "22090",
        "name": "Xã Xuân Lãnh",
        "englishName": ""
      },
      {
        "code": "22096",
        "name": "Xã Phú Mỡ",
        "englishName": ""
      },
      {
        "code": "22111",
        "name": "Xã Xuân Phước",
        "englishName": ""
      },
      {
        "code": "22114",
        "name": "Xã Tuy An Bắc",
        "englishName": ""
      },
      {
        "code": "22120",
        "name": "Xã Tuy An Đông",
        "englishName": ""
      },
      {
        "code": "22132",
        "name": "Xã Tuy An Tây",
        "englishName": ""
      },
      {
        "code": "22147",
        "name": "Xã Ô Loan",
        "englishName": ""
      },
      {
        "code": "22153",
        "name": "Xã Tuy An Nam",
        "englishName": ""
      },
      {
        "code": "22165",
        "name": "Xã Sơn Hòa",
        "englishName": ""
      },
      {
        "code": "22171",
        "name": "Xã Tây Sơn",
        "englishName": ""
      },
      {
        "code": "22177",
        "name": "Xã Vân Hòa",
        "englishName": ""
      },
      {
        "code": "22192",
        "name": "Xã Suối Trai",
        "englishName": ""
      },
      {
        "code": "22207",
        "name": "Xã Sông Hinh",
        "englishName": ""
      },
      {
        "code": "22222",
        "name": "Xã Đức Bình",
        "englishName": ""
      },
      {
        "code": "22225",
        "name": "Xã Ea Bá",
        "englishName": ""
      },
      {
        "code": "22237",
        "name": "Xã Ea Ly",
        "englishName": ""
      },
      {
        "code": "22240",
        "name": "Phường Phú Yên",
        "englishName": ""
      },
      {
        "code": "22250",
        "name": "Xã Sơn Thành",
        "englishName": "Son Thanh Dong commune"
      },
      {
        "code": "22255",
        "name": "Xã Tây Hòa",
        "englishName": ""
      },
      {
        "code": "22258",
        "name": "Phường Đông Hòa",
        "englishName": ""
      },
      {
        "code": "22261",
        "name": "Phường Hòa Hiệp",
        "englishName": ""
      },
      {
        "code": "22276",
        "name": "Xã Hòa Thịnh",
        "englishName": ""
      },
      {
        "code": "22285",
        "name": "Xã Hòa Mỹ",
        "englishName": ""
      },
      {
        "code": "22291",
        "name": "Xã Hòa Xuân",
        "englishName": ""
      },
      {
        "code": "22303",
        "name": "Xã Phú Hòa 2",
        "englishName": ""
      },
      {
        "code": "22319",
        "name": "Xã Phú Hòa 1",
        "englishName": ""
      },
      {
        "code": "24121",
        "name": "Phường Tân Lập",
        "englishName": ""
      },
      {
        "code": "24133",
        "name": "Phường Buôn Ma Thuột",
        "englishName": ""
      },
      {
        "code": "24154",
        "name": "Phường Thành Nhất",
        "englishName": ""
      },
      {
        "code": "24163",
        "name": "Phường Tân An",
        "englishName": ""
      },
      {
        "code": "24169",
        "name": "Phường Ea Kao",
        "englishName": ""
      },
      {
        "code": "24175",
        "name": "Xã Hòa Phú",
        "englishName": ""
      },
      {
        "code": "24181",
        "name": "Xã Ea Drăng",
        "englishName": ""
      },
      {
        "code": "24184",
        "name": "Xã Ea H’Leo",
        "englishName": ""
      },
      {
        "code": "24187",
        "name": "Xã Ea Hiao",
        "englishName": ""
      },
      {
        "code": "24193",
        "name": "Xã Ea Wy",
        "englishName": ""
      },
      {
        "code": "24208",
        "name": "Xã Ea Khăl",
        "englishName": ""
      },
      {
        "code": "24211",
        "name": "Xã Ea Súp",
        "englishName": ""
      },
      {
        "code": "24214",
        "name": "Xã Ia Lốp",
        "englishName": ""
      },
      {
        "code": "24217",
        "name": "Xã Ea Rốk",
        "englishName": ""
      },
      {
        "code": "24221",
        "name": "Xã Ia Rvê",
        "englishName": "Ia RVe commune"
      },
      {
        "code": "24229",
        "name": "Xã Ea Bung",
        "englishName": ""
      },
      {
        "code": "24235",
        "name": "Xã Buôn Đôn",
        "englishName": ""
      },
      {
        "code": "24241",
        "name": "Xã Ea Wer",
        "englishName": ""
      },
      {
        "code": "24250",
        "name": "Xã Ea Nuôl",
        "englishName": ""
      },
      {
        "code": "24259",
        "name": "Xã Quảng Phú",
        "englishName": ""
      },
      {
        "code": "24265",
        "name": "Xã Ea Kiết",
        "englishName": ""
      },
      {
        "code": "24277",
        "name": "Xã Ea Tul",
        "englishName": ""
      },
      {
        "code": "24280",
        "name": "Xã Cư M’gar",
        "englishName": ""
      },
      {
        "code": "24286",
        "name": "Xã Ea M’Droh",
        "englishName": ""
      },
      {
        "code": "24301",
        "name": "Xã Cuôr Đăng",
        "englishName": ""
      },
      {
        "code": "24305",
        "name": "Phường Buôn Hồ",
        "englishName": ""
      },
      {
        "code": "24310",
        "name": "Xã Krông Búk",
        "englishName": ""
      },
      {
        "code": "24313",
        "name": "Xã Cư Pơng",
        "englishName": ""
      },
      {
        "code": "24316",
        "name": "Xã Pơng Drang",
        "englishName": ""
      },
      {
        "code": "24328",
        "name": "Xã Ea Drông",
        "englishName": ""
      },
      {
        "code": "24340",
        "name": "Phường Cư Bao",
        "englishName": ""
      },
      {
        "code": "24343",
        "name": "Xã Krông Năng",
        "englishName": ""
      },
      {
        "code": "24346",
        "name": "Xã Dliê Ya",
        "englishName": ""
      },
      {
        "code": "24352",
        "name": "Xã Tam Giang",
        "englishName": ""
      },
      {
        "code": "24364",
        "name": "Xã Phú Xuân",
        "englishName": ""
      },
      {
        "code": "24373",
        "name": "Xã Ea Kar",
        "englishName": ""
      },
      {
        "code": "24376",
        "name": "Xã Ea Knốp",
        "englishName": ""
      },
      {
        "code": "24400",
        "name": "Xã Ea Păl",
        "englishName": "Ea Păl commune"
      },
      {
        "code": "24403",
        "name": "Xã Ea Ô",
        "englishName": ""
      },
      {
        "code": "24406",
        "name": "Xã Cư Yang",
        "englishName": ""
      },
      {
        "code": "24412",
        "name": "Xã M’Drắk",
        "englishName": ""
      },
      {
        "code": "24415",
        "name": "Xã Cư Prao",
        "englishName": ""
      },
      {
        "code": "24433",
        "name": "Xã Ea Riêng",
        "englishName": ""
      },
      {
        "code": "24436",
        "name": "Xã Cư M’ta",
        "englishName": ""
      },
      {
        "code": "24444",
        "name": "Xã Krông Á",
        "englishName": ""
      },
      {
        "code": "24445",
        "name": "Xã Ea Trang",
        "englishName": ""
      },
      {
        "code": "24448",
        "name": "Xã Krông Bông",
        "englishName": ""
      },
      {
        "code": "24454",
        "name": "Xã Dang Kang",
        "englishName": ""
      },
      {
        "code": "24472",
        "name": "Xã Hòa Sơn",
        "englishName": ""
      },
      {
        "code": "24478",
        "name": "Xã Cư Pui",
        "englishName": ""
      },
      {
        "code": "24484",
        "name": "Xã Yang Mao",
        "englishName": ""
      },
      {
        "code": "24490",
        "name": "Xã Krông Pắc",
        "englishName": ""
      },
      {
        "code": "24496",
        "name": "Xã Ea Kly",
        "englishName": ""
      },
      {
        "code": "24502",
        "name": "Xã Ea Phê",
        "englishName": ""
      },
      {
        "code": "24505",
        "name": "Xã Ea Knuếc",
        "englishName": ""
      },
      {
        "code": "24526",
        "name": "Xã Tân Tiến",
        "englishName": ""
      },
      {
        "code": "24529",
        "name": "Xã Vụ Bổn",
        "englishName": ""
      },
      {
        "code": "24538",
        "name": "Xã Krông Ana",
        "englishName": ""
      },
      {
        "code": "24540",
        "name": "Xã Ea Ning",
        "englishName": ""
      },
      {
        "code": "24544",
        "name": "Xã Ea Ktur",
        "englishName": ""
      },
      {
        "code": "24559",
        "name": "Xã Ea Na",
        "englishName": ""
      },
      {
        "code": "24561",
        "name": "Xã Dray Bhăng",
        "englishName": "Dray Bhang Commune"
      },
      {
        "code": "24568",
        "name": "Xã Dur Kmăl",
        "englishName": ""
      },
      {
        "code": "24580",
        "name": "Xã Liên Sơn Lắk",
        "englishName": ""
      },
      {
        "code": "24595",
        "name": "Xã Đắk Liêng",
        "englishName": ""
      },
      {
        "code": "24598",
        "name": "Xã Đắk Phơi",
        "englishName": ""
      },
      {
        "code": "24604",
        "name": "Xã Krông Nô",
        "englishName": ""
      },
      {
        "code": "24607",
        "name": "Xã Nam Ka",
        "englishName": ""
      }
    ]
  },
  {
    "code": "68",
    "name": "Tỉnh Lâm Đồng",
    "englishName": "",
    "administrativeLevel": "Tỉnh",
    "communes": [
      {
        "code": "22918",
        "name": "Phường Mũi Né",
        "englishName": ""
      },
      {
        "code": "22924",
        "name": "Phường Phú Thuỷ",
        "englishName": ""
      },
      {
        "code": "22933",
        "name": "Phường Hàm Thắng",
        "englishName": ""
      },
      {
        "code": "22945",
        "name": "Phường Phan Thiết",
        "englishName": ""
      },
      {
        "code": "22954",
        "name": "Phường Tiến Thành",
        "englishName": ""
      },
      {
        "code": "22960",
        "name": "Phường Bình Thuận",
        "englishName": ""
      },
      {
        "code": "22963",
        "name": "Xã Tuyên Quang",
        "englishName": ""
      },
      {
        "code": "22969",
        "name": "Xã Liên Hương",
        "englishName": ""
      },
      {
        "code": "22972",
        "name": "Xã Phan Rí Cửa",
        "englishName": ""
      },
      {
        "code": "22978",
        "name": "Xã Tuy Phong",
        "englishName": ""
      },
      {
        "code": "22981",
        "name": "Xã Vĩnh Hảo",
        "englishName": ""
      },
      {
        "code": "23005",
        "name": "Xã Bắc Bình",
        "englishName": ""
      },
      {
        "code": "23008",
        "name": "Xã Phan Sơn",
        "englishName": ""
      },
      {
        "code": "23020",
        "name": "Xã Hải Ninh",
        "englishName": ""
      },
      {
        "code": "23023",
        "name": "Xã Sông Lũy",
        "englishName": ""
      },
      {
        "code": "23032",
        "name": "Xã Lương Sơn",
        "englishName": ""
      },
      {
        "code": "23041",
        "name": "Xã Hồng Thái",
        "englishName": ""
      },
      {
        "code": "23053",
        "name": "Xã Hòa Thắng",
        "englishName": ""
      },
      {
        "code": "23059",
        "name": "Xã Hàm Thuận",
        "englishName": ""
      },
      {
        "code": "23065",
        "name": "Xã La Dạ",
        "englishName": ""
      },
      {
        "code": "23074",
        "name": "Xã Đông Giang",
        "englishName": ""
      },
      {
        "code": "23086",
        "name": "Xã Hồng Sơn",
        "englishName": ""
      },
      {
        "code": "23089",
        "name": "Xã Hàm Thuận Bắc",
        "englishName": ""
      },
      {
        "code": "23095",
        "name": "Xã Hàm Liêm",
        "englishName": ""
      },
      {
        "code": "23110",
        "name": "Xã Hàm Thuận Nam",
        "englishName": ""
      },
      {
        "code": "23122",
        "name": "Xã Hàm Thạnh",
        "englishName": ""
      },
      {
        "code": "23128",
        "name": "Xã Hàm Kiệm",
        "englishName": ""
      },
      {
        "code": "23134",
        "name": "Xã Tân Lập",
        "englishName": ""
      },
      {
        "code": "23143",
        "name": "Xã Tân Thành",
        "englishName": ""
      },
      {
        "code": "23149",
        "name": "Xã Tánh Linh",
        "englishName": ""
      },
      {
        "code": "23152",
        "name": "Xã Bắc Ruộng",
        "englishName": ""
      },
      {
        "code": "23158",
        "name": "Xã Nghị Đức",
        "englishName": ""
      },
      {
        "code": "23173",
        "name": "Xã Đồng Kho",
        "englishName": ""
      },
      {
        "code": "23188",
        "name": "Xã Suối Kiết",
        "englishName": ""
      },
      {
        "code": "23191",
        "name": "Xã Đức Linh",
        "englishName": ""
      },
      {
        "code": "23194",
        "name": "Xã Hoài Đức",
        "englishName": ""
      },
      {
        "code": "23200",
        "name": "Xã Nam Thành",
        "englishName": ""
      },
      {
        "code": "23227",
        "name": "Xã Trà Tân",
        "englishName": ""
      },
      {
        "code": "23230",
        "name": "Xã Tân Minh",
        "englishName": ""
      },
      {
        "code": "23231",
        "name": "Phường Phước Hội",
        "englishName": ""
      },
      {
        "code": "23235",
        "name": "Phường La Gi",
        "englishName": ""
      },
      {
        "code": "23236",
        "name": "Xã Hàm Tân",
        "englishName": ""
      },
      {
        "code": "23246",
        "name": "Xã Tân Hải",
        "englishName": "Tan Tien commune"
      },
      {
        "code": "23266",
        "name": "Xã Sơn Mỹ",
        "englishName": ""
      },
      {
        "code": "23272",
        "name": "Đặc khu Phú Quý",
        "englishName": ""
      },
      {
        "code": "24611",
        "name": "Phường Bắc Gia Nghĩa",
        "englishName": "Nghĩa Đức precinct"
      },
      {
        "code": "24615",
        "name": "Phường Nam Gia Nghĩa",
        "englishName": "Nghia Tan precinct"
      },
      {
        "code": "24616",
        "name": "Xã Quảng Sơn",
        "englishName": ""
      },
      {
        "code": "24617",
        "name": "Phường Đông Gia Nghĩa",
        "englishName": "Nghia Trung precinct"
      },
      {
        "code": "24620",
        "name": "Xã Quảng Hòa",
        "englishName": ""
      },
      {
        "code": "24631",
        "name": "Xã Quảng Khê",
        "englishName": ""
      },
      {
        "code": "24637",
        "name": "Xã Tà Đùng",
        "englishName": ""
      },
      {
        "code": "24640",
        "name": "Xã Cư Jút",
        "englishName": ""
      },
      {
        "code": "24646",
        "name": "Xã Đắk Wil",
        "englishName": ""
      },
      {
        "code": "24649",
        "name": "Xã Nam Dong",
        "englishName": ""
      },
      {
        "code": "24664",
        "name": "Xã Đức Lập",
        "englishName": ""
      },
      {
        "code": "24670",
        "name": "Xã Đắk Mil",
        "englishName": ""
      },
      {
        "code": "24678",
        "name": "Xã Đắk Sắk",
        "englishName": ""
      },
      {
        "code": "24682",
        "name": "Xã Thuận An",
        "englishName": ""
      },
      {
        "code": "24688",
        "name": "Xã Krông Nô",
        "englishName": ""
      },
      {
        "code": "24697",
        "name": "Xã Nam Đà",
        "englishName": ""
      },
      {
        "code": "24703",
        "name": "Xã Nâm Nung",
        "englishName": ""
      },
      {
        "code": "24712",
        "name": "Xã Quảng Phú",
        "englishName": ""
      },
      {
        "code": "24717",
        "name": "Xã Đức An",
        "englishName": ""
      },
      {
        "code": "24718",
        "name": "Xã Đắk Song",
        "englishName": ""
      },
      {
        "code": "24722",
        "name": "Xã Thuận Hạnh",
        "englishName": ""
      },
      {
        "code": "24730",
        "name": "Xã Trường Xuân",
        "englishName": ""
      },
      {
        "code": "24733",
        "name": "Xã Kiến Đức",
        "englishName": ""
      },
      {
        "code": "24736",
        "name": "Xã Quảng Trực",
        "englishName": ""
      },
      {
        "code": "24739",
        "name": "Xã Tuy Đức",
        "englishName": ""
      },
      {
        "code": "24748",
        "name": "Xã Quảng Tân",
        "englishName": ""
      },
      {
        "code": "24751",
        "name": "Xã Nhân Cơ",
        "englishName": ""
      },
      {
        "code": "24760",
        "name": "Xã Quảng Tín",
        "englishName": ""
      },
      {
        "code": "24778",
        "name": "Phường Lâm Viên - Đà Lạt",
        "englishName": ""
      },
      {
        "code": "24781",
        "name": "Phường Xuân Hương - Đà Lạt",
        "englishName": ""
      },
      {
        "code": "24787",
        "name": "Phường Cam Ly - Đà Lạt",
        "englishName": ""
      },
      {
        "code": "24805",
        "name": "Phường Xuân Trường - Đà Lạt",
        "englishName": ""
      },
      {
        "code": "24820",
        "name": "Phường 2 Bảo Lộc",
        "englishName": ""
      },
      {
        "code": "24823",
        "name": "Phường 1 Bảo Lộc",
        "englishName": ""
      },
      {
        "code": "24829",
        "name": "Phường B’Lao",
        "englishName": ""
      },
      {
        "code": "24841",
        "name": "Phường 3 Bảo Lộc",
        "englishName": ""
      },
      {
        "code": "24846",
        "name": "Phường Lang Biang - Đà Lạt",
        "englishName": "Lac Duong Commune"
      },
      {
        "code": "24848",
        "name": "Xã Lạc Dương",
        "englishName": "Da Nhim"
      },
      {
        "code": "24853",
        "name": "Xã Đam Rông 4",
        "englishName": ""
      },
      {
        "code": "24868",
        "name": "Xã Nam Ban Lâm Hà",
        "englishName": ""
      },
      {
        "code": "24871",
        "name": "Xã Đinh Văn Lâm Hà",
        "englishName": ""
      },
      {
        "code": "24875",
        "name": "Xã Đam Rông 3",
        "englishName": ""
      },
      {
        "code": "24877",
        "name": "Xã Đam Rông 2",
        "englishName": ""
      },
      {
        "code": "24883",
        "name": "Xã Nam Hà Lâm Hà",
        "englishName": ""
      },
      {
        "code": "24886",
        "name": "Xã Đam Rông 1",
        "englishName": ""
      },
      {
        "code": "24895",
        "name": "Xã Phú Sơn Lâm Hà",
        "englishName": ""
      },
      {
        "code": "24907",
        "name": "Xã Phúc Thọ Lâm Hà",
        "englishName": ""
      },
      {
        "code": "24916",
        "name": "Xã Tân Hà Lâm Hà",
        "englishName": ""
      },
      {
        "code": "24931",
        "name": "Xã Đơn Dương",
        "englishName": ""
      },
      {
        "code": "24934",
        "name": "Xã D’Ran",
        "englishName": ""
      },
      {
        "code": "24943",
        "name": "Xã Ka Đô",
        "englishName": ""
      },
      {
        "code": "24955",
        "name": "Xã Quảng Lập",
        "englishName": ""
      },
      {
        "code": "24958",
        "name": "Xã Đức Trọng",
        "englishName": ""
      },
      {
        "code": "24967",
        "name": "Xã Hiệp Thạnh",
        "englishName": ""
      },
      {
        "code": "24976",
        "name": "Xã Tân Hội",
        "englishName": ""
      },
      {
        "code": "24985",
        "name": "Xã Ninh Gia",
        "englishName": ""
      },
      {
        "code": "24988",
        "name": "Xã Tà Năng",
        "englishName": ""
      },
      {
        "code": "24991",
        "name": "Xã Tà Hine",
        "englishName": ""
      },
      {
        "code": "25000",
        "name": "Xã Di Linh",
        "englishName": ""
      },
      {
        "code": "25007",
        "name": "Xã Đinh Trang Thượng",
        "englishName": ""
      },
      {
        "code": "25015",
        "name": "Xã Gia Hiệp",
        "englishName": ""
      },
      {
        "code": "25018",
        "name": "Xã Bảo Thuận",
        "englishName": ""
      },
      {
        "code": "25036",
        "name": "Xã Hòa Ninh",
        "englishName": ""
      },
      {
        "code": "25042",
        "name": "Xã Hòa Bắc",
        "englishName": ""
      },
      {
        "code": "25051",
        "name": "Xã Sơn Điền",
        "englishName": ""
      },
      {
        "code": "25054",
        "name": "Xã Bảo Lâm 1",
        "englishName": ""
      },
      {
        "code": "25057",
        "name": "Xã Bảo Lâm 5",
        "englishName": ""
      },
      {
        "code": "25063",
        "name": "Xã Bảo Lâm 4",
        "englishName": ""
      },
      {
        "code": "25084",
        "name": "Xã Bảo Lâm 2",
        "englishName": ""
      },
      {
        "code": "25093",
        "name": "Xã Bảo Lâm 3",
        "englishName": ""
      },
      {
        "code": "25099",
        "name": "Xã Đạ Huoai",
        "englishName": ""
      },
      {
        "code": "25105",
        "name": "Xã Đạ Huoai 2",
        "englishName": ""
      },
      {
        "code": "25114",
        "name": "Xã Đạ Huoai 3",
        "englishName": ""
      },
      {
        "code": "25126",
        "name": "Xã Đạ Tẻh",
        "englishName": ""
      },
      {
        "code": "25135",
        "name": "Xã Đạ Tẻh 3",
        "englishName": ""
      },
      {
        "code": "25138",
        "name": "Xã Đạ Tẻh 2",
        "englishName": ""
      },
      {
        "code": "25159",
        "name": "Xã Cát Tiên",
        "englishName": ""
      },
      {
        "code": "25162",
        "name": "Xã Cát Tiên 3",
        "englishName": ""
      },
      {
        "code": "25180",
        "name": "Xã Cát Tiên 2",
        "englishName": ""
      }
    ]
  },
  {
    "code": "75",
    "name": "Tỉnh Đồng Nai",
    "englishName": "",
    "administrativeLevel": "Tỉnh",
    "communes": [
      {
        "code": "25195",
        "name": "Phường Bình Phước",
        "englishName": ""
      },
      {
        "code": "25210",
        "name": "Phường Đồng Xoài",
        "englishName": ""
      },
      {
        "code": "25217",
        "name": "Phường Phước Long",
        "englishName": ""
      },
      {
        "code": "25220",
        "name": "Phường Phước Bình",
        "englishName": ""
      },
      {
        "code": "25222",
        "name": "Xã Bù Gia Mập",
        "englishName": ""
      },
      {
        "code": "25225",
        "name": "Xã Đăk Ơ",
        "englishName": ""
      },
      {
        "code": "25231",
        "name": "Xã Đa Kia",
        "englishName": ""
      },
      {
        "code": "25246",
        "name": "Xã Bình Tân",
        "englishName": ""
      },
      {
        "code": "25252",
        "name": "Xã Phú Riềng",
        "englishName": ""
      },
      {
        "code": "25255",
        "name": "Xã Long Hà",
        "englishName": ""
      },
      {
        "code": "25261",
        "name": "Xã Phú Trung",
        "englishName": ""
      },
      {
        "code": "25267",
        "name": "Xã Phú Nghĩa",
        "englishName": ""
      },
      {
        "code": "25270",
        "name": "Xã Lộc Ninh",
        "englishName": ""
      },
      {
        "code": "25279",
        "name": "Xã Lộc Tấn",
        "englishName": ""
      },
      {
        "code": "25280",
        "name": "Xã Lộc Thạnh",
        "englishName": "Loc Thanh commune"
      },
      {
        "code": "25292",
        "name": "Xã Lộc Quang",
        "englishName": ""
      },
      {
        "code": "25294",
        "name": "Xã Lộc Thành",
        "englishName": ""
      },
      {
        "code": "25303",
        "name": "Xã Lộc Hưng",
        "englishName": ""
      },
      {
        "code": "25308",
        "name": "Xã Thiện Hưng",
        "englishName": "Thanh Binh town"
      },
      {
        "code": "25309",
        "name": "Xã Hưng Phước",
        "englishName": ""
      },
      {
        "code": "25318",
        "name": "Xã Tân Tiến",
        "englishName": ""
      },
      {
        "code": "25326",
        "name": "Phường Bình Long",
        "englishName": ""
      },
      {
        "code": "25333",
        "name": "Phường An Lộc",
        "englishName": ""
      },
      {
        "code": "25345",
        "name": "Xã Tân Hưng",
        "englishName": ""
      },
      {
        "code": "25349",
        "name": "Xã Minh Đức",
        "englishName": ""
      },
      {
        "code": "25351",
        "name": "Xã Tân Quan",
        "englishName": ""
      },
      {
        "code": "25357",
        "name": "Xã Tân Khai",
        "englishName": ""
      },
      {
        "code": "25363",
        "name": "Xã Đồng Phú",
        "englishName": ""
      },
      {
        "code": "25378",
        "name": "Xã Tân Lợi",
        "englishName": ""
      },
      {
        "code": "25387",
        "name": "Xã Thuận Lợi",
        "englishName": ""
      },
      {
        "code": "25390",
        "name": "Xã Đồng Tâm",
        "englishName": ""
      },
      {
        "code": "25396",
        "name": "Xã Bù Đăng",
        "englishName": ""
      },
      {
        "code": "25399",
        "name": "Xã Đak Nhau",
        "englishName": ""
      },
      {
        "code": "25402",
        "name": "Xã Thọ Sơn",
        "englishName": ""
      },
      {
        "code": "25405",
        "name": "Xã Bom Bo",
        "englishName": ""
      },
      {
        "code": "25417",
        "name": "Xã Nghĩa Trung",
        "englishName": ""
      },
      {
        "code": "25420",
        "name": "Xã Phước Sơn",
        "englishName": ""
      },
      {
        "code": "25432",
        "name": "Phường Chơn Thành",
        "englishName": ""
      },
      {
        "code": "25441",
        "name": "Phường Minh Hưng",
        "englishName": ""
      },
      {
        "code": "25450",
        "name": "Xã Nha Bích",
        "englishName": ""
      },
      {
        "code": "25993",
        "name": "Phường Trảng Dài",
        "englishName": ""
      },
      {
        "code": "26005",
        "name": "Phường Hố Nai",
        "englishName": ""
      },
      {
        "code": "26017",
        "name": "Phường Tam Hiệp",
        "englishName": ""
      },
      {
        "code": "26020",
        "name": "Phường Long Bình",
        "englishName": ""
      },
      {
        "code": "26041",
        "name": "Phường Trấn Biên",
        "englishName": ""
      },
      {
        "code": "26068",
        "name": "Phường Biên Hòa",
        "englishName": ""
      },
      {
        "code": "26080",
        "name": "Phường Long Khánh",
        "englishName": ""
      },
      {
        "code": "26089",
        "name": "Phường Bình Lộc",
        "englishName": ""
      },
      {
        "code": "26098",
        "name": "Phường Bảo Vinh",
        "englishName": ""
      },
      {
        "code": "26104",
        "name": "Phường Xuân Lập",
        "englishName": ""
      },
      {
        "code": "26113",
        "name": "Phường Hàng Gòn",
        "englishName": ""
      },
      {
        "code": "26116",
        "name": "Xã Tân Phú",
        "englishName": ""
      },
      {
        "code": "26119",
        "name": "Xã Đak Lua",
        "englishName": ""
      },
      {
        "code": "26122",
        "name": "Xã Nam Cát Tiên",
        "englishName": ""
      },
      {
        "code": "26134",
        "name": "Xã Tà Lài",
        "englishName": ""
      },
      {
        "code": "26158",
        "name": "Xã Phú Lâm",
        "englishName": ""
      },
      {
        "code": "26170",
        "name": "Xã Trị An",
        "englishName": ""
      },
      {
        "code": "26173",
        "name": "Xã Phú Lý",
        "englishName": ""
      },
      {
        "code": "26179",
        "name": "Xã Tân An",
        "englishName": ""
      },
      {
        "code": "26188",
        "name": "Phường Tân Triều",
        "englishName": ""
      },
      {
        "code": "26206",
        "name": "Xã Định Quán",
        "englishName": ""
      },
      {
        "code": "26209",
        "name": "Xã Thanh Sơn",
        "englishName": ""
      },
      {
        "code": "26215",
        "name": "Xã Phú Vinh",
        "englishName": ""
      },
      {
        "code": "26221",
        "name": "Xã Phú Hòa",
        "englishName": ""
      },
      {
        "code": "26227",
        "name": "Xã La Ngà",
        "englishName": ""
      },
      {
        "code": "26248",
        "name": "Xã Trảng Bom",
        "englishName": ""
      },
      {
        "code": "26254",
        "name": "Xã Bàu Hàm",
        "englishName": ""
      },
      {
        "code": "26278",
        "name": "Xã Bình Minh",
        "englishName": ""
      },
      {
        "code": "26281",
        "name": "Xã Hưng Thịnh",
        "englishName": ""
      },
      {
        "code": "26296",
        "name": "Xã An Viễn",
        "englishName": ""
      },
      {
        "code": "26299",
        "name": "Xã Thống Nhất",
        "englishName": ""
      },
      {
        "code": "26311",
        "name": "Xã Gia Kiệm",
        "englishName": ""
      },
      {
        "code": "26326",
        "name": "Xã Dầu Giây",
        "englishName": ""
      },
      {
        "code": "26332",
        "name": "Xã Xuân Quế",
        "englishName": ""
      },
      {
        "code": "26341",
        "name": "Xã Cẩm Mỹ",
        "englishName": ""
      },
      {
        "code": "26347",
        "name": "Xã Xuân Đường",
        "englishName": ""
      },
      {
        "code": "26359",
        "name": "Xã Xuân Đông",
        "englishName": ""
      },
      {
        "code": "26362",
        "name": "Xã Sông Ray",
        "englishName": ""
      },
      {
        "code": "26368",
        "name": "Xã Long Thành",
        "englishName": ""
      },
      {
        "code": "26374",
        "name": "Phường Tam Phước",
        "englishName": ""
      },
      {
        "code": "26377",
        "name": "Phường Phước Tân",
        "englishName": ""
      },
      {
        "code": "26380",
        "name": "Phường Long Hưng",
        "englishName": ""
      },
      {
        "code": "26383",
        "name": "Xã An Phước",
        "englishName": ""
      },
      {
        "code": "26389",
        "name": "Xã Bình An",
        "englishName": ""
      },
      {
        "code": "26413",
        "name": "Xã Long Phước",
        "englishName": ""
      },
      {
        "code": "26422",
        "name": "Xã Phước Thái",
        "englishName": ""
      },
      {
        "code": "26425",
        "name": "Xã Xuân Lộc",
        "englishName": ""
      },
      {
        "code": "26428",
        "name": "Xã Xuân Bắc",
        "englishName": ""
      },
      {
        "code": "26434",
        "name": "Xã Xuân Thành",
        "englishName": ""
      },
      {
        "code": "26446",
        "name": "Xã Xuân Hòa",
        "englishName": ""
      },
      {
        "code": "26458",
        "name": "Xã Xuân Phú",
        "englishName": ""
      },
      {
        "code": "26461",
        "name": "Xã Xuân Định",
        "englishName": ""
      },
      {
        "code": "26485",
        "name": "Xã Nhơn Trạch",
        "englishName": ""
      },
      {
        "code": "26491",
        "name": "Xã Đại Phước",
        "englishName": ""
      },
      {
        "code": "26503",
        "name": "Xã Phước An",
        "englishName": ""
      }
    ]
  },
  {
    "code": "79",
    "name": "Thành phố Hồ Chí Minh",
    "englishName": "",
    "administrativeLevel": "Thành phố Trung ương",
    "communes": [
      {
        "code": "25747",
        "name": "Phường Thủ Dầu Một",
        "englishName": ""
      },
      {
        "code": "25750",
        "name": "Phường Phú Lợi",
        "englishName": ""
      },
      {
        "code": "25760",
        "name": "Phường Bình Dương",
        "englishName": ""
      },
      {
        "code": "25768",
        "name": "Phường Phú An",
        "englishName": ""
      },
      {
        "code": "25771",
        "name": "Phường Chánh Hiệp",
        "englishName": ""
      },
      {
        "code": "25777",
        "name": "Xã Dầu Tiếng",
        "englishName": ""
      },
      {
        "code": "25780",
        "name": "Xã Minh Thạnh",
        "englishName": ""
      },
      {
        "code": "25792",
        "name": "Xã Long Hòa",
        "englishName": ""
      },
      {
        "code": "25807",
        "name": "Xã Thanh An",
        "englishName": ""
      },
      {
        "code": "25813",
        "name": "Phường Bến Cát",
        "englishName": ""
      },
      {
        "code": "25819",
        "name": "Xã Trừ Văn Thố",
        "englishName": ""
      },
      {
        "code": "25822",
        "name": "Xã Bàu Bàng",
        "englishName": ""
      },
      {
        "code": "25837",
        "name": "Phường Chánh Phú Hòa",
        "englishName": ""
      },
      {
        "code": "25840",
        "name": "Phường Long Nguyên",
        "englishName": ""
      },
      {
        "code": "25843",
        "name": "Phường Tây Nam",
        "englishName": ""
      },
      {
        "code": "25846",
        "name": "Phường Thới Hòa",
        "englishName": ""
      },
      {
        "code": "25849",
        "name": "Phường Hòa Lợi",
        "englishName": ""
      },
      {
        "code": "25858",
        "name": "Xã Phú Giáo",
        "englishName": ""
      },
      {
        "code": "25864",
        "name": "Xã Phước Thành",
        "englishName": ""
      },
      {
        "code": "25867",
        "name": "Xã An Long",
        "englishName": ""
      },
      {
        "code": "25882",
        "name": "Xã Phước Hòa",
        "englishName": ""
      },
      {
        "code": "25888",
        "name": "Phường Tân Uyên",
        "englishName": ""
      },
      {
        "code": "25891",
        "name": "Phường Tân Khánh",
        "englishName": ""
      },
      {
        "code": "25906",
        "name": "Xã Bắc Tân Uyên",
        "englishName": ""
      },
      {
        "code": "25909",
        "name": "Xã Thường Tân",
        "englishName": ""
      },
      {
        "code": "25912",
        "name": "Phường Vĩnh Tân",
        "englishName": ""
      },
      {
        "code": "25915",
        "name": "Phường Bình Cơ",
        "englishName": ""
      },
      {
        "code": "25920",
        "name": "Phường Tân Hiệp",
        "englishName": "Tan Hiep Commune"
      },
      {
        "code": "25942",
        "name": "Phường Dĩ An",
        "englishName": ""
      },
      {
        "code": "25945",
        "name": "Phường Tân Đông Hiệp",
        "englishName": ""
      },
      {
        "code": "25951",
        "name": "Phường Đông Hòa",
        "englishName": ""
      },
      {
        "code": "25966",
        "name": "Phường Lái Thiêu",
        "englishName": ""
      },
      {
        "code": "25969",
        "name": "Phường Thuận Giao",
        "englishName": ""
      },
      {
        "code": "25975",
        "name": "Phường An Phú",
        "englishName": ""
      },
      {
        "code": "25978",
        "name": "Phường Thuận An",
        "englishName": ""
      },
      {
        "code": "25987",
        "name": "Phường Bình Hòa",
        "englishName": ""
      },
      {
        "code": "26506",
        "name": "Phường Vũng Tàu",
        "englishName": ""
      },
      {
        "code": "26526",
        "name": "Phường Tam Thắng",
        "englishName": "Ninh An Nguyên Commune"
      },
      {
        "code": "26536",
        "name": "Phường Rạch Dừa",
        "englishName": ""
      },
      {
        "code": "26542",
        "name": "Phường Phước Thắng",
        "englishName": ""
      },
      {
        "code": "26545",
        "name": "Xã Long Sơn",
        "englishName": ""
      },
      {
        "code": "26560",
        "name": "Phường Bà Rịa",
        "englishName": ""
      },
      {
        "code": "26566",
        "name": "Phường Long Hương",
        "englishName": ""
      },
      {
        "code": "26572",
        "name": "Phường Tam Long",
        "englishName": ""
      },
      {
        "code": "26575",
        "name": "Xã Ngãi Giao",
        "englishName": ""
      },
      {
        "code": "26584",
        "name": "Xã Xuân Sơn",
        "englishName": ""
      },
      {
        "code": "26590",
        "name": "Xã Bình Giã",
        "englishName": ""
      },
      {
        "code": "26596",
        "name": "Xã Châu Đức",
        "englishName": ""
      },
      {
        "code": "26608",
        "name": "Xã Kim Long",
        "englishName": ""
      },
      {
        "code": "26617",
        "name": "Xã Nghĩa Thành",
        "englishName": ""
      },
      {
        "code": "26620",
        "name": "Xã Hồ Tràm",
        "englishName": ""
      },
      {
        "code": "26632",
        "name": "Xã Xuyên Mộc",
        "englishName": ""
      },
      {
        "code": "26638",
        "name": "Xã Bàu Lâm",
        "englishName": ""
      },
      {
        "code": "26641",
        "name": "Xã Hòa Hội",
        "englishName": ""
      },
      {
        "code": "26647",
        "name": "Xã Hòa Hiệp",
        "englishName": ""
      },
      {
        "code": "26656",
        "name": "Xã Bình Châu",
        "englishName": ""
      },
      {
        "code": "26659",
        "name": "Xã Long Điền",
        "englishName": ""
      },
      {
        "code": "26662",
        "name": "Xã Long Hải",
        "englishName": ""
      },
      {
        "code": "26680",
        "name": "Xã Đất Đỏ",
        "englishName": ""
      },
      {
        "code": "26686",
        "name": "Xã Phước Hải",
        "englishName": ""
      },
      {
        "code": "26704",
        "name": "Phường Phú Mỹ",
        "englishName": ""
      },
      {
        "code": "26710",
        "name": "Phường Tân Hải",
        "englishName": ""
      },
      {
        "code": "26713",
        "name": "Phường Tân Phước",
        "englishName": ""
      },
      {
        "code": "26725",
        "name": "Phường Tân Thành",
        "englishName": ""
      },
      {
        "code": "26728",
        "name": "Xã Châu Pha",
        "englishName": ""
      },
      {
        "code": "26732",
        "name": "Đặc khu Côn Đảo",
        "englishName": ""
      },
      {
        "code": "26737",
        "name": "Phường Tân Định",
        "englishName": ""
      },
      {
        "code": "26740",
        "name": "Phường Sài Gòn",
        "englishName": ""
      },
      {
        "code": "26743",
        "name": "Phường Bến Thành",
        "englishName": ""
      },
      {
        "code": "26758",
        "name": "Phường Cầu Ông Lãnh",
        "englishName": ""
      },
      {
        "code": "26767",
        "name": "Phường An Phú Đông",
        "englishName": ""
      },
      {
        "code": "26773",
        "name": "Phường Thới An",
        "englishName": ""
      },
      {
        "code": "26782",
        "name": "Phường Tân Thới Hiệp",
        "englishName": ""
      },
      {
        "code": "26785",
        "name": "Phường Trung Mỹ Tây",
        "englishName": ""
      },
      {
        "code": "26791",
        "name": "Phường Đông Hưng Thuận",
        "englishName": ""
      },
      {
        "code": "26800",
        "name": "Phường Linh Xuân",
        "englishName": ""
      },
      {
        "code": "26803",
        "name": "Phường Tam Bình",
        "englishName": ""
      },
      {
        "code": "26809",
        "name": "Phường Hiệp Bình",
        "englishName": ""
      },
      {
        "code": "26824",
        "name": "Phường Thủ Đức",
        "englishName": ""
      },
      {
        "code": "26833",
        "name": "Phường Long Bình",
        "englishName": ""
      },
      {
        "code": "26842",
        "name": "Phường Tăng Nhơn Phú",
        "englishName": ""
      },
      {
        "code": "26848",
        "name": "Phường Phước Long",
        "englishName": ""
      },
      {
        "code": "26857",
        "name": "Phường Long Phước",
        "englishName": ""
      },
      {
        "code": "26860",
        "name": "Phường Long Trường",
        "englishName": ""
      },
      {
        "code": "26876",
        "name": "Phường An Nhơn",
        "englishName": ""
      },
      {
        "code": "26878",
        "name": "Phường An Hội Đông",
        "englishName": ""
      },
      {
        "code": "26882",
        "name": "Phường An Hội Tây",
        "englishName": ""
      },
      {
        "code": "26884",
        "name": "Phường Gò Vấp",
        "englishName": ""
      },
      {
        "code": "26890",
        "name": "Phường Hạnh Thông",
        "englishName": ""
      },
      {
        "code": "26898",
        "name": "Phường Thông Tây Hội",
        "englishName": ""
      },
      {
        "code": "26905",
        "name": "Phường Bình Lợi Trung",
        "englishName": ""
      },
      {
        "code": "26911",
        "name": "Phường Bình Quới",
        "englishName": ""
      },
      {
        "code": "26929",
        "name": "Phường Bình Thạnh",
        "englishName": ""
      },
      {
        "code": "26944",
        "name": "Phường Gia Định",
        "englishName": ""
      },
      {
        "code": "26956",
        "name": "Phường Thạnh Mỹ Tây",
        "englishName": ""
      },
      {
        "code": "26968",
        "name": "Phường Tân Sơn Nhất",
        "englishName": ""
      },
      {
        "code": "26977",
        "name": "Phường Tân Sơn Hòa",
        "englishName": ""
      },
      {
        "code": "26983",
        "name": "Phường Bảy Hiền",
        "englishName": ""
      },
      {
        "code": "26995",
        "name": "Phường Tân Hòa",
        "englishName": ""
      },
      {
        "code": "27004",
        "name": "Phường Tân Bình",
        "englishName": ""
      },
      {
        "code": "27007",
        "name": "Phường Tân Sơn",
        "englishName": ""
      },
      {
        "code": "27013",
        "name": "Phường Tây Thạnh",
        "englishName": ""
      },
      {
        "code": "27019",
        "name": "Phường Tân Sơn Nhì",
        "englishName": ""
      },
      {
        "code": "27022",
        "name": "Phường Phú Thọ Hòa",
        "englishName": ""
      },
      {
        "code": "27028",
        "name": "Phường Phú Thạnh",
        "englishName": ""
      },
      {
        "code": "27031",
        "name": "Phường Tân Phú",
        "englishName": ""
      },
      {
        "code": "27043",
        "name": "Phường Đức Nhuận",
        "englishName": ""
      },
      {
        "code": "27058",
        "name": "Phường Cầu Kiệu",
        "englishName": ""
      },
      {
        "code": "27073",
        "name": "Phường Phú Nhuận",
        "englishName": ""
      },
      {
        "code": "27094",
        "name": "Phường An Khánh",
        "englishName": ""
      },
      {
        "code": "27097",
        "name": "Phường Bình Trưng",
        "englishName": ""
      },
      {
        "code": "27112",
        "name": "Phường Cát Lái",
        "englishName": ""
      },
      {
        "code": "27139",
        "name": "Phường Xuân Hòa",
        "englishName": ""
      },
      {
        "code": "27142",
        "name": "Phường Nhiêu Lộc",
        "englishName": ""
      },
      {
        "code": "27154",
        "name": "Phường Bàn Cờ",
        "englishName": ""
      },
      {
        "code": "27163",
        "name": "Phường Hòa Hưng",
        "englishName": ""
      },
      {
        "code": "27169",
        "name": "Phường Diên Hồng",
        "englishName": ""
      },
      {
        "code": "27190",
        "name": "Phường Vườn Lài",
        "englishName": ""
      },
      {
        "code": "27211",
        "name": "Phường Hòa Bình",
        "englishName": ""
      },
      {
        "code": "27226",
        "name": "Phường Phú Thọ",
        "englishName": ""
      },
      {
        "code": "27232",
        "name": "Phường Bình Thới",
        "englishName": ""
      },
      {
        "code": "27238",
        "name": "Phường Minh Phụng",
        "englishName": ""
      },
      {
        "code": "27259",
        "name": "Phường Xóm Chiếu",
        "englishName": ""
      },
      {
        "code": "27265",
        "name": "Phường Khánh Hội",
        "englishName": ""
      },
      {
        "code": "27286",
        "name": "Phường Vĩnh Hội",
        "englishName": ""
      },
      {
        "code": "27301",
        "name": "Phường Chợ Quán",
        "englishName": ""
      },
      {
        "code": "27316",
        "name": "Phường An Đông",
        "englishName": ""
      },
      {
        "code": "27343",
        "name": "Phường Chợ Lớn",
        "englishName": ""
      },
      {
        "code": "27349",
        "name": "Phường Phú Lâm",
        "englishName": ""
      },
      {
        "code": "27364",
        "name": "Phường Bình Phú",
        "englishName": ""
      },
      {
        "code": "27367",
        "name": "Phường Bình Tây",
        "englishName": ""
      },
      {
        "code": "27373",
        "name": "Phường Bình Tiên",
        "englishName": ""
      },
      {
        "code": "27418",
        "name": "Phường Chánh Hưng",
        "englishName": ""
      },
      {
        "code": "27424",
        "name": "Phường Bình Đông",
        "englishName": ""
      },
      {
        "code": "27427",
        "name": "Phường Phú Định",
        "englishName": ""
      },
      {
        "code": "27439",
        "name": "Phường Bình Hưng Hòa",
        "englishName": ""
      },
      {
        "code": "27442",
        "name": "Phường Bình Tân",
        "englishName": ""
      },
      {
        "code": "27448",
        "name": "Phường Bình Trị Đông",
        "englishName": ""
      },
      {
        "code": "27457",
        "name": "Phường Tân Tạo",
        "englishName": ""
      },
      {
        "code": "27460",
        "name": "Phường An Lạc",
        "englishName": ""
      },
      {
        "code": "27475",
        "name": "Phường Tân Hưng",
        "englishName": ""
      },
      {
        "code": "27478",
        "name": "Phường Tân Thuận",
        "englishName": ""
      },
      {
        "code": "27484",
        "name": "Phường Phú Thuận",
        "englishName": ""
      },
      {
        "code": "27487",
        "name": "Phường Tân Mỹ",
        "englishName": ""
      },
      {
        "code": "27496",
        "name": "Xã Tân An Hội",
        "englishName": ""
      },
      {
        "code": "27508",
        "name": "Xã An Nhơn Tây",
        "englishName": ""
      },
      {
        "code": "27511",
        "name": "Xã Nhuận Đức",
        "englishName": ""
      },
      {
        "code": "27526",
        "name": "Xã Thái Mỹ",
        "englishName": ""
      },
      {
        "code": "27541",
        "name": "Xã Phú Hòa Đông",
        "englishName": ""
      },
      {
        "code": "27544",
        "name": "Xã Bình Mỹ",
        "englishName": ""
      },
      {
        "code": "27553",
        "name": "Xã Củ Chi",
        "englishName": ""
      },
      {
        "code": "27559",
        "name": "Xã Hóc Môn",
        "englishName": ""
      },
      {
        "code": "27568",
        "name": "Xã Đông Thạnh",
        "englishName": ""
      },
      {
        "code": "27577",
        "name": "Xã Xuân Thới Sơn",
        "englishName": ""
      },
      {
        "code": "27592",
        "name": "Xã Bà Điểm",
        "englishName": ""
      },
      {
        "code": "27595",
        "name": "Xã Tân Nhựt",
        "englishName": ""
      },
      {
        "code": "27601",
        "name": "Xã Vĩnh Lộc",
        "englishName": ""
      },
      {
        "code": "27604",
        "name": "Xã Tân Vĩnh Lộc",
        "englishName": ""
      },
      {
        "code": "27610",
        "name": "Xã Bình Lợi",
        "englishName": ""
      },
      {
        "code": "27619",
        "name": "Xã Bình Hưng",
        "englishName": ""
      },
      {
        "code": "27628",
        "name": "Xã Hưng Long",
        "englishName": ""
      },
      {
        "code": "27637",
        "name": "Xã Bình Chánh",
        "englishName": ""
      },
      {
        "code": "27655",
        "name": "Xã Nhà Bè",
        "englishName": ""
      },
      {
        "code": "27658",
        "name": "Xã Hiệp Phước",
        "englishName": ""
      },
      {
        "code": "27664",
        "name": "Xã Cần Giờ",
        "englishName": ""
      },
      {
        "code": "27667",
        "name": "Xã Bình Khánh",
        "englishName": ""
      },
      {
        "code": "27673",
        "name": "Xã An Thới Đông",
        "englishName": ""
      },
      {
        "code": "27676",
        "name": "Xã Thạnh An",
        "englishName": ""
      }
    ]
  },
  {
    "code": "80",
    "name": "Tỉnh Tây Ninh",
    "englishName": "",
    "administrativeLevel": "Tỉnh",
    "communes": [
      {
        "code": "25459",
        "name": "Phường Tân Ninh",
        "englishName": ""
      },
      {
        "code": "25480",
        "name": "Phường Bình Minh",
        "englishName": ""
      },
      {
        "code": "25486",
        "name": "Xã Tân Biên",
        "englishName": ""
      },
      {
        "code": "25489",
        "name": "Xã Tân Lập",
        "englishName": ""
      },
      {
        "code": "25498",
        "name": "Xã Thạnh Bình",
        "englishName": ""
      },
      {
        "code": "25510",
        "name": "Xã Trà Vong",
        "englishName": ""
      },
      {
        "code": "25516",
        "name": "Xã Tân Châu",
        "englishName": ""
      },
      {
        "code": "25522",
        "name": "Xã Tân Đông",
        "englishName": ""
      },
      {
        "code": "25525",
        "name": "Xã Tân Hội",
        "englishName": ""
      },
      {
        "code": "25531",
        "name": "Xã Tân Hòa",
        "englishName": ""
      },
      {
        "code": "25534",
        "name": "Xã Tân Thành",
        "englishName": ""
      },
      {
        "code": "25549",
        "name": "Xã Tân Phú",
        "englishName": ""
      },
      {
        "code": "25552",
        "name": "Xã Dương Minh Châu",
        "englishName": ""
      },
      {
        "code": "25567",
        "name": "Phường Ninh Thạnh",
        "englishName": ""
      },
      {
        "code": "25573",
        "name": "Xã Cầu Khởi",
        "englishName": ""
      },
      {
        "code": "25579",
        "name": "Xã Lộc Ninh",
        "englishName": ""
      },
      {
        "code": "25585",
        "name": "Xã Châu Thành",
        "englishName": ""
      },
      {
        "code": "25588",
        "name": "Xã Hảo Đước",
        "englishName": ""
      },
      {
        "code": "25591",
        "name": "Xã Phước Vinh",
        "englishName": ""
      },
      {
        "code": "25606",
        "name": "Xã Hòa Hội",
        "englishName": ""
      },
      {
        "code": "25621",
        "name": "Xã Ninh Điền",
        "englishName": ""
      },
      {
        "code": "25630",
        "name": "Phường Long Hoa",
        "englishName": ""
      },
      {
        "code": "25633",
        "name": "Phường Thanh Điền",
        "englishName": ""
      },
      {
        "code": "25645",
        "name": "Phường Hòa Thành",
        "englishName": ""
      },
      {
        "code": "25654",
        "name": "Phường Gò Dầu",
        "englishName": ""
      },
      {
        "code": "25657",
        "name": "Xã Thạnh Đức",
        "englishName": ""
      },
      {
        "code": "25663",
        "name": "Xã Phước Thạnh",
        "englishName": ""
      },
      {
        "code": "25666",
        "name": "Xã Truông Mít",
        "englishName": ""
      },
      {
        "code": "25672",
        "name": "Phường Gia Lộc",
        "englishName": ""
      },
      {
        "code": "25681",
        "name": "Xã Bến Cầu",
        "englishName": ""
      },
      {
        "code": "25684",
        "name": "Xã Long Chữ",
        "englishName": ""
      },
      {
        "code": "25702",
        "name": "Xã Long Thuận",
        "englishName": ""
      },
      {
        "code": "25708",
        "name": "Phường Trảng Bàng",
        "englishName": ""
      },
      {
        "code": "25711",
        "name": "Xã Hưng Thuận",
        "englishName": ""
      },
      {
        "code": "25729",
        "name": "Xã Phước Chỉ",
        "englishName": ""
      },
      {
        "code": "25732",
        "name": "Phường An Tịnh",
        "englishName": ""
      },
      {
        "code": "27694",
        "name": "Phường Long An",
        "englishName": ""
      },
      {
        "code": "27712",
        "name": "Phường Tân An",
        "englishName": ""
      },
      {
        "code": "27715",
        "name": "Phường Khánh Hậu",
        "englishName": ""
      },
      {
        "code": "27721",
        "name": "Xã Tân Hưng",
        "englishName": ""
      },
      {
        "code": "27727",
        "name": "Xã Hưng Điền",
        "englishName": ""
      },
      {
        "code": "27736",
        "name": "Xã Vĩnh Thạnh",
        "englishName": ""
      },
      {
        "code": "27748",
        "name": "Xã Vĩnh Châu",
        "englishName": ""
      },
      {
        "code": "27757",
        "name": "Xã Vĩnh Hưng",
        "englishName": ""
      },
      {
        "code": "27763",
        "name": "Xã Khánh Hưng",
        "englishName": ""
      },
      {
        "code": "27775",
        "name": "Xã Tuyên Bình",
        "englishName": ""
      },
      {
        "code": "27787",
        "name": "Phường Kiến Tường",
        "englishName": ""
      },
      {
        "code": "27793",
        "name": "Xã Bình Hiệp",
        "englishName": ""
      },
      {
        "code": "27811",
        "name": "Xã Bình Hòa",
        "englishName": ""
      },
      {
        "code": "27817",
        "name": "Xã Tuyên Thạnh",
        "englishName": ""
      },
      {
        "code": "27823",
        "name": "Xã Mộc Hóa",
        "englishName": ""
      },
      {
        "code": "27826",
        "name": "Xã Tân Thạnh",
        "englishName": ""
      },
      {
        "code": "27838",
        "name": "Xã Nhơn Hòa Lập",
        "englishName": ""
      },
      {
        "code": "27841",
        "name": "Xã Hậu Thạnh",
        "englishName": ""
      },
      {
        "code": "27856",
        "name": "Xã Nhơn Ninh",
        "englishName": ""
      },
      {
        "code": "27865",
        "name": "Xã Thạnh Hóa",
        "englishName": ""
      },
      {
        "code": "27868",
        "name": "Xã Bình Thành",
        "englishName": ""
      },
      {
        "code": "27877",
        "name": "Xã Thạnh Phước",
        "englishName": ""
      },
      {
        "code": "27889",
        "name": "Xã Tân Tây",
        "englishName": ""
      },
      {
        "code": "27898",
        "name": "Xã Đông Thành",
        "englishName": ""
      },
      {
        "code": "27907",
        "name": "Xã Mỹ Quý",
        "englishName": ""
      },
      {
        "code": "27925",
        "name": "Xã Đức Huệ",
        "englishName": ""
      },
      {
        "code": "27931",
        "name": "Xã Hậu Nghĩa",
        "englishName": ""
      },
      {
        "code": "27937",
        "name": "Xã Đức Hòa",
        "englishName": ""
      },
      {
        "code": "27943",
        "name": "Xã An Ninh",
        "englishName": ""
      },
      {
        "code": "27952",
        "name": "Xã Hiệp Hòa",
        "englishName": ""
      },
      {
        "code": "27964",
        "name": "Xã Đức Lập",
        "englishName": ""
      },
      {
        "code": "27976",
        "name": "Xã Mỹ Hạnh",
        "englishName": ""
      },
      {
        "code": "27979",
        "name": "Xã Hòa Khánh",
        "englishName": ""
      },
      {
        "code": "27991",
        "name": "Xã Bến Lức",
        "englishName": ""
      },
      {
        "code": "27994",
        "name": "Xã Thạnh Lợi",
        "englishName": ""
      },
      {
        "code": "28003",
        "name": "Xã Lương Hòa",
        "englishName": ""
      },
      {
        "code": "28015",
        "name": "Xã Bình Đức",
        "englishName": ""
      },
      {
        "code": "28018",
        "name": "Xã Mỹ Yên",
        "englishName": ""
      },
      {
        "code": "28036",
        "name": "Xã Thủ Thừa",
        "englishName": ""
      },
      {
        "code": "28051",
        "name": "Xã Mỹ Thạnh",
        "englishName": ""
      },
      {
        "code": "28066",
        "name": "Xã Mỹ An",
        "englishName": ""
      },
      {
        "code": "28072",
        "name": "Xã Tân Long",
        "englishName": ""
      },
      {
        "code": "28075",
        "name": "Xã Tân Trụ",
        "englishName": ""
      },
      {
        "code": "28087",
        "name": "Xã Nhựt Tảo",
        "englishName": ""
      },
      {
        "code": "28093",
        "name": "Xã Vàm Cỏ",
        "englishName": ""
      },
      {
        "code": "28108",
        "name": "Xã Cần Đước",
        "englishName": ""
      },
      {
        "code": "28114",
        "name": "Xã Rạch Kiến",
        "englishName": ""
      },
      {
        "code": "28126",
        "name": "Xã Long Cang",
        "englishName": ""
      },
      {
        "code": "28132",
        "name": "Xã Mỹ Lệ",
        "englishName": ""
      },
      {
        "code": "28138",
        "name": "Xã Tân Lân",
        "englishName": ""
      },
      {
        "code": "28144",
        "name": "Xã Long Hựu",
        "englishName": ""
      },
      {
        "code": "28159",
        "name": "Xã Cần Giuộc",
        "englishName": ""
      },
      {
        "code": "28165",
        "name": "Xã Phước Lý",
        "englishName": ""
      },
      {
        "code": "28177",
        "name": "Xã Mỹ Lộc",
        "englishName": ""
      },
      {
        "code": "28201",
        "name": "Xã Phước Vĩnh Tây",
        "englishName": ""
      },
      {
        "code": "28207",
        "name": "Xã Tân Tập",
        "englishName": ""
      },
      {
        "code": "28210",
        "name": "Xã Tầm Vu",
        "englishName": ""
      },
      {
        "code": "28222",
        "name": "Xã Vĩnh Công",
        "englishName": ""
      },
      {
        "code": "28225",
        "name": "Xã Thuận Mỹ",
        "englishName": ""
      },
      {
        "code": "28243",
        "name": "Xã An Lục Long",
        "englishName": ""
      }
    ]
  },
  {
    "code": "82",
    "name": "Tỉnh Đồng Tháp",
    "englishName": "",
    "administrativeLevel": "Tỉnh",
    "communes": [
      {
        "code": "28249",
        "name": "Phường Đạo Thạnh",
        "englishName": ""
      },
      {
        "code": "28261",
        "name": "Phường Mỹ Tho",
        "englishName": ""
      },
      {
        "code": "28270",
        "name": "Phường Thới Sơn",
        "englishName": ""
      },
      {
        "code": "28273",
        "name": "Phường Mỹ Phong",
        "englishName": ""
      },
      {
        "code": "28285",
        "name": "Phường Trung An",
        "englishName": ""
      },
      {
        "code": "28297",
        "name": "Phường Long Thuận",
        "englishName": ""
      },
      {
        "code": "28306",
        "name": "Phường Gò Công",
        "englishName": ""
      },
      {
        "code": "28315",
        "name": "Phường Bình Xuân",
        "englishName": ""
      },
      {
        "code": "28321",
        "name": "Xã Tân Phước 1",
        "englishName": ""
      },
      {
        "code": "28327",
        "name": "Xã Tân Phước 2",
        "englishName": ""
      },
      {
        "code": "28336",
        "name": "Xã Hưng Thạnh",
        "englishName": ""
      },
      {
        "code": "28345",
        "name": "Xã Tân Phước 3",
        "englishName": ""
      },
      {
        "code": "28360",
        "name": "Xã Cái Bè",
        "englishName": ""
      },
      {
        "code": "28366",
        "name": "Xã Hậu Mỹ",
        "englishName": ""
      },
      {
        "code": "28378",
        "name": "Xã Mỹ Thiện",
        "englishName": ""
      },
      {
        "code": "28393",
        "name": "Xã Hội Cư",
        "englishName": ""
      },
      {
        "code": "28405",
        "name": "Xã Mỹ Đức Tây",
        "englishName": ""
      },
      {
        "code": "28414",
        "name": "Xã Mỹ Lợi",
        "englishName": ""
      },
      {
        "code": "28426",
        "name": "Xã Thanh Hưng",
        "englishName": ""
      },
      {
        "code": "28429",
        "name": "Xã An Hữu",
        "englishName": ""
      },
      {
        "code": "28435",
        "name": "Phường Mỹ Phước Tây",
        "englishName": ""
      },
      {
        "code": "28436",
        "name": "Phường Thanh Hòa",
        "englishName": ""
      },
      {
        "code": "28439",
        "name": "Phường Cai Lậy",
        "englishName": ""
      },
      {
        "code": "28444",
        "name": "Xã Thạnh Phú",
        "englishName": ""
      },
      {
        "code": "28456",
        "name": "Xã Mỹ Thành",
        "englishName": ""
      },
      {
        "code": "28468",
        "name": "Xã Tân Phú",
        "englishName": ""
      },
      {
        "code": "28471",
        "name": "Xã Bình Phú",
        "englishName": ""
      },
      {
        "code": "28477",
        "name": "Phường Nhị Quý",
        "englishName": ""
      },
      {
        "code": "28501",
        "name": "Xã Hiệp Đức",
        "englishName": ""
      },
      {
        "code": "28504",
        "name": "Xã Long Tiên",
        "englishName": ""
      },
      {
        "code": "28516",
        "name": "Xã Ngũ Hiệp",
        "englishName": ""
      },
      {
        "code": "28519",
        "name": "Xã Châu Thành",
        "englishName": ""
      },
      {
        "code": "28525",
        "name": "Xã Tân Hương",
        "englishName": ""
      },
      {
        "code": "28537",
        "name": "Xã Long Hưng",
        "englishName": ""
      },
      {
        "code": "28543",
        "name": "Xã Long Định",
        "englishName": ""
      },
      {
        "code": "28564",
        "name": "Xã Bình Trưng",
        "englishName": ""
      },
      {
        "code": "28576",
        "name": "Xã Vĩnh Kim",
        "englishName": ""
      },
      {
        "code": "28582",
        "name": "Xã Kim Sơn",
        "englishName": ""
      },
      {
        "code": "28594",
        "name": "Xã Chợ Gạo",
        "englishName": ""
      },
      {
        "code": "28603",
        "name": "Xã Mỹ Tịnh An",
        "englishName": ""
      },
      {
        "code": "28615",
        "name": "Xã Lương Hòa Lạc",
        "englishName": ""
      },
      {
        "code": "28627",
        "name": "Xã Tân Thuận Bình",
        "englishName": ""
      },
      {
        "code": "28633",
        "name": "Xã An Thạnh Thủy",
        "englishName": ""
      },
      {
        "code": "28648",
        "name": "Xã Bình Ninh",
        "englishName": ""
      },
      {
        "code": "28651",
        "name": "Xã Vĩnh Bình",
        "englishName": ""
      },
      {
        "code": "28660",
        "name": "Xã Đồng Sơn",
        "englishName": ""
      },
      {
        "code": "28663",
        "name": "Xã Phú Thành",
        "englishName": ""
      },
      {
        "code": "28678",
        "name": "Xã Vĩnh Hựu",
        "englishName": ""
      },
      {
        "code": "28687",
        "name": "Xã Long Bình",
        "englishName": ""
      },
      {
        "code": "28693",
        "name": "Xã Tân Thới",
        "englishName": ""
      },
      {
        "code": "28696",
        "name": "Xã Tân Phú Đông",
        "englishName": ""
      },
      {
        "code": "28702",
        "name": "Xã Tân Hòa",
        "englishName": ""
      },
      {
        "code": "28720",
        "name": "Xã Gia Thuận",
        "englishName": ""
      },
      {
        "code": "28723",
        "name": "Xã Tân Đông",
        "englishName": ""
      },
      {
        "code": "28729",
        "name": "Phường Sơn Qui",
        "englishName": ""
      },
      {
        "code": "28738",
        "name": "Xã Tân Điền",
        "englishName": ""
      },
      {
        "code": "28747",
        "name": "Xã Gò Công Đông",
        "englishName": ""
      },
      {
        "code": "29869",
        "name": "Phường Cao Lãnh",
        "englishName": ""
      },
      {
        "code": "29884",
        "name": "Phường Mỹ Ngãi",
        "englishName": ""
      },
      {
        "code": "29888",
        "name": "Phường Mỹ Trà",
        "englishName": "My Phu Commune"
      },
      {
        "code": "29905",
        "name": "Phường Sa Đéc",
        "englishName": ""
      },
      {
        "code": "29926",
        "name": "Xã Tân Hồng",
        "englishName": ""
      },
      {
        "code": "29929",
        "name": "Xã Tân Hộ Cơ",
        "englishName": ""
      },
      {
        "code": "29938",
        "name": "Xã Tân Thành",
        "englishName": ""
      },
      {
        "code": "29944",
        "name": "Xã An Phước",
        "englishName": ""
      },
      {
        "code": "29954",
        "name": "Phường An Bình",
        "englishName": ""
      },
      {
        "code": "29955",
        "name": "Phường Hồng Ngự",
        "englishName": ""
      },
      {
        "code": "29971",
        "name": "Xã Thường Phước",
        "englishName": ""
      },
      {
        "code": "29978",
        "name": "Phường Thường Lạc",
        "englishName": ""
      },
      {
        "code": "29983",
        "name": "Xã Long Khánh",
        "englishName": ""
      },
      {
        "code": "29992",
        "name": "Xã Long Phú Thuận",
        "englishName": ""
      },
      {
        "code": "30001",
        "name": "Xã Tràm Chim",
        "englishName": ""
      },
      {
        "code": "30010",
        "name": "Xã Tam Nông",
        "englishName": ""
      },
      {
        "code": "30019",
        "name": "Xã An Hòa",
        "englishName": ""
      },
      {
        "code": "30025",
        "name": "Xã Phú Cường",
        "englishName": ""
      },
      {
        "code": "30028",
        "name": "Xã An Long",
        "englishName": ""
      },
      {
        "code": "30034",
        "name": "Xã Phú Thọ",
        "englishName": ""
      },
      {
        "code": "30037",
        "name": "Xã Tháp Mười",
        "englishName": ""
      },
      {
        "code": "30043",
        "name": "Xã Phương Thịnh",
        "englishName": ""
      },
      {
        "code": "30046",
        "name": "Xã Trường Xuân",
        "englishName": ""
      },
      {
        "code": "30055",
        "name": "Xã Mỹ Quí",
        "englishName": ""
      },
      {
        "code": "30061",
        "name": "Xã Đốc Binh Kiều",
        "englishName": ""
      },
      {
        "code": "30073",
        "name": "Xã Thanh Mỹ",
        "englishName": ""
      },
      {
        "code": "30076",
        "name": "Xã Mỹ Thọ",
        "englishName": ""
      },
      {
        "code": "30085",
        "name": "Xã Ba Sao",
        "englishName": ""
      },
      {
        "code": "30088",
        "name": "Xã Phong Mỹ",
        "englishName": ""
      },
      {
        "code": "30112",
        "name": "Xã Mỹ Hiệp",
        "englishName": ""
      },
      {
        "code": "30118",
        "name": "Xã Bình Hàng Trung",
        "englishName": ""
      },
      {
        "code": "30130",
        "name": "Xã Thanh Bình",
        "englishName": ""
      },
      {
        "code": "30154",
        "name": "Xã Tân Long",
        "englishName": ""
      },
      {
        "code": "30157",
        "name": "Xã Tân Thạnh",
        "englishName": ""
      },
      {
        "code": "30163",
        "name": "Xã Bình Thành",
        "englishName": ""
      },
      {
        "code": "30169",
        "name": "Xã Lấp Vò",
        "englishName": ""
      },
      {
        "code": "30178",
        "name": "Xã Mỹ An Hưng",
        "englishName": ""
      },
      {
        "code": "30184",
        "name": "Xã Tân Khánh Trung",
        "englishName": ""
      },
      {
        "code": "30208",
        "name": "Xã Hòa Long",
        "englishName": ""
      },
      {
        "code": "30214",
        "name": "Xã Tân Dương",
        "englishName": ""
      },
      {
        "code": "30226",
        "name": "Xã Lai Vung",
        "englishName": ""
      },
      {
        "code": "30235",
        "name": "Xã Phong Hòa",
        "englishName": ""
      },
      {
        "code": "30244",
        "name": "Xã Phú Hựu",
        "englishName": ""
      },
      {
        "code": "30253",
        "name": "Xã Tân Nhuận Đông",
        "englishName": ""
      },
      {
        "code": "30259",
        "name": "Xã Tân Phú Trung",
        "englishName": ""
      }
    ]
  },
  {
    "code": "86",
    "name": "Tỉnh Vĩnh Long",
    "englishName": "",
    "administrativeLevel": "Tỉnh",
    "communes": [
      {
        "code": "28756",
        "name": "Phường Phú Khương",
        "englishName": ""
      },
      {
        "code": "28777",
        "name": "Phường An Hội",
        "englishName": ""
      },
      {
        "code": "28783",
        "name": "Phường Sơn Đông",
        "englishName": ""
      },
      {
        "code": "28789",
        "name": "Phường Bến Tre",
        "englishName": ""
      },
      {
        "code": "28807",
        "name": "Xã Giao Long",
        "englishName": ""
      },
      {
        "code": "28810",
        "name": "Xã Phú Túc",
        "englishName": ""
      },
      {
        "code": "28840",
        "name": "Xã Tân Phú",
        "englishName": ""
      },
      {
        "code": "28858",
        "name": "Phường Phú Tân",
        "englishName": ""
      },
      {
        "code": "28861",
        "name": "Xã Tiên Thủy",
        "englishName": ""
      },
      {
        "code": "28870",
        "name": "Xã Chợ Lách",
        "englishName": ""
      },
      {
        "code": "28879",
        "name": "Xã Phú Phụng",
        "englishName": ""
      },
      {
        "code": "28894",
        "name": "Xã Vĩnh Thành",
        "englishName": ""
      },
      {
        "code": "28901",
        "name": "Xã Hưng Khánh Trung",
        "englishName": ""
      },
      {
        "code": "28903",
        "name": "Xã Mỏ Cày",
        "englishName": ""
      },
      {
        "code": "28915",
        "name": "Xã Phước Mỹ Trung",
        "englishName": ""
      },
      {
        "code": "28921",
        "name": "Xã Tân Thành Bình",
        "englishName": ""
      },
      {
        "code": "28945",
        "name": "Xã Đồng Khởi",
        "englishName": ""
      },
      {
        "code": "28948",
        "name": "Xã Nhuận Phú Tân",
        "englishName": ""
      },
      {
        "code": "28957",
        "name": "Xã An Định",
        "englishName": ""
      },
      {
        "code": "28969",
        "name": "Xã Thành Thới",
        "englishName": ""
      },
      {
        "code": "28981",
        "name": "Xã Hương Mỹ",
        "englishName": ""
      },
      {
        "code": "28984",
        "name": "Xã Giồng Trôm",
        "englishName": ""
      },
      {
        "code": "28987",
        "name": "Xã Lương Hòa",
        "englishName": ""
      },
      {
        "code": "28993",
        "name": "Xã Lương Phú",
        "englishName": ""
      },
      {
        "code": "28996",
        "name": "Xã Châu Hòa",
        "englishName": ""
      },
      {
        "code": "29020",
        "name": "Xã Phước Long",
        "englishName": ""
      },
      {
        "code": "29029",
        "name": "Xã Tân Hào",
        "englishName": ""
      },
      {
        "code": "29044",
        "name": "Xã Hưng Nhượng",
        "englishName": ""
      },
      {
        "code": "29050",
        "name": "Xã Bình Đại",
        "englishName": ""
      },
      {
        "code": "29062",
        "name": "Xã Phú Thuận",
        "englishName": ""
      },
      {
        "code": "29077",
        "name": "Xã Lộc Thuận",
        "englishName": ""
      },
      {
        "code": "29083",
        "name": "Xã Châu Hưng",
        "englishName": ""
      },
      {
        "code": "29089",
        "name": "Xã Thạnh Trị",
        "englishName": ""
      },
      {
        "code": "29104",
        "name": "Xã Thạnh Phước",
        "englishName": ""
      },
      {
        "code": "29107",
        "name": "Xã Thới Thuận",
        "englishName": ""
      },
      {
        "code": "29110",
        "name": "Xã Ba Tri",
        "englishName": ""
      },
      {
        "code": "29122",
        "name": "Xã Mỹ Chánh Hòa",
        "englishName": ""
      },
      {
        "code": "29125",
        "name": "Xã Bảo Thạnh",
        "englishName": ""
      },
      {
        "code": "29137",
        "name": "Xã Tân Xuân",
        "englishName": ""
      },
      {
        "code": "29143",
        "name": "Xã An Ngãi Trung",
        "englishName": ""
      },
      {
        "code": "29158",
        "name": "Xã An Hiệp",
        "englishName": ""
      },
      {
        "code": "29167",
        "name": "Xã Tân Thủy",
        "englishName": ""
      },
      {
        "code": "29182",
        "name": "Xã Thạnh Phú",
        "englishName": ""
      },
      {
        "code": "29191",
        "name": "Xã Quới Điền",
        "englishName": ""
      },
      {
        "code": "29194",
        "name": "Xã Đại Điền",
        "englishName": ""
      },
      {
        "code": "29221",
        "name": "Xã Thạnh Hải",
        "englishName": ""
      },
      {
        "code": "29224",
        "name": "Xã An Qui",
        "englishName": ""
      },
      {
        "code": "29227",
        "name": "Xã Thạnh Phong",
        "englishName": ""
      },
      {
        "code": "29242",
        "name": "Phường Trà Vinh",
        "englishName": ""
      },
      {
        "code": "29254",
        "name": "Phường Nguyệt Hóa",
        "englishName": ""
      },
      {
        "code": "29263",
        "name": "Phường Long Đức",
        "englishName": ""
      },
      {
        "code": "29266",
        "name": "Xã Càng Long",
        "englishName": ""
      },
      {
        "code": "29275",
        "name": "Xã An Trường",
        "englishName": ""
      },
      {
        "code": "29278",
        "name": "Xã Tân An",
        "englishName": ""
      },
      {
        "code": "29287",
        "name": "Xã Bình Phú",
        "englishName": ""
      },
      {
        "code": "29302",
        "name": "Xã Nhị Long",
        "englishName": ""
      },
      {
        "code": "29308",
        "name": "Xã Cầu Kè",
        "englishName": ""
      },
      {
        "code": "29317",
        "name": "Xã An Phú Tân",
        "englishName": ""
      },
      {
        "code": "29329",
        "name": "Xã Phong Thạnh",
        "englishName": ""
      },
      {
        "code": "29335",
        "name": "Xã Tam Ngãi",
        "englishName": ""
      },
      {
        "code": "29341",
        "name": "Xã Tiểu Cần",
        "englishName": ""
      },
      {
        "code": "29362",
        "name": "Xã Hùng Hòa",
        "englishName": ""
      },
      {
        "code": "29365",
        "name": "Xã Tập Ngãi",
        "englishName": ""
      },
      {
        "code": "29371",
        "name": "Xã Tân Hòa",
        "englishName": ""
      },
      {
        "code": "29374",
        "name": "Xã Châu Thành",
        "englishName": ""
      },
      {
        "code": "29386",
        "name": "Xã Song Lộc",
        "englishName": ""
      },
      {
        "code": "29398",
        "name": "Phường Hòa Thuận",
        "englishName": ""
      },
      {
        "code": "29407",
        "name": "Xã Hưng Mỹ",
        "englishName": ""
      },
      {
        "code": "29410",
        "name": "Xã Hòa Minh",
        "englishName": ""
      },
      {
        "code": "29413",
        "name": "Xã Long Hòa",
        "englishName": ""
      },
      {
        "code": "29416",
        "name": "Xã Cầu Ngang",
        "englishName": ""
      },
      {
        "code": "29419",
        "name": "Xã Mỹ Long",
        "englishName": ""
      },
      {
        "code": "29431",
        "name": "Xã Vinh Kim",
        "englishName": ""
      },
      {
        "code": "29446",
        "name": "Xã Nhị Trường",
        "englishName": ""
      },
      {
        "code": "29455",
        "name": "Xã Hiệp Mỹ",
        "englishName": ""
      },
      {
        "code": "29461",
        "name": "Xã Trà Cú",
        "englishName": ""
      },
      {
        "code": "29467",
        "name": "Xã Tập Sơn",
        "englishName": ""
      },
      {
        "code": "29476",
        "name": "Xã Lưu Nghiệp Anh",
        "englishName": ""
      },
      {
        "code": "29489",
        "name": "Xã Hàm Giang",
        "englishName": ""
      },
      {
        "code": "29491",
        "name": "Xã Đại An",
        "englishName": ""
      },
      {
        "code": "29497",
        "name": "Xã Đôn Châu",
        "englishName": ""
      },
      {
        "code": "29506",
        "name": "Xã Long Hiệp",
        "englishName": ""
      },
      {
        "code": "29512",
        "name": "Phường Duyên Hải",
        "englishName": ""
      },
      {
        "code": "29513",
        "name": "Xã Long Thành",
        "englishName": ""
      },
      {
        "code": "29516",
        "name": "Phường Trường Long Hòa",
        "englishName": ""
      },
      {
        "code": "29518",
        "name": "Xã Long Hữu",
        "englishName": ""
      },
      {
        "code": "29530",
        "name": "Xã Ngũ Lạc",
        "englishName": ""
      },
      {
        "code": "29533",
        "name": "Xã Long Vĩnh",
        "englishName": ""
      },
      {
        "code": "29536",
        "name": "Xã Đông Hải",
        "englishName": ""
      },
      {
        "code": "29551",
        "name": "Phường Long Châu",
        "englishName": ""
      },
      {
        "code": "29557",
        "name": "Phường Phước Hậu",
        "englishName": ""
      },
      {
        "code": "29566",
        "name": "Phường Tân Ngãi",
        "englishName": ""
      },
      {
        "code": "29584",
        "name": "Xã An Bình",
        "englishName": ""
      },
      {
        "code": "29590",
        "name": "Phường Thanh Đức",
        "englishName": ""
      },
      {
        "code": "29593",
        "name": "Phường Tân Hạnh",
        "englishName": ""
      },
      {
        "code": "29602",
        "name": "Xã Long Hồ",
        "englishName": ""
      },
      {
        "code": "29611",
        "name": "Xã Phú Quới",
        "englishName": ""
      },
      {
        "code": "29623",
        "name": "Xã Nhơn Phú",
        "englishName": ""
      },
      {
        "code": "29638",
        "name": "Xã Bình Phước",
        "englishName": ""
      },
      {
        "code": "29641",
        "name": "Xã Cái Nhum",
        "englishName": ""
      },
      {
        "code": "29653",
        "name": "Xã Tân Long Hội",
        "englishName": ""
      },
      {
        "code": "29659",
        "name": "Xã Trung Thành",
        "englishName": ""
      },
      {
        "code": "29668",
        "name": "Xã Quới An",
        "englishName": ""
      },
      {
        "code": "29677",
        "name": "Xã Quới Thiện",
        "englishName": ""
      },
      {
        "code": "29683",
        "name": "Xã Trung Hiệp",
        "englishName": ""
      },
      {
        "code": "29698",
        "name": "Xã Trung Ngãi",
        "englishName": ""
      },
      {
        "code": "29701",
        "name": "Xã Hiếu Phụng",
        "englishName": ""
      },
      {
        "code": "29713",
        "name": "Xã Hiếu Thành",
        "englishName": ""
      },
      {
        "code": "29719",
        "name": "Xã Tam Bình",
        "englishName": ""
      },
      {
        "code": "29728",
        "name": "Xã Cái Ngang",
        "englishName": ""
      },
      {
        "code": "29734",
        "name": "Xã Hòa Hiệp",
        "englishName": ""
      },
      {
        "code": "29740",
        "name": "Xã Song Phú",
        "englishName": ""
      },
      {
        "code": "29767",
        "name": "Xã Ngãi Tứ",
        "englishName": ""
      },
      {
        "code": "29770",
        "name": "Phường Cái Vồn",
        "englishName": ""
      },
      {
        "code": "29771",
        "name": "Phường Bình Minh",
        "englishName": ""
      },
      {
        "code": "29785",
        "name": "Xã Tân Lược",
        "englishName": ""
      },
      {
        "code": "29788",
        "name": "Xã Mỹ Thuận",
        "englishName": ""
      },
      {
        "code": "29800",
        "name": "Xã Tân Quới",
        "englishName": ""
      },
      {
        "code": "29812",
        "name": "Phường Đông Thành",
        "englishName": ""
      },
      {
        "code": "29821",
        "name": "Xã Trà Ôn",
        "englishName": ""
      },
      {
        "code": "29830",
        "name": "Xã Hòa Bình",
        "englishName": ""
      },
      {
        "code": "29836",
        "name": "Xã Trà Côn",
        "englishName": ""
      },
      {
        "code": "29845",
        "name": "Xã Vĩnh Xuân",
        "englishName": ""
      },
      {
        "code": "29857",
        "name": "Xã Lục Sĩ Thành",
        "englishName": ""
      }
    ]
  },
  {
    "code": "91",
    "name": "Tỉnh An Giang",
    "englishName": "",
    "administrativeLevel": "Tỉnh",
    "communes": [
      {
        "code": "30292",
        "name": "Phường Bình Đức",
        "englishName": ""
      },
      {
        "code": "30301",
        "name": "Phường Mỹ Thới",
        "englishName": ""
      },
      {
        "code": "30307",
        "name": "Phường Long Xuyên",
        "englishName": "My Hoa Ward"
      },
      {
        "code": "30313",
        "name": "Xã Mỹ Hòa Hưng",
        "englishName": ""
      },
      {
        "code": "30316",
        "name": "Phường Châu Đốc",
        "englishName": ""
      },
      {
        "code": "30325",
        "name": "Phường Vĩnh Tế",
        "englishName": ""
      },
      {
        "code": "30337",
        "name": "Xã An Phú",
        "englishName": ""
      },
      {
        "code": "30341",
        "name": "Xã Khánh Bình",
        "englishName": ""
      },
      {
        "code": "30346",
        "name": "Xã Nhơn Hội",
        "englishName": ""
      },
      {
        "code": "30352",
        "name": "Xã Phú Hữu",
        "englishName": ""
      },
      {
        "code": "30367",
        "name": "Xã Vĩnh Hậu",
        "englishName": ""
      },
      {
        "code": "30376",
        "name": "Phường Tân Châu",
        "englishName": ""
      },
      {
        "code": "30377",
        "name": "Phường Long Phú",
        "englishName": ""
      },
      {
        "code": "30385",
        "name": "Xã Vĩnh Xương",
        "englishName": ""
      },
      {
        "code": "30388",
        "name": "Xã Tân An",
        "englishName": ""
      },
      {
        "code": "30403",
        "name": "Xã Châu Phong",
        "englishName": ""
      },
      {
        "code": "30406",
        "name": "Xã Phú Tân",
        "englishName": ""
      },
      {
        "code": "30409",
        "name": "Xã Chợ Vàm",
        "englishName": ""
      },
      {
        "code": "30421",
        "name": "Xã Phú Lâm",
        "englishName": ""
      },
      {
        "code": "30430",
        "name": "Xã Hòa Lạc",
        "englishName": ""
      },
      {
        "code": "30436",
        "name": "Xã Phú An",
        "englishName": ""
      },
      {
        "code": "30445",
        "name": "Xã Bình Thạnh Đông",
        "englishName": ""
      },
      {
        "code": "30463",
        "name": "Xã Châu Phú",
        "englishName": ""
      },
      {
        "code": "30469",
        "name": "Xã Mỹ Đức",
        "englishName": ""
      },
      {
        "code": "30478",
        "name": "Xã Vĩnh Thạnh Trung",
        "englishName": ""
      },
      {
        "code": "30481",
        "name": "Xã Thạnh Mỹ Tây",
        "englishName": ""
      },
      {
        "code": "30487",
        "name": "Xã Bình Mỹ",
        "englishName": ""
      },
      {
        "code": "30502",
        "name": "Phường Thới Sơn",
        "englishName": ""
      },
      {
        "code": "30505",
        "name": "Phường Chi Lăng",
        "englishName": ""
      },
      {
        "code": "30520",
        "name": "Phường Tịnh Biên",
        "englishName": ""
      },
      {
        "code": "30526",
        "name": "Xã An Cư",
        "englishName": ""
      },
      {
        "code": "30538",
        "name": "Xã Núi Cấm",
        "englishName": ""
      },
      {
        "code": "30544",
        "name": "Xã Tri Tôn",
        "englishName": ""
      },
      {
        "code": "30547",
        "name": "Xã Ba Chúc",
        "englishName": ""
      },
      {
        "code": "30568",
        "name": "Xã Vĩnh Gia",
        "englishName": ""
      },
      {
        "code": "30577",
        "name": "Xã Ô Lâm",
        "englishName": ""
      },
      {
        "code": "30580",
        "name": "Xã Cô Tô",
        "englishName": ""
      },
      {
        "code": "30589",
        "name": "Xã An Châu",
        "englishName": ""
      },
      {
        "code": "30595",
        "name": "Xã Cần Đăng",
        "englishName": ""
      },
      {
        "code": "30604",
        "name": "Xã Vĩnh An",
        "englishName": ""
      },
      {
        "code": "30607",
        "name": "Xã Bình Hòa",
        "englishName": ""
      },
      {
        "code": "30619",
        "name": "Xã Vĩnh Hanh",
        "englishName": ""
      },
      {
        "code": "30628",
        "name": "Xã Chợ Mới",
        "englishName": ""
      },
      {
        "code": "30631",
        "name": "Xã Long Điền",
        "englishName": ""
      },
      {
        "code": "30643",
        "name": "Xã Cù Lao Giêng",
        "englishName": ""
      },
      {
        "code": "30658",
        "name": "Xã Nhơn Mỹ",
        "englishName": ""
      },
      {
        "code": "30664",
        "name": "Xã Long Kiến",
        "englishName": ""
      },
      {
        "code": "30673",
        "name": "Xã Hội An",
        "englishName": ""
      },
      {
        "code": "30682",
        "name": "Xã Thoại Sơn",
        "englishName": ""
      },
      {
        "code": "30685",
        "name": "Xã Phú Hòa",
        "englishName": ""
      },
      {
        "code": "30688",
        "name": "Xã Óc Eo",
        "englishName": ""
      },
      {
        "code": "30691",
        "name": "Xã Tây Phú",
        "englishName": ""
      },
      {
        "code": "30697",
        "name": "Xã Vĩnh Trạch",
        "englishName": ""
      },
      {
        "code": "30709",
        "name": "Xã Định Mỹ",
        "englishName": ""
      },
      {
        "code": "30742",
        "name": "Phường Rạch Giá",
        "englishName": ""
      },
      {
        "code": "30760",
        "name": "Phường Vĩnh Thông",
        "englishName": ""
      },
      {
        "code": "30766",
        "name": "Phường Tô Châu",
        "englishName": ""
      },
      {
        "code": "30769",
        "name": "Phường Hà Tiên",
        "englishName": ""
      },
      {
        "code": "30781",
        "name": "Xã Tiên Hải",
        "englishName": ""
      },
      {
        "code": "30787",
        "name": "Xã Kiên Lương",
        "englishName": ""
      },
      {
        "code": "30790",
        "name": "Xã Hòa Điền",
        "englishName": ""
      },
      {
        "code": "30793",
        "name": "Xã Vĩnh Điều",
        "englishName": ""
      },
      {
        "code": "30796",
        "name": "Xã Giang Thành",
        "englishName": ""
      },
      {
        "code": "30811",
        "name": "Xã Sơn Hải",
        "englishName": ""
      },
      {
        "code": "30814",
        "name": "Xã Hòn Nghệ",
        "englishName": ""
      },
      {
        "code": "30817",
        "name": "Xã Hòn Đất",
        "englishName": ""
      },
      {
        "code": "30823",
        "name": "Xã Bình Sơn",
        "englishName": ""
      },
      {
        "code": "30826",
        "name": "Xã Bình Giang",
        "englishName": ""
      },
      {
        "code": "30835",
        "name": "Xã Sơn Kiên",
        "englishName": ""
      },
      {
        "code": "30838",
        "name": "Xã Mỹ Thuận",
        "englishName": ""
      },
      {
        "code": "30850",
        "name": "Xã Tân Hiệp",
        "englishName": ""
      },
      {
        "code": "30856",
        "name": "Xã Tân Hội",
        "englishName": ""
      },
      {
        "code": "30874",
        "name": "Xã Thạnh Đông",
        "englishName": ""
      },
      {
        "code": "30880",
        "name": "Xã Châu Thành",
        "englishName": ""
      },
      {
        "code": "30886",
        "name": "Xã Thạnh Lộc",
        "englishName": ""
      },
      {
        "code": "30898",
        "name": "Xã Bình An",
        "englishName": ""
      },
      {
        "code": "30904",
        "name": "Xã Giồng Riềng",
        "englishName": ""
      },
      {
        "code": "30910",
        "name": "Xã Thạnh Hưng",
        "englishName": ""
      },
      {
        "code": "30928",
        "name": "Xã Ngọc Chúc",
        "englishName": ""
      },
      {
        "code": "30934",
        "name": "Xã Hòa Hưng",
        "englishName": ""
      },
      {
        "code": "30943",
        "name": "Xã Long Thạnh",
        "englishName": ""
      },
      {
        "code": "30949",
        "name": "Xã Hòa Thuận",
        "englishName": ""
      },
      {
        "code": "30952",
        "name": "Xã Gò Quao",
        "englishName": ""
      },
      {
        "code": "30958",
        "name": "Xã Định Hòa",
        "englishName": ""
      },
      {
        "code": "30970",
        "name": "Xã Vĩnh Hòa Hưng",
        "englishName": ""
      },
      {
        "code": "30982",
        "name": "Xã Vĩnh Tuy",
        "englishName": ""
      },
      {
        "code": "30985",
        "name": "Xã An Biên",
        "englishName": ""
      },
      {
        "code": "30988",
        "name": "Xã Tây Yên",
        "englishName": ""
      },
      {
        "code": "31006",
        "name": "Xã Đông Thái",
        "englishName": ""
      },
      {
        "code": "31012",
        "name": "Xã Vĩnh Hòa",
        "englishName": ""
      },
      {
        "code": "31018",
        "name": "Xã An Minh",
        "englishName": ""
      },
      {
        "code": "31024",
        "name": "Xã Đông Hòa",
        "englishName": ""
      },
      {
        "code": "31027",
        "name": "Xã U Minh Thượng",
        "englishName": ""
      },
      {
        "code": "31031",
        "name": "Xã Tân Thạnh",
        "englishName": "Tan Thanh commune"
      },
      {
        "code": "31036",
        "name": "Xã Đông Hưng",
        "englishName": ""
      },
      {
        "code": "31042",
        "name": "Xã Vân Khánh",
        "englishName": ""
      },
      {
        "code": "31051",
        "name": "Xã Vĩnh Phong",
        "englishName": ""
      },
      {
        "code": "31064",
        "name": "Xã Vĩnh Bình",
        "englishName": ""
      },
      {
        "code": "31069",
        "name": "Xã Vĩnh Thuận",
        "englishName": ""
      },
      {
        "code": "31078",
        "name": "Đặc khu Phú Quốc",
        "englishName": ""
      },
      {
        "code": "31105",
        "name": "Đặc khu Thổ Châu",
        "englishName": ""
      },
      {
        "code": "31108",
        "name": "Đặc khu Kiên Hải",
        "englishName": ""
      }
    ]
  },
  {
    "code": "92",
    "name": "Thành phố Cần Thơ",
    "englishName": "",
    "administrativeLevel": "Thành phố Trung ương",
    "communes": [
      {
        "code": "31120",
        "name": "Phường Cái Khế",
        "englishName": ""
      },
      {
        "code": "31135",
        "name": "Phường Ninh Kiều",
        "englishName": ""
      },
      {
        "code": "31147",
        "name": "Phường Tân An",
        "englishName": ""
      },
      {
        "code": "31150",
        "name": "Phường An Bình",
        "englishName": ""
      },
      {
        "code": "31153",
        "name": "Phường Ô Môn",
        "englishName": ""
      },
      {
        "code": "31157",
        "name": "Phường Thới Long",
        "englishName": ""
      },
      {
        "code": "31162",
        "name": "Phường Phước Thới",
        "englishName": ""
      },
      {
        "code": "31168",
        "name": "Phường Bình Thủy",
        "englishName": ""
      },
      {
        "code": "31174",
        "name": "Phường Thới An Đông",
        "englishName": ""
      },
      {
        "code": "31183",
        "name": "Phường Long Tuyền",
        "englishName": ""
      },
      {
        "code": "31186",
        "name": "Phường Cái Răng",
        "englishName": ""
      },
      {
        "code": "31201",
        "name": "Phường Hưng Phú",
        "englishName": ""
      },
      {
        "code": "31207",
        "name": "Phường Thốt Nốt",
        "englishName": ""
      },
      {
        "code": "31213",
        "name": "Phường Tân Lộc",
        "englishName": ""
      },
      {
        "code": "31217",
        "name": "Phường Trung Nhứt",
        "englishName": ""
      },
      {
        "code": "31228",
        "name": "Phường Thuận Hưng",
        "englishName": ""
      },
      {
        "code": "31231",
        "name": "Xã Thạnh An",
        "englishName": ""
      },
      {
        "code": "31232",
        "name": "Xã Vĩnh Thạnh",
        "englishName": ""
      },
      {
        "code": "31237",
        "name": "Xã Vĩnh Trinh",
        "englishName": ""
      },
      {
        "code": "31246",
        "name": "Xã Thạnh Quới",
        "englishName": ""
      },
      {
        "code": "31249",
        "name": "Xã Thạnh Phú",
        "englishName": ""
      },
      {
        "code": "31255",
        "name": "Xã Trung Hưng",
        "englishName": ""
      },
      {
        "code": "31258",
        "name": "Xã Thới Lai",
        "englishName": ""
      },
      {
        "code": "31261",
        "name": "Xã Cờ Đỏ",
        "englishName": ""
      },
      {
        "code": "31264",
        "name": "Xã Thới Hưng",
        "englishName": ""
      },
      {
        "code": "31273",
        "name": "Xã Đông Hiệp",
        "englishName": ""
      },
      {
        "code": "31282",
        "name": "Xã Đông Thuận",
        "englishName": ""
      },
      {
        "code": "31288",
        "name": "Xã Trường Thành",
        "englishName": ""
      },
      {
        "code": "31294",
        "name": "Xã Trường Xuân",
        "englishName": ""
      },
      {
        "code": "31299",
        "name": "Xã Phong Điền",
        "englishName": ""
      },
      {
        "code": "31309",
        "name": "Xã Trường Long",
        "englishName": ""
      },
      {
        "code": "31315",
        "name": "Xã Nhơn Ái",
        "englishName": ""
      },
      {
        "code": "31321",
        "name": "Phường Vị Thanh",
        "englishName": ""
      },
      {
        "code": "31333",
        "name": "Phường Vị Tân",
        "englishName": ""
      },
      {
        "code": "31338",
        "name": "Xã Hỏa Lựu",
        "englishName": "Tân Tiến Commune"
      },
      {
        "code": "31340",
        "name": "Phường Ngã Bảy",
        "englishName": "Nga Bay precinct"
      },
      {
        "code": "31342",
        "name": "Xã Tân Hòa",
        "englishName": ""
      },
      {
        "code": "31348",
        "name": "Xã Trường Long Tây",
        "englishName": ""
      },
      {
        "code": "31360",
        "name": "Xã Thạnh Xuân",
        "englishName": ""
      },
      {
        "code": "31366",
        "name": "Xã Châu Thành",
        "englishName": ""
      },
      {
        "code": "31369",
        "name": "Xã Đông Phước",
        "englishName": ""
      },
      {
        "code": "31378",
        "name": "Xã Phú Hữu",
        "englishName": ""
      },
      {
        "code": "31393",
        "name": "Xã Hòa An",
        "englishName": ""
      },
      {
        "code": "31396",
        "name": "Xã Hiệp Hưng",
        "englishName": ""
      },
      {
        "code": "31399",
        "name": "Xã Tân Bình",
        "englishName": ""
      },
      {
        "code": "31408",
        "name": "Xã Thạnh Hòa",
        "englishName": ""
      },
      {
        "code": "31411",
        "name": "Phường Đại Thành",
        "englishName": ""
      },
      {
        "code": "31420",
        "name": "Xã Phụng Hiệp",
        "englishName": ""
      },
      {
        "code": "31426",
        "name": "Xã Phương Bình",
        "englishName": ""
      },
      {
        "code": "31432",
        "name": "Xã Tân Phước Hưng",
        "englishName": ""
      },
      {
        "code": "31441",
        "name": "Xã Vị Thủy",
        "englishName": ""
      },
      {
        "code": "31453",
        "name": "Xã Vĩnh Thuận Đông",
        "englishName": ""
      },
      {
        "code": "31459",
        "name": "Xã  Vĩnh Tường",
        "englishName": ""
      },
      {
        "code": "31465",
        "name": "Xã Vị Thanh 1",
        "englishName": ""
      },
      {
        "code": "31471",
        "name": "Phường Long Mỹ",
        "englishName": ""
      },
      {
        "code": "31473",
        "name": "Phường Long Bình",
        "englishName": ""
      },
      {
        "code": "31480",
        "name": "Phường Long Phú 1",
        "englishName": ""
      },
      {
        "code": "31489",
        "name": "Xã Vĩnh Viễn",
        "englishName": ""
      },
      {
        "code": "31492",
        "name": "Xã Lương Tâm",
        "englishName": ""
      },
      {
        "code": "31495",
        "name": "Xã Xà Phiên",
        "englishName": ""
      },
      {
        "code": "31507",
        "name": "Phường Sóc Trăng",
        "englishName": ""
      },
      {
        "code": "31510",
        "name": "Phường Phú Lợi",
        "englishName": ""
      },
      {
        "code": "31528",
        "name": "Xã Kế Sách",
        "englishName": ""
      },
      {
        "code": "31531",
        "name": "Xã An Lạc Thôn",
        "englishName": ""
      },
      {
        "code": "31537",
        "name": "Xã Phong Nẫm",
        "englishName": ""
      },
      {
        "code": "31540",
        "name": "Xã Thới An Hội",
        "englishName": ""
      },
      {
        "code": "31552",
        "name": "Xã Nhơn Mỹ",
        "englishName": ""
      },
      {
        "code": "31561",
        "name": "Xã Đại Hải",
        "englishName": ""
      },
      {
        "code": "31567",
        "name": "Xã Mỹ Tú",
        "englishName": ""
      },
      {
        "code": "31569",
        "name": "Xã Phú Tâm",
        "englishName": ""
      },
      {
        "code": "31570",
        "name": "Xã Hồ Đắc Kiện",
        "englishName": ""
      },
      {
        "code": "31579",
        "name": "Xã Long Hưng",
        "englishName": ""
      },
      {
        "code": "31582",
        "name": "Xã Thuận Hòa",
        "englishName": ""
      },
      {
        "code": "31591",
        "name": "Xã Mỹ Hương",
        "englishName": ""
      },
      {
        "code": "31594",
        "name": "Xã An Ninh",
        "englishName": ""
      },
      {
        "code": "31603",
        "name": "Xã Mỹ Phước",
        "englishName": ""
      },
      {
        "code": "31615",
        "name": "Xã An Thạnh",
        "englishName": ""
      },
      {
        "code": "31633",
        "name": "Xã Cù Lao Dung",
        "englishName": ""
      },
      {
        "code": "31639",
        "name": "Xã Long Phú",
        "englishName": ""
      },
      {
        "code": "31645",
        "name": "Xã Đại Ngãi",
        "englishName": ""
      },
      {
        "code": "31654",
        "name": "Xã Trường Khánh",
        "englishName": ""
      },
      {
        "code": "31666",
        "name": "Xã Tân Thạnh",
        "englishName": ""
      },
      {
        "code": "31673",
        "name": "Xã Trần Đề",
        "englishName": ""
      },
      {
        "code": "31675",
        "name": "Xã Liêu Tú",
        "englishName": ""
      },
      {
        "code": "31679",
        "name": "Xã Lịch Hội Thượng",
        "englishName": ""
      },
      {
        "code": "31684",
        "name": "Phường Mỹ Xuyên",
        "englishName": ""
      },
      {
        "code": "31687",
        "name": "Xã Tài Văn",
        "englishName": ""
      },
      {
        "code": "31699",
        "name": "Xã Thạnh Thới An",
        "englishName": ""
      },
      {
        "code": "31708",
        "name": "Xã Nhu Gia",
        "englishName": ""
      },
      {
        "code": "31717",
        "name": "Xã Hòa Tú",
        "englishName": ""
      },
      {
        "code": "31723",
        "name": "Xã Ngọc Tố",
        "englishName": ""
      },
      {
        "code": "31726",
        "name": "Xã Gia Hòa",
        "englishName": ""
      },
      {
        "code": "31732",
        "name": "Phường Ngã Năm",
        "englishName": ""
      },
      {
        "code": "31741",
        "name": "Xã Tân Long",
        "englishName": ""
      },
      {
        "code": "31753",
        "name": "Phường Mỹ Quới",
        "englishName": ""
      },
      {
        "code": "31756",
        "name": "Xã Phú Lộc",
        "englishName": ""
      },
      {
        "code": "31759",
        "name": "Xã Lâm Tân",
        "englishName": ""
      },
      {
        "code": "31777",
        "name": "Xã Vĩnh Lợi",
        "englishName": ""
      },
      {
        "code": "31783",
        "name": "Phường Vĩnh Châu",
        "englishName": ""
      },
      {
        "code": "31789",
        "name": "Phường Khánh Hòa",
        "englishName": ""
      },
      {
        "code": "31795",
        "name": "Xã Vĩnh Hải",
        "englishName": ""
      },
      {
        "code": "31804",
        "name": "Phường Vĩnh Phước",
        "englishName": ""
      },
      {
        "code": "31810",
        "name": "Xã Lai Hòa",
        "englishName": ""
      }
    ]
  },
  {
    "code": "96",
    "name": "Tỉnh Cà Mau",
    "englishName": "",
    "administrativeLevel": "Tỉnh",
    "communes": [
      {
        "code": "31825",
        "name": "Phường Bạc Liêu",
        "englishName": ""
      },
      {
        "code": "31834",
        "name": "Phường Vĩnh Trạch",
        "englishName": ""
      },
      {
        "code": "31840",
        "name": "Phường Hiệp Thành",
        "englishName": ""
      },
      {
        "code": "31843",
        "name": "Xã Hồng Dân",
        "englishName": ""
      },
      {
        "code": "31849",
        "name": "Xã Ninh Quới",
        "englishName": ""
      },
      {
        "code": "31858",
        "name": "Xã Vĩnh Lộc",
        "englishName": ""
      },
      {
        "code": "31864",
        "name": "Xã Ninh Thạnh Lợi",
        "englishName": ""
      },
      {
        "code": "31867",
        "name": "Xã Phước Long",
        "englishName": ""
      },
      {
        "code": "31876",
        "name": "Xã Vĩnh Phước",
        "englishName": ""
      },
      {
        "code": "31882",
        "name": "Xã Vĩnh Thanh",
        "englishName": ""
      },
      {
        "code": "31885",
        "name": "Xã Phong Hiệp",
        "englishName": ""
      },
      {
        "code": "31891",
        "name": "Xã Hòa Bình",
        "englishName": ""
      },
      {
        "code": "31894",
        "name": "Xã Châu Thới",
        "englishName": ""
      },
      {
        "code": "31900",
        "name": "Xã Vĩnh Lợi",
        "englishName": ""
      },
      {
        "code": "31906",
        "name": "Xã Hưng Hội",
        "englishName": ""
      },
      {
        "code": "31918",
        "name": "Xã Vĩnh Mỹ",
        "englishName": ""
      },
      {
        "code": "31927",
        "name": "Xã Vĩnh Hậu",
        "englishName": ""
      },
      {
        "code": "31942",
        "name": "Phường Giá Rai",
        "englishName": ""
      },
      {
        "code": "31951",
        "name": "Phường Láng Tròn",
        "englishName": ""
      },
      {
        "code": "31957",
        "name": "Xã Phong Thạnh",
        "englishName": ""
      },
      {
        "code": "31972",
        "name": "Xã Gành Hào",
        "englishName": ""
      },
      {
        "code": "31975",
        "name": "Xã Đông Hải",
        "englishName": ""
      },
      {
        "code": "31985",
        "name": "Xã Long Điền",
        "englishName": ""
      },
      {
        "code": "31988",
        "name": "Xã An Trạch",
        "englishName": ""
      },
      {
        "code": "31993",
        "name": "Xã Định Thành",
        "englishName": ""
      },
      {
        "code": "32002",
        "name": "Phường An Xuyên",
        "englishName": ""
      },
      {
        "code": "32014",
        "name": "Phường Lý Văn Lâm",
        "englishName": ""
      },
      {
        "code": "32025",
        "name": "Phường Tân Thành",
        "englishName": ""
      },
      {
        "code": "32041",
        "name": "Phường Hòa Thành",
        "englishName": ""
      },
      {
        "code": "32044",
        "name": "Xã Nguyễn Phích",
        "englishName": ""
      },
      {
        "code": "32047",
        "name": "Xã U Minh",
        "englishName": ""
      },
      {
        "code": "32059",
        "name": "Xã Khánh An",
        "englishName": ""
      },
      {
        "code": "32062",
        "name": "Xã Khánh Lâm",
        "englishName": ""
      },
      {
        "code": "32065",
        "name": "Xã Thới Bình",
        "englishName": ""
      },
      {
        "code": "32069",
        "name": "Xã Biển Bạch",
        "englishName": "Tan Bang commune"
      },
      {
        "code": "32071",
        "name": "Xã Trí Phải",
        "englishName": ""
      },
      {
        "code": "32083",
        "name": "Xã Tân Lộc",
        "englishName": ""
      },
      {
        "code": "32092",
        "name": "Xã Hồ Thị Kỷ",
        "englishName": ""
      },
      {
        "code": "32095",
        "name": "Xã Trần Văn Thời",
        "englishName": ""
      },
      {
        "code": "32098",
        "name": "Xã Sông Đốc",
        "englishName": ""
      },
      {
        "code": "32104",
        "name": "Xã Đá Bạc",
        "englishName": ""
      },
      {
        "code": "32110",
        "name": "Xã Khánh Bình",
        "englishName": ""
      },
      {
        "code": "32119",
        "name": "Xã Khánh Hưng",
        "englishName": ""
      },
      {
        "code": "32128",
        "name": "Xã Cái Nước",
        "englishName": ""
      },
      {
        "code": "32134",
        "name": "Xã Lương Thế Trân",
        "englishName": ""
      },
      {
        "code": "32137",
        "name": "Xã Tân Hưng",
        "englishName": ""
      },
      {
        "code": "32140",
        "name": "Xã Hưng Mỹ",
        "englishName": ""
      },
      {
        "code": "32152",
        "name": "Xã Đầm Dơi",
        "englishName": ""
      },
      {
        "code": "32155",
        "name": "Xã Tạ An Khương",
        "englishName": ""
      },
      {
        "code": "32161",
        "name": "Xã Trần Phán",
        "englishName": ""
      },
      {
        "code": "32167",
        "name": "Xã Tân Thuận",
        "englishName": ""
      },
      {
        "code": "32182",
        "name": "Xã Quách Phẩm",
        "englishName": ""
      },
      {
        "code": "32185",
        "name": "Xã Thanh Tùng",
        "englishName": ""
      },
      {
        "code": "32188",
        "name": "Xã Tân Tiến",
        "englishName": ""
      },
      {
        "code": "32191",
        "name": "Xã Năm Căn",
        "englishName": ""
      },
      {
        "code": "32201",
        "name": "Xã Đất Mới",
        "englishName": "Lam Hai commune"
      },
      {
        "code": "32206",
        "name": "Xã Tam Giang",
        "englishName": ""
      },
      {
        "code": "32212",
        "name": "Xã Cái Đôi Vàm",
        "englishName": ""
      },
      {
        "code": "32214",
        "name": "Xã Phú Mỹ",
        "englishName": "Phu Thuan Commune"
      },
      {
        "code": "32218",
        "name": "Xã Phú Tân",
        "englishName": ""
      },
      {
        "code": "32227",
        "name": "Xã Nguyễn Việt Khái",
        "englishName": ""
      },
      {
        "code": "32236",
        "name": "Xã Tân Ân",
        "englishName": ""
      },
      {
        "code": "32244",
        "name": "Xã Phan Ngọc Hiển",
        "englishName": ""
      },
      {
        "code": "32248",
        "name": "Xã Đất Mũi",
        "englishName": ""
      }
    ]
  }
];

/**
 * Get province by code
 */
function getProvinceByCode(code) {
  return vietnamAddressData.find(p => p.code === code);
}

/**
 * Get province by name (supports full name matching)
 */
function getProvinceByName(name) {
  // Normalize name for comparison (remove "Thành phố", "Tỉnh" prefix)
  const normalizeName = (str) => {
    return str
      .replace(/^(Thành phố|Tỉnh)\s+/, '')
      .toLowerCase()
      .trim();
  };

  const searchName = normalizeName(name);

  return vietnamAddressData.find(p => {
    const provinceName = normalizeName(p.name);
    return provinceName === searchName || p.name === name;
  });
}

/**
 * Get all provinces (for dropdown)
 */
function getAllProvinces() {
  return vietnamAddressData.map(p => ({
    code: p.code,
    name: p.name
  }));
}

/**
 * Get communes for a province (by name or code)
 */
function getCommunesForProvince(provinceNameOrCode) {
  const province = getProvinceByName(provinceNameOrCode) || getProvinceByCode(provinceNameOrCode);
  return (province && province.communes) || [];
}

module.exports = {
  vietnamAddressData,
  getProvinceByCode,
  getProvinceByName,
  getAllProvinces,
  getCommunesForProvince
};
